<template>
  <div class="mb-0" v-if="getRealTime" style="height: 80%">
    <svg
      xmlns:xlink="http://www.w3.org/1999/xlink"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 1639 816"
      style="enable-background: new 0 0 1639 816"
      xml:space="preserve"
    >
      <g>
        <g>
          <g>
            <path
              class="st0"
              d="M308.9,482.3l-4.6-2.4h-4.2H296l-4.6,2.4c-0.2,0.1-0.1,0.4,0.1,0.4h8.7h8.7     C309.1,482.7,309.2,482.4,308.9,482.3"
            />
            <g>
              <rect
                x="293.1"
                y="419.5"
                class="st1"
                width="11.5"
                height="14.7"
              />
              <path
                class="st2"
                d="M306,434.2h-14.3c-1.1,0-2,0.9-2,2v3.1H308v-3.1C308,435.1,307.1,434.2,306,434.2"
              />
              <rect x="291.5" y="422" class="st3" width="14.7" height="2.6" />
              <rect x="291.5" y="426.5" class="st3" width="14.7" height="2.6" />
              <rect x="291.5" y="430.9" class="st3" width="14.7" height="2.6" />
            </g>
            <g>
              <path
                class="st0"
                d="M343.7,492.3l-10.1-3h-17.7h-17l-10.8,3c-0.7,0.1-0.4,0.5,0.3,0.5h27.5h27.5      C344.1,492.8,344.3,492.4,343.7,492.3"
              />
              <path
                class="st4"
                d="M298.9,439.3h36.3c3.3,0,6,2.7,6,6v38c0,3.3-2.7,6-6,6h-36.3V439.3z"
              />
              <rect x="308" y="483" class="st3" width="20.3" height="6.2" />
              <path
                class="st5"
                d="M294.6,447.5h-28.8c-0.3,0.9-0.6,1.8-0.7,2.7h29.6V447.5z"
              />
              <polygon
                class="st5"
                points="294.6,452.4 264.8,452.4 264.5,455.1 294.6,455.1     "
              />
              <polygon
                class="st5"
                points="294.6,457.3 264.2,457.3 263.9,460 294.6,460     "
              />
              <polygon
                class="st5"
                points="294.6,462.2 263.7,462.2 263.4,464.9 294.6,464.9     "
              />
              <polygon
                class="st5"
                points="294.6,467.1 263.1,467.1 262.8,469.8 294.6,469.8     "
              />
              <polygon
                class="st5"
                points="294.6,472 262.6,472 262.2,474.7 294.6,474.7     "
              />
              <polygon
                class="st5"
                points="294.6,476.9 262,476.9 261.7,479.6 294.6,479.6     "
              />
              <path
                class="st5"
                d="M294.6,481.7h-33.2l0,0.3c-0.1,0.9,0,1.7,0.2,2.5h33V481.7z"
              />
              <path
                class="st3"
                d="M277.7,439.3c-5.4,0-10,3.4-11.9,8.2h28.8v2.7h-29.6c0,0.1,0,0.2-0.1,0.3l-0.2,1.8h29.8v2.7h-30.1l-0.2,2.1      h30.4v2.7h-30.7l-0.2,2.1h30.9v2.7h-31.3l-0.2,2.1h31.5v2.7h-31.8l-0.2,2.1h32.1v2.7h-32.4l-0.2,2.1h32.6v2.7h-32.9l-0.2,2.1      h33.2v2.7h-33c0.8,2.7,3.2,4.8,6.3,4.8h31v-49.9H277.7z"
              />
              <line class="st6" x1="332.8" y1="439.3" x2="332.8" y2="489.2" />
            </g>
          </g>
          <g>
            <g>
              <rect x="187.7" y="382.1" class="st7" width="22.4" height="4.3" />
              <rect x="187.7" y="386.4" class="st0" width="22.4" height="1.5" />
              <polygon
                class="st7"
                points="210.1,389.9 187.7,392.6 187.7,387.9 210.1,387.9     "
              />
              <polygon
                class="st7"
                points="187.7,370.1 210.1,372.7 210.1,374.7 187.7,374.7     "
              />
              <rect x="187.7" y="376.2" class="st7" width="22.4" height="4.3" />
              <rect x="187.7" y="374.7" class="st0" width="22.4" height="1.5" />
              <polygon
                class="st0"
                points="210.1,381.3 210.1,382.1 187.7,382.1 187.7,380.5 210.1,380.5     "
              />
            </g>
            <path
              :class="
                getRealTime.Valve[16].On ||
                getRealTime.Valve[17].On ||
                getRealTime.Valve[18].On ||
                getRealTime.Valve[0].On
                  ? 'st30'
                  : 'st8'
              "
              d="M302.6,419.5h-7.7v-31.8c0-1.4-1.2-2.6-2.6-2.6h-82.2v-7.7h82.2c5.7,0,10.3,4.6,10.3,10.3V419.5z"
            />
            <g>
              <rect
                x="232.6"
                y="431.7"
                class="st9"
                width="13.8"
                height="56.7"
              />
              <path
                class="st2"
                d="M227.2,431.7v50.6c0,3.3,1.8,6,4,6h1.4v-56.7H227.2z"
              />
              <path
                class="st2"
                d="M246.4,431.7v56.7h2.2c2.2,0,4-2.7,4-6v-50.6H246.4z"
              />
              <path
                class="st0"
                d="M258.1,493.4l-9.5-5h-8.7h-8.7l-9.5,5c-0.4,0.2-0.3,0.9,0.2,0.9h18h18C258.4,494.3,258.6,493.6,258.1,493.4      "
              />
              <path
                class="st10"
                d="M221.4,405.3h-26.1l1.2,17.6c0.1,1,0.1,2,0.1,3h24.9V405.3z"
              />
              <rect
                x="221.4"
                y="399.2"
                class="st11"
                width="36.8"
                height="32.7"
              />
            </g>
            <g>
              <path
                class="st12"
                d="M184.6,285l-6.2-80.3h-32.5l4.2,84.5C150,289.2,166.5,278.3,184.6,285"
              />
              <path
                class="st13"
                d="M52.1,285.2l4-80.5H38L31.8,285C37.3,284.7,44.5,284.5,52.1,285.2"
              />
              <path
                class="st14"
                d="M80.6,292.8c26,13.8,69.5-3.6,69.5-3.6l-4.2-84.5H56.1l-4,80.5C61.6,286,71.8,288.2,80.6,292.8"
              />
              <path
                class="st15"
                d="M56.1,204.5l0,0.2h89.8l0-0.2c-1-20-11.7-35.5-24.5-35.5h-13.2H101H80.6C67.7,169,57.1,184.5,56.1,204.5"
              />
              <path
                class="st16"
                d="M145.8,204.5l0,0.2h32.5l0-0.2c-1.5-20-18.2-35.5-38.3-35.5h-18.7C134.2,169,144.9,184.5,145.8,204.5"
              />
              <path
                class="st17"
                d="M56.1,204.5c1-20,11.7-35.5,24.5-35.5h-4.3c-20.1,0-36.8,15.4-38.3,35.5l0,0.2h18.1L56.1,204.5z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M99.3,481.6l-9.5-5H81h-8.7l-9.5,5c-0.4,0.2-0.3,0.9,0.2,0.9h18h18C99.6,482.5,99.7,481.8,99.3,481.6"
              />
              <path
                class="st9"
                d="M90.6,476.6H71.4c-1.7,0-3.1-1.4-3.1-3.1v-16.3h25.4v16.3C93.7,475.2,92.3,476.6,90.6,476.6"
              />
            </g>
            <g>
              <path
                class="st18"
                d="M39.1,422.8l1.6-33.4H20.7l-2.3,33.4c-1.3,18.6,13.5,34.3,32.1,34.3h10.7      C48.4,457.2,38.3,441.4,39.1,422.8"
              />
              <path
                class="st1"
                d="M196.5,422.8l-1.2-17.6l-1.1-15.9h-33.7l1.6,33.4c0.9,18.6-9.3,34.3-22.2,34.3h24.5      c17.6,0,31.7-14.1,32.1-31.3C196.6,424.8,196.6,423.8,196.5,422.8"
              />
              <path
                class="st2"
                d="M108.2,457.2H52.5c0,7.7,7.3,14,16.3,14h28h11.3h11.3h28c9,0,16.3-6.3,16.3-14H108.2z"
              />
              <path
                class="st3"
                d="M162.1,422.8l-1.6-33.4h-52.4h-7.1H40.7l-1.6,33.4c-0.9,18.6,9.3,34.3,22.2,34.3h39.8h7.1H140      C152.8,457.2,163,441.4,162.1,422.8"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M78,499.3l-9.5-5h-8.7h-8.7l-9.5,5c-0.4,0.2-0.3,0.9,0.2,0.9h18h18C78.3,500.2,78.5,499.5,78,499.3"
              />
              <rect x="52.5" y="457.2" class="st9" width="13.8" height="37.1" />
              <path
                class="st2"
                d="M47.1,457.2v33.1c0,2.2,1.8,4,4,4h1.4v-37.1H47.1z"
              />
              <path
                class="st2"
                d="M66.3,457.2v37.1h2.2c2.2,0,4-1.8,4-4v-33.1H66.3z"
              />
            </g>
            <g>
              <path
                class="st19"
                d="M47.5,377.9h106.9h37.3l-6.7-86.1c-17.3-3.3-31.8,5.6-31.8,5.6s-46.9,17.3-74.8,3.6      c-9.4-4.6-20.4-6.8-30.7-7.6c-6-0.5-11.6-0.5-16.6-0.4l-6.6,84.9H47.5z"
              />
              <polygon
                class="st20"
                points="191.7,377.9 154.4,377.9 47.5,377.9 24.6,377.9 23.7,389.4 46.9,389.4 101,389.4 108.2,389.4       155,389.4 192.6,389.4     "
              />
              <g>
                <path
                  class="st21"
                  d="M144.2,354.3c3.4,0,6.8,1.1,10.2,1.5c3.4,0.4,7.2,0,9.7-2.4c-3.4,4.2-9.1,6.4-14.4,5.6       c-3.1-0.5-6.1-1.9-9.2-2.4c-1.7-0.3-3.4-0.2-5.1,0C137.5,354.8,141.4,354.2,144.2,354.3"
                />
                <path
                  class="st21"
                  d="M74.2,343.9c2.3-2.5,5.8-3.3,9.2-3.3c3.3,0,6.6,0.9,9.9,1.2c3.3,0.4,6.9,0.3,9.8-1.4       c-2.1,3.2-6,4.8-9.9,5c-3.8,0.2-7.6-0.6-11.4-1.1c-3.8-0.5-7.8-0.6-11.3,1"
                />
                <path
                  class="st21"
                  d="M131.3,322.4c2.4-0.6,4.8-0.6,7.3-0.5c5.9,0.2,12,1.4,17.7-0.1c-2.6,1.8-5.4,3.6-8.5,4.1       c-2.2,0.3-4.4-0.1-6.6-0.4c-6.2-1-13-1.7-18.8,1.3C125.1,324.9,128.1,323.2,131.3,322.4"
                />
                <path
                  class="st21"
                  d="M62,313c2.8,0.2,5.6,1.1,8.4,1.6c2.8,0.5,5.8,0.6,8.3-0.8c-2.6,2.9-6.5,4.2-10.4,4.5       c-3.1,0.2-6.1-0.2-9.2-0.6c-4.5-0.6-8.7,0-13.2,0C50.3,314.8,56.6,312.7,62,313"
                />
              </g>
              <g>
                <path
                  class="st22"
                  d="M63.1,323.8c-0.2,1.3-0.3,2.7-0.2,4.1c0,0.5,0.3,1.1,0.8,1c0.2-0.1,0.3-0.3,0.4-0.5       c0.4-1.1,0.3-2.4,0.2-3.6c0-0.5-0.1-1-0.5-1.3c-0.4-0.2-1.1,0.3-0.8,0.6"
                />
                <path
                  class="st22"
                  d="M69.7,338.8c0,1-0.1,2-0.1,3c0,0.5,0,1.1,0.2,1.5c0.2,0.5,0.8,0.8,1.3,0.7c0.4-0.1,0.6-0.6,0.8-1       c0.2-0.7,0.3-1.4,0.3-2.1c0-0.6-0.2-1.3-0.7-1.8c-0.5-0.4-1.4-0.5-1.7,0.1"
                />
                <path
                  class="st22"
                  d="M65,332.3c0,1.1,0,2.2,0,3.3c0,0.4,0.1,1,0.6,0.9c0.3,0,0.4-0.4,0.5-0.7c0.3-1.3,0.1-2.6-0.5-3.8"
                />
                <path
                  class="st22"
                  d="M77.9,357.4c-0.1,1.2-0.3,2.4-0.4,3.6c0,0.4,0.1,0.9,0.5,0.8c0.3-0.1,0.3-0.4,0.3-0.6       c0.1-1.5,0.1-3,0.1-4.4"
                />
                <path
                  class="st22"
                  d="M79.7,352.6c-0.1,1.6,0,3.2,0.1,4.8c0.3,0.2,0.6-0.3,0.7-0.7c0.1-1.2,0.2-2.5,0.1-3.7       c0-0.5-0.3-1.2-0.7-1"
                />
                <path
                  class="st22"
                  d="M150.4,331.6c-0.1,1.2-0.2,2.4-0.3,3.6c-0.1,1,0.4,2.5,1.3,2.1c0.3-0.1,0.4-0.4,0.6-0.7       c0.8-1.7,0.5-3.8-0.7-5.2"
                />
                <path
                  class="st22"
                  d="M159.4,317.7c0,1.6-0.1,3.1-0.1,4.7c0,0.6,0,1.2,0.4,1.6c0.6,0.7,1.8,0.3,2.3-0.5       c0.4-0.8,0.2-1.8-0.1-2.6c-0.3-0.9-0.7-1.7-0.8-2.6l-1.3-0.1"
                />
                <path
                  class="st22"
                  d="M162.8,340c0.5,1.1-0.1,2.4-0.1,3.6c0,1.2,1.4,2.6,2.3,1.7c0.2-0.2,0.3-0.5,0.4-0.8       c0.4-1.8-0.1-3.9-1.4-5.3"
                />
                <path
                  class="st22"
                  d="M51.1,316.6c0,1.1,0,2.2-0.1,3.4c0,0.4,0.1,1,0.5,1.1c0.5,0.1,0.7-0.6,0.8-1.1c0.1-1.3,0.1-2.5,0-3.8       l-0.6,0"
                />
                <path
                  class="st23"
                  d="M63.3,340.6c-0.4,1.2-0.4,2.5,0,3.7c0.6-1.1,0.8-2.4,0.6-3.6c-0.1-0.4-0.5-0.8-0.7-0.5"
                />
                <path
                  class="st23"
                  d="M71.4,350.2c0.1,0.7-0.1,1.4,0,2.1c0.1,0.7,0.8,1.4,1.4,1.1c0.5-0.2,0.6-0.9,0.6-1.4c0-0.9,0-1.8-0.5-2.5       C72.3,348.9,71.4,349.3,71.4,350.2"
                />
                <path
                  class="st23"
                  d="M75.5,329.5c0.2,0.7-0.2,1.5-0.3,2.2c0,0.8,0.6,1.7,1.3,1.4c0.5-0.2,0.6-0.9,0.6-1.4c0-0.9,0-1.8-0.1-2.7       c-0.3,0-0.5,0-0.8,0"
                />
                <path
                  class="st23"
                  d="M70.5,358.7c-0.2,1-0.3,2.1-0.2,3.2c0,0.4,0.3,0.9,0.7,0.8c0.3-0.1,0.3-0.4,0.4-0.6       c0.2-1.3,0.1-2.7-0.1-4c-0.2,0-0.5,0-0.7,0"
                />
                <path
                  class="st23"
                  d="M56.8,331.4c-0.1,0.9,0,1.8,0.3,2.7c0.1,0.2,0.1,0.3,0.3,0.4c0.4,0.2,0.7-0.4,0.8-0.8       c0.1-0.8,0-1.7-0.2-2.5l-1,0c0,0.2,0,0.4,0,0.6"
                />
                <path
                  class="st23"
                  d="M155.4,344.9c-0.1,1-0.2,1.9-0.4,2.9c-0.1,0.4-0.1,0.9,0.2,1.2c0.4,0.4,1.1,0.2,1.4-0.2       c0.3-0.4,0.4-1,0.3-1.5c0-1.1-0.2-2.2-0.5-3.3c-0.3-0.2-0.9,0.2-0.8,0.6"
                />
                <path
                  class="st23"
                  d="M164.8,359.6c-0.1,1.5-0.1,3.1,0.1,4.6c0.1,0.9,0.7,2,1.5,1.6c0.5-0.2,0.6-0.9,0.6-1.5c0-1,0-2,0.1-3       c0-0.5,0-1.1-0.3-1.6c-0.3-0.5-0.9-0.8-1.4-0.5"
                />
              </g>
              <path
                class="st24"
                d="M47.8,293.4c10.3,0.8,21.3,3,30.7,7.6c28,13.8,74.8-3.6,74.8-3.6s14.6-9,31.8-5.6l-0.5-6.8      c-18.1-6.7-34.5,4.2-34.5,4.2s-43.5,17.3-69.5,3.6c-8.7-4.6-19-6.8-28.5-7.6c-7.6-0.7-14.8-0.5-20.3-0.2l-0.6,8      C36.1,292.9,41.8,292.9,47.8,293.4"
              />
            </g>
          </g>
          <g>
            <rect x="490.2" y="460.1" class="st8" width="9.2" height="9.2" />
            <path
              class="st10"
              d="M511.1,444.3c0,9-7.3,16.3-16.3,16.3c-9,0-16.3-7.3-16.3-16.3c0-9,7.3-16.3,16.3-16.3     C503.8,428,511.1,435.3,511.1,444.3"
            />
            <path
              class="st25"
              d="M508.5,444.3c0,7.6-6.1,13.7-13.7,13.7c-7.6,0-13.7-6.1-13.7-13.7c0-7.6,6.1-13.7,13.7-13.7     C502.4,430.6,508.5,436.7,508.5,444.3"
            />
            <polygon
              class="st8"
              points="495.1,449.8 498.6,447.8 494.6,445    "
            />
            <polygon
              class="st8"
              points="493.8,445.4 495.4,444.5 489.2,435.5    "
            />
            <path
              class="st8"
              d="M496.4,444c0.5,1,0.2,2.2-0.7,2.7c-1,0.5-2.2,0.2-2.7-0.7c-0.5-1-0.2-2.2,0.7-2.7     C494.6,442.7,495.8,443,496.4,444"
            />
            <path
              class="st2"
              d="M505.2,444.2L505.2,444.2c0,0.3,0,0.5,0,0.7l2.2,0.1c0-0.3,0-0.5,0-0.8v0L505.2,444.2z M504.7,441     c0.1,0.2,0.1,0.4,0.2,0.6l2.1-0.6c-0.1-0.3-0.1-0.5-0.2-0.8L504.7,441z M503.2,438.1c0.1,0.2,0.3,0.4,0.4,0.5l1.9-1.2     c-0.1-0.2-0.3-0.4-0.4-0.7L503.2,438.1z M500.9,435.8c0.2,0.1,0.3,0.3,0.5,0.4l1.4-1.7c-0.2-0.2-0.4-0.3-0.6-0.5L500.9,435.8z      M498,434.3c0.2,0.1,0.4,0.1,0.6,0.2l0.8-2c-0.2-0.1-0.5-0.2-0.7-0.3L498,434.3z M494.8,433.8L494.8,433.8c0.2,0,0.4,0,0.7,0     l0.1-2.2c-0.3,0-0.5,0-0.8,0h0L494.8,433.8z M491.6,434.4c0.2-0.1,0.4-0.1,0.6-0.2l-0.5-2.1c-0.3,0.1-0.5,0.1-0.8,0.2     L491.6,434.4z M488.7,435.9c0.2-0.1,0.4-0.3,0.5-0.4l-1.2-1.9c-0.2,0.1-0.4,0.3-0.7,0.4L488.7,435.9z M486.4,438.2     c0.1-0.2,0.3-0.4,0.4-0.5l-1.7-1.4c-0.2,0.2-0.3,0.4-0.5,0.6L486.4,438.2z M484.9,441.1c0.1-0.2,0.1-0.4,0.2-0.6l-2-0.8     c-0.1,0.2-0.2,0.5-0.3,0.7L484.9,441.1z M484.4,444.3L484.4,444.3c0-0.2,0-0.4,0-0.7l-2.2-0.1c0,0.3,0,0.5,0,0.8v0L484.4,444.3z      M484.9,447.5c-0.1-0.2-0.1-0.4-0.2-0.6l-2.1,0.5c0.1,0.3,0.1,0.5,0.2,0.8L484.9,447.5z M486.4,450.4c-0.1-0.2-0.3-0.4-0.4-0.5     l-1.9,1.2c0.1,0.2,0.3,0.4,0.4,0.7L486.4,450.4z M503.3,450.4c-0.1,0.2-0.3,0.3-0.4,0.5l1.7,1.4c0.2-0.2,0.3-0.4,0.5-0.6     L503.3,450.4z M504.7,447.5c-0.1,0.2-0.1,0.4-0.2,0.6l2,0.8c0.1-0.2,0.2-0.5,0.3-0.7L504.7,447.5z"
            />
          </g>
        </g>
      </g>
      <rect x="31.1" y="761.1" class="st26" width="1591.2" height="17.8" />
      <g>
        <g id="ledlayer3">
          <polygon
            class="st27"
            points="760.2,50 1399.8,50 1408.2,92.7 746.7,92.7  "
          />
          <linearGradient
            id="SVGID_1_"
            gradientUnits="userSpaceOnUse"
            x1="1077.4294"
            y1="92.6664"
            x2="1077.4294"
            y2="49.9972"
          >
            <stop
              v-if="
                getRealTime.Light[2].LED1 > 0 ||
                getRealTime.Light[2].LED2 > 0 ||
                getRealTime.Light[2].LED3 > 0 ||
                getRealTime.Light[2].LED4 > 0
              "
              offset="0"
              style="stop-color: #ffffff; stop-opacity: 0"
            />
            <stop
              v-if="
                getRealTime.Light[2].LED1 > 0 ||
                getRealTime.Light[2].LED2 > 0 ||
                getRealTime.Light[2].LED3 > 0 ||
                getRealTime.Light[2].LED4 > 0
              "
              offset="0"
              style="stop-color: #fdfdff; stop-opacity: 0.25"
            />
            <stop
              v-if="getRealTime.Light[2].LED4 > 0"
              offset="25%"
              style="stop-color: #701212; stop-opacity: 0.3"
            />
            <stop
              offset="50%"
              v-if="getRealTime.Light[2].LED3 > 0"
              style="stop-color: #0025d4; stop-opacity: 0.5"
            />
            <stop
              offset="60%"
              v-if="getRealTime.Light[2].LED2 > 0"
              style="stop-color: #ff0000; stop-opacity: 0.6"
            />
            <stop
              offset="85%"
              v-if="getRealTime.Light[2].LED1 > 0"
              style="stop-color: rgb(211, 211, 211); stop-opacity: 0.6"
            />
          </linearGradient>
        </g>
        <g id="ledLayer2">
          <polygon
            class="st28"
            points="760.3,162.6 1399.9,162.6 1408.3,205.2 746.8,205.2  "
          />
          <linearGradient
            id="SVGID_2_"
            gradientUnits="userSpaceOnUse"
            x1="1077.5089"
            y1="205.2323"
            x2="1077.5089"
            y2="162.5631"
          >
            <stop
              v-if="
                getRealTime.Light[1].LED1 > 0 ||
                getRealTime.Light[1].LED2 > 0 ||
                getRealTime.Light[1].LED3 > 0 ||
                getRealTime.Light[1].LED4 > 0
              "
              offset="0"
              style="stop-color: #ffffff; stop-opacity: 0"
            />
            <stop
              v-if="
                getRealTime.Light[1].LED1 > 0 ||
                getRealTime.Light[1].LED2 > 0 ||
                getRealTime.Light[1].LED3 > 0 ||
                getRealTime.Light[1].LED4 > 0
              "
              offset="0"
              style="stop-color: #fdfdff; stop-opacity: 0.25"
            />
            <stop
              v-if="getRealTime.Light[1].LED4 > 0"
              offset="25%"
              style="stop-color: #701212; stop-opacity: 0.3"
            />
            <stop
              offset="50%"
              v-if="getRealTime.Light[1].LED3 > 0"
              style="stop-color: #0025d4; stop-opacity: 0.5"
            />
            <stop
              offset="60%"
              v-if="getRealTime.Light[1].LED2 > 0"
              style="stop-color: #ff0000; stop-opacity: 0.6"
            />
            <stop
              offset="85%"
              v-if="getRealTime.Light[1].LED1 > 0"
              style="stop-color: rgb(211, 211, 211); stop-opacity: 0.6"
            />
          </linearGradient>
        </g>
        <g id="ledLayer1">
          <polygon
            class="st29"
            points="758.8,280.7 1398.5,280.7 1406.8,323.4 745.3,323.4  "
          />
          <linearGradient
            id="SVGID_3_"
            gradientUnits="userSpaceOnUse"
            x1="1076.0653"
            y1="323.393"
            x2="1076.0653"
            y2="280.7238"
          >
            <stop
              v-if="
                getRealTime.Light[0].LED1 > 0 ||
                getRealTime.Light[0].LED2 > 0 ||
                getRealTime.Light[0].LED3 > 0 ||
                getRealTime.Light[0].LED4 > 0
              "
              offset="0"
              style="stop-color: #ffffff; stop-opacity: 0"
            />
            <stop
              v-if="
                getRealTime.Light[0].LED1 > 0 ||
                getRealTime.Light[0].LED2 > 0 ||
                getRealTime.Light[0].LED3 > 0 ||
                getRealTime.Light[0].LED4 > 0
              "
              offset="0"
              style="stop-color: #fdfdff; stop-opacity: 0.7"
            />
            <stop
              v-if="getRealTime.Light[0].LED4 > 0"
              offset="25%"
              style="stop-color: #701212; stop-opacity: 0.3"
            />
            <stop
              offset="50%"
              v-if="getRealTime.Light[0].LED3 > 0"
              style="stop-color: #0025d4; stop-opacity: 0.5"
            />
            <stop
              offset="60%"
              v-if="getRealTime.Light[0].LED2 > 0"
              style="stop-color: #ff0000; stop-opacity: 0.6"
            />
            <stop
              offset="85%"
              v-if="getRealTime.Light[0].LED1 > 0"
              style="stop-color: rgb(211, 211, 211); stop-opacity: 0.6"
            />
          </linearGradient>
        </g>
      </g>
      <g>
        <g>
          <rect x="659.3" y="610" class="st25" width="337.4" height="141" />
          <rect
            x="659.3"
            y="-760.2"
            class="st30"
            width="337.4"
            height="1em"
            transform="scale(1,-1)"
            v-bind:style="{
              fontSize:
                fontSizeTank(getRealTime.Status.NutrientTank.Level.toFixed(2)) +
                'px',
            }"
          />
          <rect x="654.8" y="606.6" class="st31" width="4.4" height="154.5" />
          <path
            class="st31"
            d="M1004.3,612.2H652.8c-1.2,0-2.1-1.3-2.1-2.8c0-1.5,1-2.8,2.1-2.8h351.4c1.2,0,2.1,1.3,2.1,2.8    C1006.4,610.9,1005.4,612.2,1004.3,612.2"
          />
          <rect x="996.7" y="606.6" class="st31" width="4.4" height="154.5" />
          <polygon
            class="st31"
            points="654.8,761.1 654.8,753.6 1001.1,754 1001.1,760.8   "
          />
        </g>
        <g
          v-if="
            getRealTime.Valve[6].On ||
            getRealTime.Valve[7].On ||
            getRealTime.Valve[8].On
          "
        >
          <path
            class="st32"
            d="M862.6,636.1c-1.2,7.1-5.8,13.7-4.8,20.8c0.4,2.9,1.7,5.5,2.4,8.3c1.1,4.8,0,10.2-3,13.8    c-0.7,0.9-1.5,1.7-2.2,2.6c-1,1.4-1.7,3.2-2.1,5c-1.5,6.6,0.5,14.1,4.9,18.8c-5.9-3.6-8.4-11.9-8.1-19.5c0.1-2,0.3-4.1,1-6    c0.7-1.9,1.7-3.6,2.7-5.4c1.3-2.3,2.6-4.8,2.7-7.5c0.2-5.1-3.3-9.4-4-14.4c-0.4-3.4,0.5-6.9,1.8-10c1.3-3.1,3-6,4.1-9.3    c0.9-2.5,1.4-5.2,1.5-7.9c0.1-3,0-6.1-0.4-9c-0.1-0.8-0.1-4.1-0.1-4.1c1-0.3,3,0,3.7,0c0.7,0,0.8,11.1,0.8,12.1    C863.6,628.2,863.2,632.3,862.6,636.1"
          />
          <path
            class="st33"
            d="M860.1,698.6c0.1,0,0.2,0,0.2-0.1c0.4-0.2-0.4-1.9-0.5-2.3c-0.2-1.4,0.2-3,0.4-4.4c0.4-2.4,1.1-4.9,1.2-7.4    c0-0.7,0-1.4-0.1-2.1c-0.4-2.8-1.5-5.5-2.8-7.9c-1.6-3.1-3.5-6.1-4.5-9.5c-1.4-4.8-1-10.2,1.2-14.6c2.2-4.5,6.1-7.9,7.5-12.8    c0.7-2.4,0.7-5,0.7-7.5c0-6.3,2.7-12.8-0.7-17.7c0.9,5.8-1.9,11.4-2.1,17.3c-0.1,2.8-0.3,5.6-1.4,8.1c-1.5,3.5-4.5,5.8-6.6,9    c-1.9,2.9-3,6.5-3,10.1c0,3.3,0.8,6.6,1.7,9.7c1,3.6,2.2,7.2,4.4,10.1c1.7,2.2,2.7,3.2,3,6c0.5,4.1-0.6,8.1-0.2,12    C858.6,695,859.1,698.7,860.1,698.6"
          />
          <path
            class="st34"
            d="M866.1,636.5c-1.4,4-4,7.6-4,11.9c0.1,2.8,1.3,5.3,2.1,7.9c2.5,7.9,1.2,17.1-3.2,23.8    c-1.2,1.8-2.5,3.4-3.6,5.2c-3.1,5.2-3.4,12.4-0.9,18c1.3,2.9,3.3,5.4,4.1,8.5c0.3,1.2,0.8,3.6,0,4.7c-0.4-0.8-0.3-1.7-0.6-2.6    c-0.8-2.2-2.2-3.9-3.5-5.7c-2.1-2.9-3.9-6-4.9-9.5c-1.9-6.8-0.3-14.4,2.9-20.6c1.6-3.1,3.6-6.2,3.9-9.7c0.4-4.5-2-8.9-2.1-13.4    c-0.1-6.4,4.1-11.6,6.7-17.2c1.4-3,2.4-6.3,2.9-9.6c0.8-5.1,0.1-10.6,0-15.8C868.1,619.6,868.7,629.2,866.1,636.5"
          />
          <path
            class="st35"
            d="M862.7,645.2c-1.5,3.4-3.6,6.8-3.4,10.5c0.1,1.8,0.7,3.5,1.2,5.2c2.1,6.7,2.9,14.5,0,20.9    c-1.2,2.7-3.1,5-3.9,7.9c-1,3.5,0,9.1,2,12c-5.2-4.7-5.4-13.3-2.9-19.9c1.2-3,2.7-5.3,3.1-8.6c0.5-3.9-0.9-7.3-2-10.9    c-1.5-4.4-1.2-8.5,0.5-12.8c1.5-3.8,3.7-7.2,5.2-11c1-2.7,0.9-5.9,1.1-8.8c0.4-3.6-0.8-13.9-0.8-17.4c0.7,4.3,2.8,12.6,2.6,17    C865.2,633.8,864.6,641.1,862.7,645.2"
          />
          <path
            class="st36"
            d="M862.1,612.3h4.7c1.4,6,0.7,12.5-0.1,18.6c-0.4,2.9-0.9,5.9-2,8.6c-1.6,4.1-4.3,7.6-5.3,11.9    c-1.1,4.6,0,9.5,1,14.2c0.8,3.9,1.6,8.3,0.5,12.2c-1,3.7-3.6,6.6-4.1,10.6c-0.4,2.6-0.1,5.4,0.3,8c0.2,1.5,0.6,2.9,1,4.4    c0.4,1.2,1.3,2.6,1.1,3.8c-2.3-1.6-3.6-6.4-4.1-9c-0.6-3.5-0.3-7.1,0.7-10.4c1.3-4.1,4.3-7.7,4.2-12c0-5.1-4.1-9-4.9-14    c-0.6-3.5,0.6-7.1,2.1-10.1c1.6-3.1,3.6-5.8,5.1-8.9C866.5,631.9,866.2,620.6,862.1,612.3"
          />
        </g>
        <g>
          <polygon
            class="st0"
            points="864.7,582.5 865.2,582.5 865.2,595.3 864.3,595.3 864.3,582.5   "
          />
          <rect x="865.2" y="582.5" class="st7" width="2.5" height="12.9" />
          <rect x="867.6" y="582.5" class="st0" width="0.9" height="12.9" />
          <polygon
            class="st7"
            points="869.6,582.5 871.2,595.3 868.5,595.3 868.5,582.5   "
          />
          <polygon
            class="st7"
            points="858.3,595.3 859.8,582.5 860.9,582.5 860.9,595.3   "
          />
          <rect x="860.9" y="582.5" class="st0" width="0.9" height="12.9" />
          <rect x="861.8" y="582.5" class="st7" width="2.5" height="12.9" />
          <path
            class="st37"
            d="M849.7,606.5h28.1c0-6.2-2.5-11.1-5.6-11.1h-16.9C852.2,595.3,849.7,600.3,849.7,606.5z"
          />
        </g>
      </g>
      <g>
        <g>
          <rect
            x="1075.6"
            y="608.3"
            class="st31"
            width="279.4"
            height="153.9"
          />
          <rect x="1080.6" y="612.1" class="st25" width="268" height="140.8" />
          <rect
            x="1080.5"
            y="-755"
            class="st38"
            width="268.8"
            height="1em"
            transform="scale(1,-1)"
            v-bind:style="{
              fontSize:
                fontSizeTank(getRealTime.Status.DrainTank.Level.toFixed(2)) +
                'px',
            }"
          />
          <path
            class="st31"
            d="M1355.2,610.6H1074c-0.9,0-1.7-1.2-1.7-2.8c0-1.5,0.8-2.8,1.7-2.8h281.2c0.9,0,1.7,1.2,1.7,2.8    C1357,609.3,1356.2,610.6,1355.2,610.6"
          />
        </g>
        <g>
          <g>
            <rect
              x="1436.1"
              y="654.1"
              class="st39"
              width="34.1"
              height="40.8"
            />
            <rect
              x="1436.1"
              y="694.9"
              class="st40"
              width="34.1"
              height="65.7"
            />
            <polygon
              class="st41"
              points="1480.6,664.9 1480.6,651.1 1470.1,640 1470.1,654.1    "
            />
            <polygon
              class="st42"
              points="1470.1,694.9 1470.1,760.6 1480.6,760.6 1480.6,705.7    "
            />
            <polygon
              class="st43"
              points="1470.1,654.1 1470.1,694.9 1480.6,705.7 1480.6,664.9    "
            />
            <path
              class="st44"
              d="M1589,654.1c-0.8-3.6-2.6-6.8-5.2-9.3v9.3v40.8v65.7h5.6v-103C1589.3,656.4,1589.2,655.2,1589,654.1"
            />
            <path
              class="st45"
              d="M1583.8,654.1v-9.3c-3.2-3-7.4-4.8-12.1-4.8h-21.9v14.1H1583.8z"
            />
            <rect
              x="1549.7"
              y="654.1"
              class="st39"
              width="34.1"
              height="40.8"
            />
            <rect
              x="1549.7"
              y="694.9"
              class="st40"
              width="34.1"
              height="65.7"
            />
            <polygon
              class="st43"
              points="1539.2,664.9 1539.2,705.7 1549.7,694.9 1549.7,654.1    "
            />
            <polygon
              class="st42"
              points="1539.2,705.7 1539.2,760.6 1549.7,760.6 1549.7,694.9    "
            />
            <polygon
              class="st41"
              points="1549.7,654.1 1549.7,640 1539.2,651.1 1539.2,664.9    "
            />
            <rect
              x="1480.6"
              y="664.9"
              class="st46"
              width="58.6"
              height="40.8"
            />
            <rect
              x="1480.6"
              y="651.1"
              class="st47"
              width="58.6"
              height="13.8"
            />
            <path
              class="st45"
              d="M1470.1,654.1V640h-21.9c-4.7,0-8.9,1.8-12.1,4.8v9.3H1470.1z"
            />
            <path
              class="st44"
              d="M1430.9,654.1c-0.2,1.2-0.4,2.4-0.4,3.6v103h5.6v-65.7v-40.8v-9.3C1433.5,647.2,1431.7,650.4,1430.9,654.1"
            />
            <rect
              x="1480.6"
              y="705.7"
              class="st48"
              width="58.6"
              height="54.9"
            />
          </g>
        </g>
        <g>
          <g v-if="getRealTime.Valve[21].On">
            <path
              class="st49"
              d="M1430.5,723.5v37.1h5.6v-38.3C1432.3,723,1430.5,723.5,1430.5,723.5"
            />
            <path
              class="st50"
              d="M1436.1,718.4v4c6-0.9,16.9-1.9,34.1-0.7v-4C1453,716.4,1442.1,717.4,1436.1,718.4"
            />
            <path
              class="st38"
              d="M1436.1,722.4v38.3h34.1v-39C1453,720.4,1442.1,721.4,1436.1,722.4"
            />
            <path
              class="st51"
              d="M1470.1,717.6v4c3.3,0.2,6.8,0.5,10.5,0.9v-4C1476.9,718.1,1473.4,717.8,1470.1,717.6"
            />
            <path
              class="st49"
              d="M1470.1,721.6v39h10.5v-38.1C1476.9,722.1,1473.4,721.8,1470.1,721.6"
            />
            <path
              class="st51"
              d="M1583.8,720.4c1.8,0.5,3.7,1.1,5.6,1.8v-4c-1.9-0.7-3.7-1.3-5.6-1.8V720.4z"
            />
            <path
              class="st49"
              d="M1583.8,760.6h5.6v-38.4c-1.9-0.7-3.7-1.3-5.6-1.8V760.6z"
            />
            <path
              class="st50"
              d="M1549.7,718.3v4c0,0,15.9-6.5,34-1.9v-4C1565.6,711.8,1549.7,718.3,1549.7,718.3"
            />
            <path
              class="st38"
              d="M1549.7,722.3v38.3h34v-40.2C1565.6,715.8,1549.7,722.3,1549.7,722.3"
            />
            <path
              class="st51"
              d="M1539.2,720.5v4c7.1-1,10.5-2.2,10.5-2.2v-4C1549.7,718.3,1546.3,719.5,1539.2,720.5"
            />
            <path
              class="st49"
              d="M1539.2,724.5v36.1h10.5v-38.3C1549.7,722.3,1546.3,723.5,1539.2,724.5"
            />
            <path
              class="st50"
              d="M1489.1,719.5c-3-0.4-5.8-0.7-8.5-1v4c2.7,0.3,5.5,0.6,8.5,1c24.1,3.2,40.5,2.3,50.1,1v-4     C1529.6,721.8,1513.2,722.7,1489.1,719.5"
            />
            <path
              class="st51"
              d="M1436.1,718.4c-3.8,0.6-5.6,1.2-5.6,1.2v4c0,0,1.8-0.6,5.6-1.2V718.4z"
            />
            <path
              class="st38"
              d="M1489.1,723.5c-3-0.4-5.8-0.7-8.5-1v38.1h58.6v-36.1C1529.6,725.9,1513.2,726.7,1489.1,723.5"
            />
            <path
              class="st52"
              d="M1481.1,726.1c1.4,1.7,3.7,2.5,5.9,2.2c0.2,0,0.4-0.1,0.5-0.2c0.3-0.2,0.2-0.7,0-1     c-0.2-0.3-0.6-0.4-0.9-0.5c-1.8-0.6-3.6-1.3-5.4-1.9c-0.2,0.4-0.1,1,0.3,1.3"
            />
            <path
              class="st52"
              d="M1493.7,728.9c-0.7,0.2-1.5,0-2.2,0c-0.7,0-1.6,0.2-1.9,0.9c1.6,0.5,3.3,0.7,5,0.5c0.3,0,0.8-0.2,0.8-0.5     c0-0.3-0.4-0.5-0.7-0.5C1494.3,729.1,1494,729.1,1493.7,728.9"
            />
            <path
              class="st52"
              d="M1506.7,735.3c-0.8,0.3-1.5,0.7-2.1,1.2c-0.5,0.4-1,1.4-0.4,1.7c0.3,0.1,0.6,0.1,0.9,0     c0.7-0.2,1.4-0.3,2-0.8c0.6-0.4,1-1.2,0.8-1.8"
            />
            <path
              class="st52"
              d="M1492.1,732.7c3,0.3,6.1,0.1,9.1,0c0.5,0,1.2,0,1.4,0.5c0.2,0.4,0,0.9-0.3,1.1c-0.3,0.3-0.8,0.4-1.2,0.4     c-1.7,0.3-22.8,0.8-20.3-4.6c0.8-1.7,3.8,0.3,4.7,0.8C1487.6,732,1489.9,732.5,1492.1,732.7"
            />
          </g>
          <g v-if="getRealTime.Valve[21].On">
            <path
              class="st52"
              d="M1486,730.6c-4.3-1.3-8.7-2.7-12.4-5.3c-7.9-5.4-12.2-15.4-20.8-19.4c-6.9-3.2-14.9-1.9-22.2,0     c1.8-1.9,4.3-2.8,6.8-3.5c3.7-1.1,7.7-2,11.5-1.3c5.1,0.9,9.5,3.5,13.4,6.9c1.3,1.2,2.5,3.2,3.5,4.6c0.8,1,1.9,1.5,2.6,2.6     c1.6,2.6,3.7,4.3,5.6,6.7c1.1,1.4,2.1,2.6,3.7,3.5c1.9,1,3.8,2,5.7,3c1.7,0.9,4.2,1.6,5.6,2.9     C1488,731.3,1486.9,730.9,1486,730.6"
            />
            <path
              class="st53"
              d="M1444.7,702.9c4.9-0.3,9.9,0.5,14,3.1c6.3,4,9.5,11.5,14.9,16.6c2.5,2.4,5.4,4.2,8.4,5.8     c3,1.6,6.2,2.9,9.5,3.6c1.4,0.3,8.5,1.6,8.8-0.6c0.2-1-3-0.6-3.7-0.6c-1.7-0.1-3.3-0.2-4.9-0.5c-3.1-0.6-6.1-1.6-8.7-3.3     c-9.2-5.9-12.8-18.1-22-23.9c-6.5-4.1-14.6-4.2-22.3-4.3c-2.6,0-5.4,0.9-7.9,0.7c-0.3,2.1-0.4,4.2-0.2,6.3     C1430.5,704.9,1443.5,703,1444.7,702.9"
            />
            <path
              class="st38"
              d="M1446.4,699.2c2.5,0.2,5,0.6,7.3,1.4c2.5,0.9,4.8,2.2,7.1,3.6c1.7,1,3.4,2.2,4.8,3.6c1.1,1.2,2,2.7,2.9,4.1     c1.6,2.4,3.3,4.6,5,6.9c1.4,1.8,2.8,3.7,4.7,5.1c1.6,1.2,3.4,2,5.1,2.9c2.4,1.3,4.8,2.8,7.5,3.5c1.1,0.3,3.8,0.8,4.4-0.6     c0.6-1.5-1.1-1.4-2-1.6c-1.6-0.4-3.2-1.1-4.5-2.1c-6.7-4.9-11.7-9.3-17.8-16.3c-3.8-4.3-8.4-8-13.5-10.6     c-3.6-1.8-7.6-2.7-11.6-2.7c-3.8,0-7.2,0.2-10.9,1c-1.2,0.3-3.2,0.5-3.9,1.7c-0.5,0.9-0.3,2.2-0.3,3.2c2-0.7,3.7-2.3,5.9-2.7     C1439.8,698.9,1443.1,698.9,1446.4,699.2"
            />
            <path
              class="st54"
              d="M1454.6,695c7.3,1.9,13.8,6.5,18.6,12.4c0.8,1,1.5,2,2.4,2.9c1.2,1.3,2.6,2.4,4,3.3c0.7,0.4,3.8,1.4,3.8,2     c-1.5,0.3-3.3-0.8-4.6-1.5c-1.8-0.9-3.6-2.1-5.2-3.4c-3.3-2.7-6.4-5.7-10-8c-4.9-3-10.6-4.4-16.4-4.5c-2.9-0.1-5.8,0.2-8.7,0.6     c-2.7,0.4-5.4,1.4-8.1,1.7c0.4-3.2,7.6-5.2,10-5.7C1445.2,693.6,1450.1,693.8,1454.6,695"
            />
            <path
              class="st55"
              d="M1440.3,692.1c3.8-1.3,7.9-1.8,11.7-1.6c6,0.3,11.9,2.1,16.9,5.5c1.6,1.1,3.1,2.3,4.3,3.8     c1.5,1.9,2.4,4.3,3.8,6.3c1.4,2.2,3.3,4,5.5,5.4c1,0.6,2.4,0.9,3.3,1.5c0.7,0.4,0.6,1-0.5,0.9c-1.2-0.1-2.5-0.8-3.5-1.3     c-2.3-1.2-4.4-2.9-6.2-4.8c-3.6-3.7-6.8-8.2-11.2-10.8c-4.2-2.5-9.3-3.2-14.1-2.8c-3.2,0.2-6.4,0.9-9.6,1.7     c-3.4,0.9-7,1.8-9.9,3.9c0.1-0.6,0.5-1,0.9-1.5c1.2-1.4,2.4-2.9,4-3.9C1436.9,693.5,1438.6,692.7,1440.3,692.1"
            />
            <path
              class="st56"
              d="M1438.4,697.5c5.3-0.9,10.7,0.1,15.7,2.1c4.9,2,9.4,5.1,13.5,8.5c2.2,1.8,4.2,3.7,6.4,5.5     c1.9,1.5,3.7,3.1,5.5,4.7c0.6,0.5,1.2,1.5,2.1,1.7c0.9,0.2,1.3-0.2,1-0.9c-0.3-0.7-1.4-1.6-1.9-2.3c-0.7-1.1-1.5-2.2-2.3-3.2     c-2.9-3.5-5.9-7-9.4-10c-7.1-6-16.8-8.7-26-7.2c-2.9,0.5-5.7,1.4-8.1,3.1"
            />
            <path
              class="st57"
              d="M1441.9,691.5c5.5-1.7,11.7-1.7,17.2-0.1c2.7,0.8,5.1,1.2,7.5,2.6c2.9,1.6,5.2,3.9,7.4,6.4     c1,1.1,2,2.7,3.2,3.5c0.2,0.2,2.1,1.3,0.5,1c-0.7-0.1-1.7-1.1-2.2-1.5c-1.7-1.4-3-2.9-4.6-4.4c-0.5-0.4-1-0.8-1.6-1.1     c-6.4-4-15.2-7-22.8-6.1c-1.9,0.2-3.8,0.7-5.6,1.4c-3.4,1.1-7.4,2.6-9.7,5.3c0.4-1.4,1.5-2.4,2.7-3.2     C1436.5,693.5,1438.7,692.4,1441.9,691.5"
            />
          </g>
          <g>
            <rect
              x="1342"
              y="699"
              :class="getRealTime.Pump[3].On ? 'st38' : 'st8'"
              width="30"
              height="6.5"
            />
            <rect
              x="1405.3"
              y="699"
              :class="getRealTime.Valve[21].On ? 'st38' : 'st8'"
              width="24.7"
              height="6.5"
            />
            <g>
              <rect
                x="1371.4"
                y="696.9"
                :class="getRealTime.Valve[21].On ? 'st64' : 'st67'"
                width="38.6"
                height="11.5"
              />
              <g>
                <rect
                  x="1383.8"
                  y="693.2"
                  class="st12"
                  width="14.3"
                  height="3.7"
                />
                <rect
                  x="1389.1"
                  y="681.5"
                  class="st12"
                  width="3.8"
                  height="11.7"
                />
                <polygon
                  :class="getRealTime.Valve[21].On ? 'st64' : 'st67'"
                  points="1388.8,684.4 1379.2,681.4 1379.2,690.2 1388.8,690.2     "
                />
                <polygon
                  :class="getRealTime.Valve[21].On ? 'st64' : 'st67'"
                  points="1393.1,684.4 1402.7,681.4 1402.7,690.2 1393.1,690.2     "
                />
                <rect
                  x="1388.8"
                  y="684.4"
                  :class="getRealTime.Valve[21].On ? 'st64' : 'st67'"
                  width="4.2"
                  height="5.8"
                />
              </g>
            </g>
          </g>
          <rect x="1340.4" y="699.3" class="st59" width="5.8" height="6.5" />
          <path
            class="st37"
            d="M1317.6,687v28.6c6.3,0,11.3-2.6,11.3-5.7v-17.2C1329,689.6,1323.9,687,1317.6,687"
          />
          <g>
            <polygon
              class="st7"
              points="1302.2,744.2 1302.2,729.7 1292.5,729.7 1292.5,744.2 1277,744.2 1277,729.7 1267.2,729.7      1267.2,744.2 1243,744.2 1243,753.2 1326.2,753.2 1326.2,744.2    "
            />
            <g>
              <g>
                <rect
                  x="1262.9"
                  y="672.9"
                  class="st61"
                  width="7.3"
                  height="56.8"
                />
                <rect
                  x="1299.7"
                  y="672.9"
                  class="st61"
                  width="6.6"
                  height="56.8"
                />
                <rect
                  x="1270.1"
                  y="672.9"
                  class="st62"
                  width="5.8"
                  height="56.8"
                />
                <rect
                  x="1293.9"
                  y="672.9"
                  class="st63"
                  width="5.8"
                  height="56.8"
                />
                <path
                  :class="getRealTime.Pump[3].On ? 'st64' : 'st67'"
                  d="M1306.3,672.9v56.8c6.3,0,11.3-5.1,11.3-11.3v-34.1C1317.6,678,1312.6,672.9,1306.3,672.9"
                />
                <path
                  :class="getRealTime.Pump[3].On ? 'st64' : 'st67'"
                  d="M1262.9,672.9v56.8c-7.8,0-14.1-5.1-14.1-11.3v-34.1C1248.7,678,1255.1,672.9,1262.9,672.9"
                />
                <rect
                  x="1275.9"
                  y="672.9"
                  class="st61"
                  width="17.9"
                  height="56.8"
                />
              </g>
            </g>
            <g>
              <polygon
                class="st0"
                points="1342,702.3 1342,702.7 1329,702.7 1329,701.8 1342,701.8     "
              />
              <rect x="1329" y="702.7" class="st7" width="13.1" height="2.5" />
              <rect x="1329" y="705.2" class="st0" width="13.1" height="0.9" />
              <polygon
                class="st7"
                points="1342,707.2 1329,708.8 1329,706.1 1342,706.1     "
              />
              <polygon
                class="st7"
                points="1329,695.7 1342,697.3 1342,698.4 1329,698.4     "
              />
              <rect x="1329" y="698.4" class="st0" width="13.1" height="0.9" />
              <rect x="1329" y="699.3" class="st7" width="13.1" height="2.5" />
            </g>
            <g>
              <rect
                x="1232.9"
                y="707.9"
                class="st7"
                width="15.8"
                height="3.1"
              />
              <rect
                x="1232.9"
                y="706.8"
                class="st0"
                width="15.8"
                height="1.1"
              />
              <polygon
                class="st7"
                points="1232.9,705.4 1248.7,703.5 1248.7,706.8 1232.9,706.8     "
              />
              <polygon
                class="st7"
                points="1248.7,719.6 1232.9,717.7 1232.9,716.3 1248.7,716.3     "
              />
              <rect
                x="1232.9"
                y="715.2"
                class="st0"
                width="15.8"
                height="1.1"
              />
              <rect
                x="1232.9"
                y="712.1"
                class="st7"
                width="15.8"
                height="3.1"
              />
              <polygon
                class="st0"
                points="1232.9,711.6 1232.9,711 1248.7,711 1248.7,712.1 1232.9,712.1     "
              />
            </g>
          </g>
        </g>
        <g>
          <g
            v-if="
              getRealTime.Valve[11].On ||
              getRealTime.Valve[12].On ||
              getRealTime.Valve[13].On
            "
          >
            <path
              class="st38"
              d="M1168,623.3c-0.8,5.5-3.9,10.5-3.3,16c0.3,2.2,1.2,4.2,1.6,6.4c0.7,3.7,0,7.8-2,10.6c-0.5,0.7-1,1.3-1.5,2     c-0.7,1.1-1.1,2.4-1.4,3.8c-1,5.1,0.3,10.8,3.4,14.4c-4-2.7-5.7-9.1-5.5-14.9c0.1-1.6,0.2-3.1,0.7-4.6c0.5-1.5,1.2-2.8,1.9-4.1     c0.9-1.8,1.8-3.7,1.8-5.8c0.2-3.9-2.3-7.2-2.7-11c-0.3-2.6,0.4-5.3,1.2-7.6c0.9-2.4,2-4.6,2.8-7.1c0.6-1.9,0.9-4,1-6.1     c0.1-2.3,0-4.6-0.2-6.9c-0.1-0.6-0.1-3.2-0.1-3.2c0.7-0.2,2.1,0,2.5,0c0.5,0,0.6,8.5,0.5,9.3     C1168.6,617.3,1168.4,620.4,1168,623.3"
            />
            <path
              class="st38"
              d="M1170.3,623.6c-1,3-2.7,5.8-2.7,9.1c0,2.1,0.8,4.1,1.4,6c1.7,6,0.8,13.1-2.2,18.2c-0.8,1.4-1.7,2.6-2.4,4     c-2.1,4-2.3,9.5-0.6,13.8c0.9,2.2,2.3,4.1,2.8,6.5c0.2,1-0.3,2.9-0.1,3.6c-0.9-2.2-1.4-4.2-2.8-6.4c-1.4-2.2-2.6-4.6-3.3-7.3     c-1.3-5.2-0.2-11,2-15.8c1.1-2.4,2.4-4.7,2.7-7.5c0.3-3.5-1.3-6.8-1.4-10.3c-0.1-4.9,2.8-8.9,4.6-13.2c1-2.3,1.6-4.8,2-7.4     c0.5-3.9,0.1-8.1,0-12.1C1171.7,610.7,1172.1,618.1,1170.3,623.6"
            />
            <path
              class="st66"
              d="M1168.1,630.3c-1,2.6-2.4,5.2-2.3,8.1c0.1,1.4,0.5,2.7,0.8,4c1.4,5.2,2,11.1,0,16c-0.8,2-2.1,3.8-2.6,6     c-0.7,2.7,0,6.9,1.3,9.2c-3.6-3.6-3.7-10.2-2-15.2c0.8-2.3,1.8-4.1,2.1-6.6c0.3-3-0.6-5.6-1.4-8.4c-1-3.4-0.8-6.5,0.3-9.8     c1-2.9,2.5-5.5,3.5-8.4c0.7-2.1,0.6-4.5,0.8-6.7c0.2-2.7-0.6-10.6-0.5-13.3c0.5,3.3,1.9,9.6,1.8,13     C1169.7,621.6,1169.3,627.2,1168.1,630.3"
            />
            <path
              class="st38"
              d="M1167.2,605h3.2c1,4.6,0.5,9.5-0.1,14.2c-0.3,2.3-0.6,4.5-1.3,6.6c-1.1,3.1-2.9,5.8-3.6,9.1     c-0.7,3.5,0,7.3,0.6,10.8c0.5,3,1.1,6.3,0.4,9.4c-0.7,2.9-2.4,5-2.8,8.1c-0.2,1.9-0.1,3.8,0.2,5.7c0.3,1.9,1.3,4,1.2,6     c-1.6-0.9-2.2-4.6-2.5-6.3c-0.4-2.6-0.2-5.3,0.5-7.9c0.9-3.1,2.9-5.9,2.9-9.2c0-3.9-2.8-6.9-3.3-10.7c-0.4-2.7,0.4-5.4,1.4-7.7     c1.1-2.3,2.4-4.4,3.5-6.8C1170.2,620,1170,611.4,1167.2,605"
            />
            <path
              class="st38"
              d="M1168.6,660.2c0,1.9-0.5,3.8-0.8,5.7c-0.2,1.2-0.3,2.4-0.3,3.5c0,0.2-0.2,1.8-0.2,1.8     c-0.3-1-0.6-2.2-0.7-3.2c-0.3-3,0.5-6.1,0.1-9.2c-0.2-2.1-0.9-3-2-4.6c-1.5-2.2-2.3-5-3-7.7c-0.6-2.4-1.2-4.9-1.1-7.4     c0-2.8,0.7-5.5,2-7.7c1.4-2.4,3.4-4.2,4.5-6.9c0.7-1.9,0.9-4.1,1-6.2c0.1-4.5,2-8.8,1.4-13.2c2.4,3.8,0.5,8.7,0.5,13.6     c0,1.9,0,3.9-0.5,5.7c-1,3.7-3.6,6.4-5.1,9.8c-1.5,3.4-1.8,7.5-0.8,11.2c0.7,2.6,2,4.9,3,7.2c0.8,1.9,1.6,3.9,1.9,6.1     C1168.6,659.1,1168.7,659.7,1168.6,660.2"
            />
          </g>
          <g>
            <polygon
              class="st0"
              points="1168.5,586.5 1168.8,586.5 1168.8,596.5 1168.2,596.5 1168.2,586.5    "
            />
            <rect x="1168.8" y="586.5" class="st7" width="1.9" height="10" />
            <rect x="1170.8" y="586.5" class="st0" width="0.7" height="10" />
            <polygon
              class="st7"
              points="1172.3,586.5 1173.5,596.5 1171.4,596.5 1171.4,586.5    "
            />
            <polygon
              class="st7"
              points="1163.5,596.5 1164.7,586.5 1165.5,586.5 1165.5,596.5    "
            />
            <rect x="1165.5" y="586.5" class="st0" width="0.7" height="10" />
            <rect x="1166.2" y="586.5" class="st7" width="1.9" height="10" />
            <path
              class="st37"
              d="M1156.8,605.2h21.9c0-4.8-2-8.7-4.4-8.7h-13.2C1158.8,596.5,1156.8,600.4,1156.8,605.2z"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <path
            class="st37"
            d="M956,690.2v28.1c6.2,0,11.1-2.5,11.1-5.6v-16.9C967.1,692.8,962.1,690.2,956,690.2"
          />
          <polygon
            class="st7"
            points="940.8,746.5 940.8,732.2 931.2,732.2 931.2,746.5 916,746.5 916,732.2 906.4,732.2 906.4,746.5     882.6,746.5 882.6,755.4 964.4,755.4 964.4,746.5   "
          />
          <g>
            <polygon
              class="st0"
              points="979.9,705.2 979.9,705.7 967.1,705.7 967.1,704.8 979.9,704.8    "
            />
            <rect x="967.1" y="705.7" class="st7" width="12.8" height="2.5" />
            <rect x="967.1" y="708.1" class="st0" width="12.8" height="0.9" />
            <polygon
              class="st7"
              points="979.9,710.1 967.1,711.7 967.1,709 979.9,709    "
            />
            <polygon
              class="st7"
              points="967.1,698.8 979.9,700.3 979.9,701.4 967.1,701.4    "
            />
            <rect x="967.1" y="701.4" class="st0" width="12.8" height="0.9" />
            <rect x="967.1" y="702.3" class="st7" width="12.8" height="2.5" />
          </g>
          <g>
            <polygon
              class="st0"
              points="872.2,714.4 872.2,713.8 888,713.8 888,714.9 872.2,714.9    "
            />
            <rect x="872.2" y="710.8" class="st7" width="15.8" height="3" />
            <rect x="872.2" y="709.7" class="st0" width="15.8" height="1.1" />
            <polygon
              class="st7"
              points="872.2,708.3 888,706.4 888,709.7 872.2,709.7    "
            />
            <polygon
              class="st7"
              points="888,722.3 872.2,720.4 872.2,719 888,719    "
            />
            <rect x="872.2" y="718" class="st0" width="15.8" height="1.1" />
            <rect x="872.2" y="714.9" class="st7" width="15.8" height="3" />
          </g>
        </g>
        <g>
          <rect x="915" y="676.4" class="st61" width="17.6" height="55.8" />
          <rect x="902.1" y="676.4" class="st61" width="7.1" height="55.8" />
          <rect x="938.3" y="676.4" class="st61" width="6.5" height="55.8" />
          <rect x="909.3" y="676.4" class="st62" width="5.7" height="55.8" />
          <rect x="932.6" y="676.4" class="st63" width="5.7" height="55.8" />
          <rect x="909.3" y="679.8" class="st7" width="29.1" height="1" />
          <rect x="909.3" y="680.8" class="st65" width="29.1" height="1" />
          <rect x="909.3" y="687.7" class="st7" width="29.1" height="1" />
          <rect x="909.3" y="688.7" class="st65" width="29.1" height="1" />
          <rect x="909.3" y="695.5" class="st7" width="29.1" height="1" />
          <rect x="909.3" y="696.5" class="st65" width="29.1" height="1" />
          <rect x="909.3" y="703.3" class="st7" width="29.1" height="1" />
          <rect x="909.3" y="704.3" class="st65" width="29.1" height="1" />
          <rect x="909.3" y="711.1" class="st7" width="29.1" height="1" />
          <rect x="909.3" y="712.1" class="st65" width="29.1" height="1" />
          <rect x="909.3" y="719" class="st7" width="29.1" height="1" />
          <rect x="909.3" y="720" class="st65" width="29.1" height="1" />
          <rect x="909.3" y="726.8" class="st7" width="29.1" height="1" />
          <rect x="909.3" y="727.8" class="st65" width="29.1" height="1" />
        </g>
        <g>
          <path
            :class="getRealTime.Pump[1].On ? 'st64' : 'st67'"
            d="M902.1,676.4v55.8c-7.8,0-14.1-5-14.1-11.1v-33.6C888,681.4,894.3,676.4,902.1,676.4"
          />
          <path
            :class="getRealTime.Pump[1].On ? 'st64' : 'st67'"
            d="M944.8,676.4v55.8c6.2,0,11.1-5,11.1-11.1v-33.6C956,681.4,951,676.4,944.8,676.4"
          />
          <path
            :class="getRealTime.Pump[1].On ? 'st30' : 'st8'"
            d="M1543.6,465.5c0,1.7-1.1,2.4-2.5,2.4l-520.3-0.1c-2.9,0-5.2,2.3-5.2,5.2l0.5,161.3v21.1v37.9h0v3.8    c0,2.7-2.2,4.9-5,4.9h-28.8c-1.3,0-2.3,1-2.3,2.3v2.6l0,0c0,1.3,1,2.3,2.3,2.3l35.1-0.2c3.6,0,6.5-2.9,6.5-6.3l-0.1-47.1    l0.2-176.2c0-2.1,1.7-3.9,3.9-3.9l515.2,0.5c2.9,0.1,8.6-0.2,8.6-5.3V147.4c0-1.3-1-2.3-2.3-2.3h-23.4c-1.3,0-2.3,1-2.3,2.3v4.5    c0,1.3,1,2.3,2.3,2.3h15.4c1.3,0,2.3,1,2.3,2.3v102.6c0,1.3-1,2.3-2.3,2.3h-16c-1.3,0-2.3,1-2.3,2.3v4.5c0,1.3,1,2.3,2.3,2.3h16    c1.3,0,2.3,1,2.3,2.3V379c0,1.3-1,2.3-2.3,2.3h-16c-1.3,0-2.3,1-2.3,2.3v4.5c0,1.3,1,2.3,2.3,2.3h16c1.3,0,2.3,1,2.3,2.3    L1543.6,465.5z"
          />
        </g>
      </g>
      <g>
        <g>
          <polygon
            class="st68"
            points="445.1,596.6 433.9,596.6 423.7,610.3 439.5,610.3   "
          />
          <polygon
            class="st17"
            points="518,610.3 507.8,596.6 485.3,596.6 490.9,610.3   "
          />
          <polygon
            class="st69"
            points="490.9,610.3 485.3,596.6 470.8,596.6 465.2,596.6 445.1,596.6 439.5,610.3   "
          />
          <rect x="423.7" y="719.2" class="st70" width="15.9" height="26.6" />
          <rect x="490.9" y="719.2" class="st71" width="27.1" height="26.6" />
          <polygon
            class="st72"
            points="439.5,719.2 439.5,745.9 465.2,745.9 470.8,745.9 490.9,745.9 490.9,719.2   "
          />
          <rect x="423.7" y="714.8" class="st73" width="15.9" height="4.5" />
          <rect x="490.9" y="714.8" class="st73" width="27.1" height="4.5" />
          <rect x="439.5" y="714.8" class="st74" width="51.3" height="4.5" />
        </g>
        <g>
          <g>
            <rect
              x="476.1"
              y="554.5"
              :class="getRealTime.Pump[7].On ? 'st75' : 'st8'"
              width="228.2"
              height="5.1"
            />
            <path
              :class="getRealTime.Pump[7].On ? 'st75' : 'st8'"
              d="M474,554.5c-4.9,0-8.8,4-8.8,9v12.1h5v-12.1c0-2.1,1.7-3.8,3.8-3.8h2.1v-5.1H474z"
            />
            <rect
              x="465.2"
              y="575.5"
              :class="getRealTime.Pump[7].On ? 'st75' : 'st8'"
              width="5"
              height="21"
            />
          </g>
          <path
            :class="getRealTime.Pump[7].On ? 'st75' : 'st8'"
            d="M732.1,563.5c0-4.9-4-9-8.8-9h-19v5.1h19c2.1,0,3.8,1.7,3.8,3.8v12.1h5V563.5z"
          />
          <rect
            x="727.1"
            y="575.5"
            :class="getRealTime.Pump[7].On ? 'st75' : 'st8'"
            width="5"
            height="6.4"
          />
        </g>
        <g v-if="getRealTime.Pump[7].On">
          <path
            class="st75"
            d="M732.1,592.3c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5s1.1-5.8,2.5-5.8    C731,586.5,732.1,590.9,732.1,592.3"
          />
          <path
            class="st75"
            d="M732.1,602.5c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5s1.1-5.8,2.5-5.8    C731,596.7,732.1,601.1,732.1,602.5"
          />
          <path
            class="st75"
            d="M732.1,612.8c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5s1.1-5.8,2.5-5.8    C731,607,732.1,611.4,732.1,612.8"
          />
          <path
            class="st75"
            d="M732.1,623c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5s1.1-5.8,2.5-5.8C731,617.2,732.1,621.6,732.1,623"
          />
          <path
            class="st75"
            d="M732.1,633.3c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5c0-1.4,1.1-5.8,2.5-5.8    C731,627.5,732.1,631.9,732.1,633.3"
          />
          <path
            class="st75"
            d="M732.1,643.6c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5c0-1.4,1.1-5.8,2.5-5.8    C731,637.8,732.1,642.2,732.1,643.6"
          />
          <path
            class="st75"
            d="M732.1,653.8c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5s1.1-5.8,2.5-5.8    C731,648,732.1,652.4,732.1,653.8"
          />
          <path
            class="st75"
            d="M732.1,664.1c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5s1.1-5.8,2.5-5.8    C731,658.3,732.1,662.7,732.1,664.1"
          />
          <path
            class="st75"
            d="M732.1,674.3c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5c0-1.4,1.1-5.8,2.5-5.8    C731,668.5,732.1,672.9,732.1,674.3"
          />
        </g>
        <g>
          <polygon
            class="st0"
            points="470.8,745.9 468,745.9 468.1,759 470.8,759 473.8,759 473.8,745.9   "
          />
          <polygon
            class="st0"
            points="476.4,745.9 476.4,759 481.2,759 482.4,745.9   "
          />
          <polygon
            class="st0"
            points="451,745.9 452.9,759 458.1,759 456.9,745.9   "
          />
          <polygon
            class="st0"
            points="485,745.9 483.8,759 489,759 490.9,745.9   "
          />
          <polygon
            class="st0"
            points="426.6,745.9 429.3,759 433.8,759 430.5,745.9   "
          />
          <polygon
            class="st0"
            points="433.2,745.9 436.5,759 442.1,759 439.5,745.9   "
          />
          <polygon
            class="st0"
            points="442.2,745.9 444.8,759 450.3,759 448.4,745.9   "
          />
          <polygon
            class="st0"
            points="459.5,745.9 460.7,759 465.5,759 465.4,745.9   "
          />
          <polygon
            class="st0"
            points="493.5,745.9 491.6,759 497.1,759 499.7,745.9   "
          />
          <polygon
            class="st0"
            points="502.3,745.9 499.7,759 505.4,759 508.7,745.9   "
          />
          <polygon
            class="st0"
            points="515,745.9 511.4,745.9 508,759 512.3,759   "
          />
          <polygon
            class="st4"
            points="430.5,745.9 433.8,759 436.5,759 433.2,745.9   "
          />
          <polygon
            class="st4"
            points="439.5,745.9 442.1,759 444.8,759 442.2,745.9   "
          />
          <polygon
            class="st4"
            points="448.4,745.9 450.3,759 452.9,759 451,745.9   "
          />
          <polygon
            class="st4"
            points="456.9,745.9 458.1,759 460.7,759 459.5,745.9   "
          />
          <polygon
            class="st4"
            points="465.4,745.9 465.5,759 468.1,759 468,745.9   "
          />
          <polygon
            class="st4"
            points="508.7,745.9 505.4,759 508,759 511.4,745.9   "
          />
          <polygon
            class="st4"
            points="499.7,745.9 497.1,759 499.7,759 502.3,745.9   "
          />
          <polygon
            class="st4"
            points="490.9,745.9 489,759 491.6,759 493.5,745.9   "
          />
          <polygon
            class="st4"
            points="482.4,745.9 481.2,759 483.8,759 485,745.9   "
          />
          <polygon
            class="st4"
            points="473.8,745.9 473.8,759 476.4,759 476.4,745.9   "
          />
        </g>
        <g>
          <rect x="439.5" y="610.3" class="st76" width="51.3" height="104.4" />
          <rect x="491" y="610.3" class="st12" width="27.1" height="104.4" />
          <rect x="423.8" y="610.3" class="st12" width="15.9" height="104.4" />
        </g>
        <g>
          <rect
            x="439.5"
            y="-715.2"
            class="st75"
            width="51.3"
            height="1em"
            transform="scale(1,-1)"
            v-bind:style="{
              fontSize:
                fontSizeABpH(getRealTime.Status.pHTank.Level[1].Value) + 'px',
            }"
          />
          <rect
            x="491"
            y="-715.2"
            class="st77"
            width="27.1"
            height="1em"
            transform="scale(1,-1)"
            v-bind:style="{
              fontSize:
                fontSizeABpH(getRealTime.Status.pHTank.Level[1].Value) + 'px',
            }"
          />
          <rect
            x="423.8"
            y="-715.2"
            class="st77"
            width="15.9"
            height="1em"
            transform="scale(1,-1)"
            v-bind:style="{
              fontSize:
                fontSizeABpH(getRealTime.Status.pHTank.Level[1].Value) + 'px',
            }"
          />
        </g>
      </g>
      <g>
        <g>
          <polygon
            class="st68"
            points="60.4,596.6 49.2,596.6 39,610.3 54.8,610.3   "
          />
          <polygon
            class="st17"
            points="133.3,610.3 123.1,596.6 100.6,596.6 106.2,610.3   "
          />
          <polygon
            class="st69"
            points="106.2,610.3 100.6,596.6 86.1,596.6 80.5,596.6 60.4,596.6 54.8,610.3   "
          />
          <rect x="39" y="719.2" class="st70" width="15.9" height="26.6" />
          <rect x="39" y="714.8" class="st73" width="15.9" height="4.5" />
          <rect x="106.2" y="714.8" class="st73" width="27.1" height="4.5" />
          <rect x="106.2" y="719.2" class="st71" width="27.1" height="26.6" />
          <rect x="54.8" y="714.8" class="st74" width="51.3" height="4.5" />
          <polygon
            class="st72"
            points="54.8,719.2 54.8,745.9 80.5,745.9 86.1,745.9 106.2,745.9 106.2,719.2   "
          />
        </g>
        <g>
          <rect x="54.8" y="610.3" class="st76" width="51.3" height="104.4" />
          <rect x="106.2" y="610.3" class="st12" width="27.1" height="104.4" />
          <rect x="39" y="610.3" class="st12" width="15.9" height="104.4" />
        </g>
        <g>
          <rect
            x="54.5"
            y="-715.2"
            class="sta8"
            width="51.3"
            height="1em"
            transform="scale(1,-1)"
            v-bind:style="{
              fontSize:
                fontSizeABpH(getRealTime.Status.FertilizerTank.Level[0].Value) +
                'px',
            }"
          />
          <rect
            x="105.8"
            y="-715.2"
            class="sta9"
            width="27.1"
            height="1em"
            transform="scale(1,-1)"
            v-bind:style="{
              fontSize:
                fontSizeABpH(getRealTime.Status.FertilizerTank.Level[0].Value) +
                'px',
            }"
          />
          <rect
            x="39.2"
            y="-715.2"
            class="sta9"
            width="15.9"
            height="1em"
            transform="scale(1,-1)"
            v-bind:style="{
              fontSize:
                fontSizeABpH(getRealTime.Status.FertilizerTank.Level[0].Value) +
                'px',
            }"
          />
        </g>
        <g v-if="getRealTime.Pump[4].On">
          <path
            class="sta8"
            d="M698,603.7c0,1.4-1.1,2.6-2.5,2.6s-2.5-1.2-2.5-2.6c0-1.4,1.1-5.9,2.5-5.9S698,602.3,698,603.7"
          />
          <path
            class="sta8"
            d="M698,614.2c0,1.4-1.1,2.6-2.5,2.6s-2.5-1.2-2.5-2.6s1.1-5.9,2.5-5.9S698,612.8,698,614.2"
          />
          <path
            class="sta8"
            d="M698,624.7c0,1.4-1.1,2.6-2.5,2.6s-2.5-1.2-2.5-2.6s1.1-5.9,2.5-5.9S698,623.3,698,624.7"
          />
          <path
            class="sta8"
            d="M698,635.2c0,1.4-1.1,2.6-2.5,2.6s-2.5-1.2-2.5-2.6c0-1.4,1.1-5.9,2.5-5.9S698,633.8,698,635.2"
          />
          <path
            class="sta8"
            d="M698,645.8c0,1.4-1.1,2.6-2.5,2.6s-2.5-1.2-2.5-2.6c0-1.4,1.1-5.9,2.5-5.9S698,644.3,698,645.8"
          />
          <path
            class="sta8"
            d="M698,656.3c0,1.4-1.1,2.6-2.5,2.6s-2.5-1.2-2.5-2.6c0-1.4,1.1-5.9,2.5-5.9S698,654.9,698,656.3"
          />
          <path
            class="sta8"
            d="M698,666.8c0,1.4-1.1,2.6-2.5,2.6s-2.5-1.2-2.5-2.6c0-1.4,1.1-5.9,2.5-5.9S698,665.4,698,666.8"
          />
        </g>
        <g>
          <rect
            x="692.9"
            y="558.4"
            :class="getRealTime.Pump[4].On ? 'sta8' : 'st8'"
            width="5.1"
            height="34.7"
          />
          <g>
            <path
              :class="getRealTime.Pump[4].On ? 'sta8' : 'st8'"
              d="M92.5,521.2c-5,0-9,3.9-9,8.7v20.8h5.1v-20.8c0-2.1,1.7-3.7,3.8-3.7h5.9v-5H92.5z"
            />
            <rect
              x="83.6"
              y="550.7"
              :class="getRealTime.Pump[4].On ? 'sta8' : 'st8'"
              width="5.1"
              height="45.9"
            />
            <rect
              x="98.4"
              y="521.2"
              :class="getRealTime.Pump[4].On ? 'sta8' : 'st8'"
              width="578.3"
              height="5"
            />
          </g>
          <path
            :class="getRealTime.Pump[4].On ? 'sta8' : 'st8'"
            d="M698,529.9c0-4.8-4-8.7-9-8.7h-12.3v5H689c2.1,0,3.8,1.7,3.8,3.7v28.5h5.1V529.9z"
          />
        </g>
        <g>
          <polygon
            class="st0"
            points="86.1,745.9 83.3,745.9 83.4,759 86.1,759 89.1,759 89.1,745.9   "
          />
          <polygon
            class="st0"
            points="91.7,745.9 91.7,759 96.5,759 97.7,745.9   "
          />
          <polygon
            class="st0"
            points="66.3,745.9 68.2,759 73.4,759 72.2,745.9   "
          />
          <polygon
            class="st0"
            points="100.3,745.9 99.1,759 104.3,759 106.2,745.9   "
          />
          <polygon
            class="st0"
            points="41.9,745.9 44.6,759 49.1,759 45.8,745.9   "
          />
          <polygon
            class="st0"
            points="48.5,745.9 51.8,759 57.4,759 54.8,745.9   "
          />
          <polygon
            class="st0"
            points="57.5,745.9 60.1,759 65.6,759 63.7,745.9   "
          />
          <polygon
            class="st0"
            points="74.8,745.9 76,759 80.8,759 80.7,745.9   "
          />
          <polygon
            class="st0"
            points="108.8,745.9 106.9,759 112.4,759 115,745.9   "
          />
          <polygon
            class="st0"
            points="117.6,745.9 115,759 120.7,759 124,745.9   "
          />
          <polygon
            class="st0"
            points="130.3,745.9 126.7,745.9 123.3,759 127.6,759   "
          />
          <polygon
            class="st4"
            points="45.8,745.9 49.1,759 51.8,759 48.5,745.9   "
          />
          <polygon
            class="st4"
            points="54.8,745.9 57.4,759 60.1,759 57.5,745.9   "
          />
          <polygon
            class="st4"
            points="63.7,745.9 65.6,759 68.2,759 66.3,745.9   "
          />
          <polygon
            class="st4"
            points="72.2,745.9 73.4,759 76,759 74.8,745.9   "
          />
          <polygon
            class="st4"
            points="80.7,745.9 80.8,759 83.4,759 83.3,745.9   "
          />
          <polygon
            class="st4"
            points="124,745.9 120.7,759 123.3,759 126.7,745.9   "
          />
          <polygon
            class="st4"
            points="115,745.9 112.4,759 115,759 117.6,745.9   "
          />
          <polygon
            class="st4"
            points="106.2,745.9 104.3,759 106.9,759 108.8,745.9   "
          />
          <polygon
            class="st4"
            points="97.7,745.9 96.5,759 99.1,759 100.3,745.9   "
          />
          <polygon
            class="st4"
            points="89.1,745.9 89.1,759 91.7,759 91.7,745.9   "
          />
        </g>
      </g>
      <g>
        <g>
          <polygon
            class="st68"
            points="188.6,596.6 177.4,596.6 167.2,610.3 183.1,610.3   "
          />
          <polygon
            class="st17"
            points="261.5,610.3 251.3,596.6 228.8,596.6 234.4,610.3   "
          />
          <polygon
            class="st69"
            points="234.4,610.3 228.8,596.6 214.4,596.6 208.7,596.6 188.6,596.6 183.1,610.3   "
          />
          <rect x="167.2" y="719.2" class="st70" width="15.9" height="26.6" />
          <rect x="167.2" y="714.8" class="st73" width="15.9" height="4.5" />
          <rect x="234.4" y="714.8" class="st73" width="27.1" height="4.5" />
          <rect x="234.4" y="719.2" class="st71" width="27.1" height="26.6" />
          <rect x="183.1" y="714.8" class="st74" width="51.3" height="4.5" />
          <polygon
            class="st72"
            points="183.1,719.2 183.1,745.9 208.7,745.9 214.4,745.9 234.4,745.9 234.4,719.2   "
          />
          <g>
            <polygon
              class="st0"
              points="214.4,745.9 211.6,745.9 211.6,759 214.4,759 217.3,759 217.4,745.9    "
            />
            <polygon
              class="st0"
              points="220,745.9 219.9,759 224.7,759 225.9,745.9    "
            />
            <polygon
              class="st0"
              points="194.5,745.9 196.4,759 201.6,759 200.4,745.9    "
            />
            <polygon
              class="st0"
              points="228.5,745.9 227.3,759 232.5,759 234.4,745.9    "
            />
            <polygon
              class="st0"
              points="170.2,745.9 172.8,759 177.4,759 174,745.9    "
            />
            <polygon
              class="st0"
              points="176.7,745.9 180,759 185.7,759 183.1,745.9    "
            />
            <polygon
              class="st0"
              points="185.7,745.9 188.3,759 193.8,759 191.9,745.9    "
            />
            <polygon
              class="st0"
              points="203,745.9 204.2,759 209,759 209,745.9    "
            />
            <polygon
              class="st0"
              points="237,745.9 235.1,759 240.6,759 243.2,745.9    "
            />
            <polygon
              class="st0"
              points="245.9,745.9 243.3,759 248.9,759 252.2,745.9    "
            />
            <polygon
              class="st0"
              points="258.5,745.9 254.9,745.9 251.6,759 255.9,759    "
            />
            <polygon
              class="st4"
              points="174,745.9 177.4,759 180,759 176.7,745.9    "
            />
            <polygon
              class="st4"
              points="183.1,745.9 185.7,759 188.3,759 185.7,745.9    "
            />
            <polygon
              class="st4"
              points="191.9,745.9 193.8,759 196.4,759 194.5,745.9    "
            />
            <polygon
              class="st4"
              points="200.4,745.9 201.6,759 204.2,759 203,745.9    "
            />
            <polygon
              class="st4"
              points="209,745.9 209,759 211.6,759 211.6,745.9    "
            />
            <polygon
              class="st4"
              points="252.2,745.9 248.9,759 251.6,759 254.9,745.9    "
            />
            <polygon
              class="st4"
              points="243.2,745.9 240.6,759 243.3,759 245.9,745.9    "
            />
            <polygon
              class="st4"
              points="234.4,745.9 232.5,759 235.1,759 237,745.9    "
            />
            <polygon
              class="st4"
              points="225.9,745.9 224.7,759 227.3,759 228.5,745.9    "
            />
            <polygon
              class="st4"
              points="217.4,745.9 217.3,759 219.9,759 220,745.9    "
            />
          </g>
          <g>
            <rect
              x="183.1"
              y="610.3"
              class="st76"
              width="51.3"
              height="104.4"
            />
            <rect
              x="234.5"
              y="610.3"
              class="st12"
              width="27.1"
              height="104.4"
            />
            <rect
              x="167.3"
              y="610.3"
              class="st12"
              width="15.9"
              height="104.4"
            />
          </g>
        </g>
        <g>
          <rect
            x="183.1"
            y="-715.2"
            class="st80"
            width="51.3"
            height="1em"
            transform="scale(1,-1)"
            v-bind:style="{
              fontSize:
                fontSizeABpH(getRealTime.Status.FertilizerTank.Level[0].Value) +
                'px',
            }"
          />
          <rect
            x="234.5"
            y="-715.2"
            class="st81"
            width="27.1"
            height="1em"
            transform="scale(1,-1)"
            v-bind:style="{
              fontSize:
                fontSizeABpH(getRealTime.Status.FertilizerTank.Level[0].Value) +
                'px',
            }"
          />
          <rect
            x="167.3"
            y="-715.2"
            class="st81"
            width="15.9"
            height="1em"
            transform="scale(1,-1)"
            v-bind:style="{
              fontSize:
                fontSizeABpH(getRealTime.Status.FertilizerTank.Level[0].Value) +
                'px',
            }"
          />
        </g>
        <g>
          <rect
            x="703.5"
            y="561.5"
            :class="getRealTime.Pump[5].On ? 'st80' : 'st8'"
            width="5.1"
            height="25.4"
          />
          <path
            :class="getRealTime.Pump[5].On ? 'st80' : 'st8'"
            d="M708.6,541.6c0-4.8-4-8.6-9-8.6H689v4.9h10.6c2.1,0,3.8,1.7,3.8,3.7v19.9h5.1V541.6z"
          />
          <g>
            <rect
              x="211.9"
              y="556.6"
              :class="getRealTime.Pump[5].On ? 'st80' : 'st8'"
              width="5.1"
              height="40.5"
            />
            <path
              :class="getRealTime.Pump[5].On ? 'st80' : 'st8'"
              d="M220.9,533c-5,0-9,3.9-9,8.6v14.9h5.1v-14.9c0-2,1.7-3.7,3.8-3.7h0.9V533H220.9z"
            />
            <rect
              x="221.8"
              y="533"
              :class="getRealTime.Pump[5].On ? 'st80' : 'st8'"
              width="467.2"
              height="4.9"
            />
          </g>
        </g>
        <g v-if="getRealTime.Pump[5].On">
          <path
            class="st80"
            d="M708.6,597.4c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5s1.1-5.8,2.5-5.8    C707.5,591.6,708.6,596,708.6,597.4"
          />
          <path
            class="st80"
            d="M708.6,607.6c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5s1.1-5.8,2.5-5.8    C707.5,601.8,708.6,606.2,708.6,607.6"
          />
          <path
            class="st80"
            d="M708.6,617.9c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5s1.1-5.8,2.5-5.8    C707.5,612.1,708.6,616.5,708.6,617.9"
          />
          <path
            class="st80"
            d="M708.6,628.2c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5s1.1-5.8,2.5-5.8    C707.5,622.4,708.6,626.8,708.6,628.2"
          />
          <path
            class="st80"
            d="M708.6,638.4c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5s1.1-5.8,2.5-5.8    C707.5,632.6,708.6,637,708.6,638.4"
          />
          <path
            class="st80"
            d="M708.6,648.7c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5s1.1-5.8,2.5-5.8    C707.5,642.9,708.6,647.3,708.6,648.7"
          />
          <path
            class="st80"
            d="M708.6,658.9c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5s1.1-5.8,2.5-5.8    C707.5,653.1,708.6,657.5,708.6,658.9"
          />
          <path
            class="st80"
            d="M708.6,669.2c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5c0-1.4,1.1-5.8,2.5-5.8    C707.5,663.4,708.6,667.8,708.6,669.2"
          />
        </g>
      </g>
      <g>
        <g>
          <g>
            <polygon
              class="st68"
              points="316.9,596.6 305.6,596.6 295.4,610.3 311.3,610.3    "
            />
            <polygon
              class="st17"
              points="389.7,610.3 379.5,596.6 357.1,596.6 362.6,610.3    "
            />
            <polygon
              class="st69"
              points="362.6,610.3 357.1,596.6 342.6,596.6 337,596.6 316.9,596.6 311.3,610.3    "
            />
            <rect x="295.4" y="719.2" class="st70" width="15.9" height="26.6" />
            <rect x="295.4" y="714.8" class="st73" width="15.9" height="4.5" />
            <rect x="362.6" y="714.8" class="st73" width="27.1" height="4.5" />
            <rect x="362.6" y="719.2" class="st71" width="27.1" height="26.6" />
            <rect x="311.3" y="714.8" class="st74" width="51.3" height="4.5" />
            <polygon
              class="st72"
              points="311.3,719.2 311.3,745.9 337,745.9 342.6,745.9 362.6,745.9 362.6,719.2    "
            />
          </g>
          <g>
            <polygon
              class="st0"
              points="342.6,745.9 339.8,745.9 339.8,759 342.6,759 345.5,759 345.6,745.9    "
            />
            <polygon
              class="st0"
              points="348.2,745.9 348.1,759 353,759 354.2,745.9    "
            />
            <polygon
              class="st0"
              points="322.8,745.9 324.7,759 329.8,759 328.6,745.9    "
            />
            <polygon
              class="st0"
              points="356.8,745.9 355.6,759 360.7,759 362.6,745.9    "
            />
            <polygon
              class="st0"
              points="298.4,745.9 301.1,759 305.6,759 302.3,745.9    "
            />
            <polygon
              class="st0"
              points="304.9,745.9 308.3,759 313.9,759 311.3,745.9    "
            />
            <polygon
              class="st0"
              points="314,745.9 316.6,759 322,759 320.1,745.9    "
            />
            <polygon
              class="st0"
              points="331.2,745.9 332.4,759 337.3,759 337.2,745.9    "
            />
            <polygon
              class="st0"
              points="365.3,745.9 363.4,759 368.8,759 371.4,745.9    "
            />
            <polygon
              class="st0"
              points="374.1,745.9 371.5,759 377.1,759 380.4,745.9    "
            />
            <polygon
              class="st0"
              points="386.8,745.9 383.1,745.9 379.8,759 384.1,759    "
            />
            <polygon
              class="st4"
              points="302.3,745.9 305.6,759 308.3,759 304.9,745.9    "
            />
            <polygon
              class="st4"
              points="311.3,745.9 313.9,759 316.6,759 314,745.9    "
            />
            <polygon
              class="st4"
              points="320.1,745.9 322,759 324.7,759 322.8,745.9    "
            />
            <polygon
              class="st4"
              points="328.6,745.9 329.8,759 332.4,759 331.2,745.9    "
            />
            <polygon
              class="st4"
              points="337.2,745.9 337.2,759 339.8,759 339.8,745.9    "
            />
            <polygon
              class="st4"
              points="380.4,745.9 377.1,759 379.8,759 383.1,745.9    "
            />
            <polygon
              class="st4"
              points="371.4,745.9 368.8,759 371.5,759 374.1,745.9    "
            />
            <polygon
              class="st4"
              points="362.6,745.9 360.7,759 363.4,759 365.3,745.9    "
            />
            <polygon
              class="st4"
              points="354.2,745.9 353,759 355.6,759 356.8,745.9    "
            />
            <polygon
              class="st4"
              points="345.6,745.9 345.5,759 348.1,759 348.2,745.9    "
            />
          </g>
          <g>
            <rect
              x="311.6"
              y="610.3"
              class="st76"
              width="51.3"
              height="104.4"
            />
            <rect
              x="362.7"
              y="610.3"
              class="st12"
              width="27.1"
              height="104.4"
            />
            <rect
              x="295.6"
              y="610.3"
              class="st12"
              width="15.9"
              height="104.4"
            />
          </g>
        </g>
        <g>
          <rect
            x="311.6"
            y="-715.2"
            class="st82"
            width="51.3"
            height="1em"
            transform="scale(1,-1)"
            v-bind:style="{
              fontSize:
                fontSizeABpH(getRealTime.Status.pHTank.Level[0].Value) + 'px',
            }"
          />
          <rect
            x="362.7"
            y="-715.2"
            class="st83"
            width="27.1"
            height="1em"
            transform="scale(1,-1)"
            v-bind:style="{
              fontSize:
                fontSizeABpH(getRealTime.Status.pHTank.Level[0].Value) + 'px',
            }"
          />
          <rect
            x="295.6"
            y="-715.2"
            class="st83"
            width="15.9"
            height="1em"
            transform="scale(1,-1)"
            v-bind:style="{
              fontSize:
                fontSizeABpH(getRealTime.Status.pHTank.Level[0].Value) + 'px',
            }"
          />
        </g>
        <g>
          <g>
            <rect
              x="351.3"
              y="544"
              :class="getRealTime.Pump[6].On ? 'st82' : 'st8'"
              width="352"
              height="5.1"
            />
            <rect
              x="339.5"
              y="565"
              :class="getRealTime.Pump[6].On ? 'st82' : 'st8'"
              width="5.1"
              height="31.6"
            />
            <path
              :class="getRealTime.Pump[6].On ? 'st82' : 'st8'"
              d="M348.5,544c-5,0-9,4-9,9V565h5.1v-12.1c0-2.1,1.7-3.8,3.8-3.8h2.8V544H348.5z"
            />
          </g>
          <rect
            x="714.7"
            y="565"
            :class="getRealTime.Pump[6].On ? 'st82' : 'st8'"
            width="5.1"
            height="18.5"
          />
          <path
            :class="getRealTime.Pump[6].On ? 'st82' : 'st8'"
            d="M719.8,552.9c0-4.9-4-9-9-9h-7.5v5.1h7.5c2.1,0,3.8,1.7,3.8,3.8V565h5.1V552.9z"
          />
        </g>
        <g v-if="getRealTime.Pump[6].On">
          <path
            class="st82"
            d="M719.6,595.6c0,1.4-1.1,2.6-2.4,2.6c-1.3,0-2.4-1.2-2.4-2.6c0-1.4,1.1-5.9,2.4-5.9    C718.6,589.7,719.6,594.2,719.6,595.6"
          />
          <path
            class="st82"
            d="M719.6,606.1c0,1.4-1.1,2.6-2.4,2.6c-1.3,0-2.4-1.2-2.4-2.6c0-1.4,1.1-5.9,2.4-5.9    C718.6,600.2,719.6,604.7,719.6,606.1"
          />
          <path
            class="st82"
            d="M719.6,616.6c0,1.4-1.1,2.6-2.4,2.6c-1.3,0-2.4-1.2-2.4-2.6c0-1.4,1.1-5.9,2.4-5.9    C718.6,610.7,719.6,615.2,719.6,616.6"
          />
          <path
            class="st82"
            d="M719.6,627.1c0,1.4-1.1,2.6-2.4,2.6c-1.3,0-2.4-1.2-2.4-2.6c0-1.4,1.1-5.9,2.4-5.9    C718.6,621.2,719.6,625.7,719.6,627.1"
          />
          <path
            class="st82"
            d="M719.6,637.6c0,1.4-1.1,2.6-2.4,2.6c-1.3,0-2.4-1.2-2.4-2.6c0-1.4,1.1-5.9,2.4-5.9    C718.6,631.7,719.6,636.2,719.6,637.6"
          />
          <path
            class="st82"
            d="M719.6,648.1c0,1.4-1.1,2.6-2.4,2.6c-1.3,0-2.4-1.2-2.4-2.6c0-1.4,1.1-5.9,2.4-5.9    C718.6,642.1,719.6,646.6,719.6,648.1"
          />
          <path
            class="st82"
            d="M719.6,658.5c0,1.4-1.1,2.6-2.4,2.6c-1.3,0-2.4-1.2-2.4-2.6c0-1.4,1.1-5.9,2.4-5.9    C718.6,652.6,719.6,657.1,719.6,658.5"
          />
          <path
            class="st82"
            d="M719.6,669c0,1.4-1.1,2.6-2.4,2.6c-1.3,0-2.4-1.2-2.4-2.6s1.1-5.9,2.4-5.9    C718.6,663.1,719.6,667.6,719.6,669"
          />
        </g>
      </g>
      <g>
        <g>
          <rect
            x="1422.4"
            y="381.5"
            :class="getRealTime.Valve[1].On ? 'st30' : 'st8'"
            width="63.5"
            height="9.1"
          />
          <g>
            <rect
              x="1485.9"
              y="380.3"
              :class="getRealTime.Valve[1].On ? 'st64' : 'st84'"
              width="38.6"
              height="11.5"
            />
            <rect x="1498" y="376.5" class="st12" width="14.3" height="3.7" />
            <rect x="1503.3" y="364.9" class="st12" width="3.8" height="11.7" />
            <polygon
              points="1503.1,367.8 1493.4,364.8 1493.4,373.5 1503.1,373.5    "
              :class="getRealTime.Valve[1].On ? 'st64' : 'st84'"
            />
            <polygon
              points="1507.3,367.8 1517,364.8 1517,373.5 1507.3,373.5    "
              :class="getRealTime.Valve[1].On ? 'st64' : 'st84'"
            />
            <rect
              x="1503.1"
              y="367.8"
              :class="getRealTime.Valve[1].On ? 'st64' : 'st84'"
              width="4.2"
              height="5.8"
            />
          </g>
        </g>
        <g>
          <rect
            x="1422.3"
            y="261.6"
            :class="getRealTime.Valve[2].On ? 'st30' : 'st8'"
            width="62.3"
            height="9.1"
          />
          <g>
            <rect
              x="1484.6"
              y="260.5"
              :class="getRealTime.Valve[2].On ? 'st64' : 'st84'"
              width="38.6"
              height="11.5"
            />
            <rect x="1496.7" y="256.8" class="st12" width="14.3" height="3.7" />
            <rect x="1502" y="245.1" class="st12" width="3.8" height="11.7" />
            <polygon
              :class="getRealTime.Valve[2].On ? 'st64' : 'st84'"
              points="1501.8,248 1492.1,245 1492.1,253.8 1501.8,253.8    "
            />
            <polygon
              :class="getRealTime.Valve[2].On ? 'st64' : 'st84'"
              points="1506,248 1515.7,245 1515.7,253.8 1506,253.8    "
            />
            <rect
              x="1501.8"
              y="248"
              :class="getRealTime.Valve[2].On ? 'st64' : 'st84'"
              width="4.2"
              height="5.8"
            />
          </g>
        </g>
        <g>
          <rect
            x="1423.1"
            y="145.2"
            :class="getRealTime.Valve[3].On ? 'st30' : 'st8'"
            width="61.5"
            height="9.1"
          />
          <g>
            <rect
              x="1484.6"
              y="143.9"
              :class="getRealTime.Valve[3].On ? 'st64' : 'st84'"
              width="38.6"
              height="11.5"
            />
            <rect x="1496.8" y="140.2" class="st12" width="14.3" height="3.7" />
            <rect x="1502" y="128.5" class="st12" width="3.8" height="11.7" />
            <polygon
              :class="getRealTime.Valve[3].On ? 'st64' : 'st84'"
              points="1501.8,131.4 1492.2,128.4 1492.2,137.2 1501.8,137.2    "
            />
            <polygon
              :class="getRealTime.Valve[3].On ? 'st64' : 'st84'"
              points="1506,131.4 1515.7,128.4 1515.7,137.2 1506,137.2   "
            />
            <rect
              x="1501.8"
              y="131.4"
              :class="getRealTime.Valve[3].On ? 'st64' : 'st84'"
              width="4.2"
              height="5.8"
            />
          </g>
        </g>
      </g>
      <g>
        <path
          :class="
            getRealTime.Valve[6].On ||
            getRealTime.Valve[7].On ||
            getRealTime.Valve[8].On
              ? 'st30'
              : 'st8'
          "
          d="M623.7,472.5c0,1.8,1.5,3.3,3.3,3.3h230.8c1.4,0,2.8,1.1,2.8,2.8l-0.1,106.2h7.9V475.3c0-5.1-2.9-7.4-8.6-7.4   h-236V472.5z"
        />
        <g>
          <rect
            :class="
              getRealTime.Valve[16].On || getRealTime.Valve[1].On
                ? 'st30'
                : 'st8'
            "
            x="651.4"
            y="380.8"
            width="87.8"
            height="9.1"
          />
          <g>
            <rect
              x="651.4"
              y="380"
              :class="getRealTime.Valve[6].On ? 'st64' : 'st67'"
              width="38.6"
              height="11.5"
            />
            <rect x="663.5" y="376.2" class="st12" width="14.3" height="3.7" />
            <rect x="668.8" y="364.6" class="st12" width="3.8" height="11.7" />
            <polygon
              :class="getRealTime.Valve[6].On ? 'st64' : 'st67'"
              points="672.6,367.5 682.2,364.5 682.2,373.2 672.6,373.2    "
            />
            <polygon
              :class="getRealTime.Valve[6].On ? 'st64' : 'st67'"
              points="668.3,367.5 658.7,364.5 658.7,373.2 668.3,373.2    "
            />
            <rect
              :class="getRealTime.Valve[6].On ? 'st64' : 'st67'"
              x="668.3"
              y="367.5"
              width="4.2"
              height="5.8"
            />
          </g>
        </g>
        <g>
          <rect
            x="651.4"
            y="263.1"
            :class="
              getRealTime.Valve[17].On || getRealTime.Valve[2].On
                ? 'st30'
                : 'st8'
            "
            width="88.5"
            height="9.1"
          />
          <g>
            <rect
              x="651.4"
              y="262.3"
              :class="getRealTime.Valve[7].On ? 'st64' : 'st67'"
              width="38.6"
              height="11.5"
            />
            <rect x="663.5" y="258.6" class="st12" width="14.3" height="3.7" />
            <rect x="668.8" y="246.9" class="st12" width="3.8" height="11.7" />
            <polygon
              :class="getRealTime.Valve[7].On ? 'st64' : 'st67'"
              points="672.6,249.8 682.2,246.8 682.2,255.6 672.6,255.6    "
            />
            <polygon
              :class="getRealTime.Valve[7].On ? 'st64' : 'st67'"
              points="668.3,249.8 658.7,246.8 658.7,255.6 668.3,255.6    "
            />
            <rect
              x="668.3"
              y="249.8"
              :class="getRealTime.Valve[7].On ? 'st64' : 'st67'"
              width="4.2"
              height="5.8"
            />
          </g>
        </g>
        <g>
          <rect
            x="651.4"
            y="145.2"
            :class="
              getRealTime.Valve[18].On || getRealTime.Valve[3].On
                ? 'st30'
                : 'st8'
            "
            width="88.6"
            height="9.1"
          />
          <g>
            <rect
              x="651.5"
              y="143.9"
              :class="getRealTime.Valve[8].On ? 'st64' : 'st84'"
              width="38.6"
              height="11.5"
            />
            <rect x="663.7" y="140.2" class="st12" width="14.3" height="3.7" />
            <rect x="668.9" y="128.5" class="st12" width="3.8" height="11.7" />
            <polygon
              :class="getRealTime.Valve[8].On ? 'st64' : 'st84'"
              points="672.7,131.4 682.4,128.4 682.4,137.2 672.7,137.2    "
            />
            <polygon
              :class="getRealTime.Valve[8].On ? 'st64' : 'st84'"
              points="668.5,131.4 658.8,128.4 658.8,137.2 668.5,137.2    "
            />
            <rect
              x="668.5"
              y="131.4"
              :class="getRealTime.Valve[8].On ? 'st64' : 'st84'"
              width="4.2"
              height="5.8"
            />
          </g>
        </g>
        <g>
          <polygon
            class="st8"
            points="623.8,380.9 623.7,467.9 631.7,467.9 631.4,390 651.4,390 651.4,380.9   "
          />
          <path
            class="st8"
            d="M631.7,467.9l-0.2-309.6c0-2.2,1.8-4,4-4h16v-9.1l-19.4-0.1c-4.5,0-8.2,3.6-8.2,8.2l-0.1,314.6H631.7z"
          />
          <polygon
            class="st8"
            points="623.8,263.6 623.7,467.9 631.7,467.9 631.4,272.7 651.4,272.7 651.4,263.6   "
          />
        </g>
        <g>
          <polygon
            v-if="getRealTime.Valve[6].On"
            class="st30"
            points="623.8,380.9 623.7,467.9 631.7,467.9 631.4,390 651.4,390 651.4,380.9   "
          />
          <polygon
            v-if="getRealTime.Valve[7].On"
            class="st30"
            points="623.8,263.6 623.7,467.9 631.7,467.9 631.4,272.7 651.4,272.7 651.4,263.6   "
          />
          <path
            v-if="getRealTime.Valve[8].On"
            class="st30"
            d="M631.7,467.9l-0.2-309.6c0-2.2,1.8-4,4-4h16v-9.1l-19.4-0.1c-4.5,0-8.2,3.6-8.2,8.2l-0.1,314.6H631.7z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            :class="getRealTime.Valve[18].On ? 'st30' : 'st8'"
            d="M1443.3,215.1h-52.3c-2.1,0-3.8-1.7-3.8-3.8v-48.4l8.9,0.2v38.8c0,2.3,1.9,4.2,4.2,4.2h43V215.1z"
          />
          <g>
            <rect
              x="1404.7"
              y="204.6"
              :class="getRealTime.Valve[18].On ? 'st64' : 'st67'"
              width="38.6"
              height="11.5"
            />
            <rect x="1416.9" y="200.9" class="st12" width="14.3" height="3.7" />
            <rect x="1422.1" y="189.2" class="st12" width="3.8" height="11.7" />
            <polygon
              :class="getRealTime.Valve[18].On ? 'st64' : 'st67'"
              points="1421.9,192.1 1412.2,189.1 1412.2,197.9 1421.9,197.9    "
            />
            <polygon
              :class="getRealTime.Valve[18].On ? 'st64' : 'st67'"
              points="1426.1,192.1 1435.8,189.1 1435.8,197.9 1426.1,197.9    "
            />
            <rect
              x="1421.9"
              y="192.1"
              :class="getRealTime.Valve[18].On ? 'st64' : 'st67'"
              width="4.2"
              height="5.8"
            />
          </g>
        </g>
        <g>
          <path
            :class="getRealTime.Valve[17].On ? 'st30' : 'st8'"
            d="M1443.3,333h-50.9c-2.9,0-5.2-2.3-5.2-5.2v-47l8.9,0.2v38.6c0,2.4,2,4.4,4.4,4.4h42.8V333z"
          />
          <g>
            <rect
              x="1404.7"
              y="322.5"
              :class="getRealTime.Valve[17].On ? 'st64' : 'st67'"
              width="38.6"
              height="11.5"
            />
            <rect x="1416.9" y="318.8" class="st12" width="14.3" height="3.7" />
            <rect x="1422.1" y="307.1" class="st12" width="3.8" height="11.7" />
            <polygon
              :class="getRealTime.Valve[17].On ? 'st64' : 'st67'"
              points="1421.9,310 1412.2,307 1412.2,315.8 1421.9,315.8    "
            />
            <polygon
              :class="getRealTime.Valve[17].On ? 'st64' : 'st67'"
              points="1426.1,310 1435.8,307 1435.8,315.8 1426.1,315.8    "
            />
            <rect
              x="1421.9"
              y="310"
              :class="getRealTime.Valve[17].On ? 'st64' : 'st67'"
              width="4.2"
              height="5.8"
            />
          </g>
        </g>
        <g>
          <path
            :class="getRealTime.Valve[16].On ? 'st30' : 'st8'"
            d="M1443.3,452.1H1392c-2.6,0-4.7-2.1-4.7-4.7v-47.5l8.9,0.2v38.9c0,2.3,1.9,4.1,4.1,4.1h43V452.1z"
          />
          <g>
            <rect
              x="1404.7"
              y="441.6"
              :class="getRealTime.Valve[16].On ? 'st64' : 'st67'"
              width="38.6"
              height="11.5"
            />
            <g>
              <rect
                x="1417.2"
                y="437.9"
                class="st12"
                width="14.3"
                height="3.7"
              />
              <rect
                x="1422.4"
                y="426.2"
                class="st12"
                width="3.8"
                height="11.7"
              />
              <polygon
                :class="getRealTime.Valve[16].On ? 'st64' : 'st67'"
                points="1422.2,429.1 1412.5,426.1 1412.5,434.9 1422.2,434.9     "
              />
              <polygon
                :class="getRealTime.Valve[16].On ? 'st64' : 'st67'"
                points="1426.4,429.1 1436.1,426.1 1436.1,434.9 1426.4,434.9     "
              />
              <rect
                x="1422.2"
                y="429.1"
                :class="getRealTime.Valve[16].On ? 'st64' : 'st67'"
                width="4.2"
                height="5.8"
              />
            </g>
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1382.6,339c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1382.2,340.2,1382.7,339.6,1382.6,339"
                />
                <polygon
                  class="st87"
                  points="1378.1,370.6 1379.3,370.6 1379.3,366.2 1377.7,366.2      "
                />
                <path
                  class="st87"
                  d="M1378.7,347c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1378.8,349,1378.3,347.8,1378.7,347"
                />
                <path
                  class="st88"
                  d="M1378.2,345.7c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1378.1,347.4,1378.5,346.4,1378.2,345.7"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_4_"
                    d="M1392.9,342.6c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1393.2,342.6,1393,342.6,1392.9,342.6"
                  />
                </defs>
                <clipPath id="SVGID_5_">
                  <use xlink:href="#SVGID_4_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_6_"
                  gradientUnits="userSpaceOnUse"
                  x1="-76.7549"
                  y1="835.36"
                  x2="-75.769"
                  y2="835.36"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st89"
                  points="1366.1,349.6 1391.8,334.7 1408.4,363.6 1382.7,378.4      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_7_"
                    d="M1361.4,344.4c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C1362.9,342.6,1361.8,343.3,1361.4,344.4"
                  />
                </defs>
                <clipPath id="SVGID_8_">
                  <use xlink:href="#SVGID_7_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_9_"
                  gradientUnits="userSpaceOnUse"
                  x1="-59.9877"
                  y1="838.7171"
                  x2="-59.0018"
                  y2="838.7171"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st90"
                  points="1365.6,334.7 1391.3,349.6 1374.7,378.4 1348.9,363.6      "
                />
              </g>
              <polygon
                class="st87"
                points="1376.9,368.7 1377.6,370.6 1378.5,375.6 1379.8,375.6 1380.7,370.6 1381.4,368.7     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1339.7,339c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1339.3,340.2,1339.8,339.6,1339.7,339"
                />
                <polygon
                  class="st87"
                  points="1335.1,370.6 1336.4,370.6 1336.4,366.2 1334.8,366.2      "
                />
                <path
                  class="st87"
                  d="M1335.7,347c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1335.9,349,1335.4,347.8,1335.7,347"
                />
                <path
                  class="st88"
                  d="M1335.3,345.7c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1335.1,347.4,1335.6,346.4,1335.3,345.7"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_10_"
                    d="M1349.9,342.6c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1350.3,342.6,1350.1,342.6,1349.9,342.6"
                  />
                </defs>
                <clipPath id="SVGID_11_">
                  <use xlink:href="#SVGID_10_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_12_"
                  gradientUnits="userSpaceOnUse"
                  x1="-78.062"
                  y1="836.1146"
                  x2="-77.0761"
                  y2="836.1146"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st91"
                  points="1323.1,349.6 1348.8,334.7 1365.5,363.6 1339.8,378.4      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_13_"
                    d="M1318.5,344.4c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C1319.9,342.6,1318.9,343.3,1318.5,344.4"
                  />
                </defs>
                <clipPath id="SVGID_14_">
                  <use xlink:href="#SVGID_13_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_15_"
                  gradientUnits="userSpaceOnUse"
                  x1="-61.2948"
                  y1="837.9625"
                  x2="-60.3089"
                  y2="837.9625"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st92"
                  points="1322.7,334.7 1348.4,349.6 1331.7,378.4 1306,363.6      "
                />
              </g>
              <polygon
                class="st87"
                points="1334,368.7 1334.7,370.6 1335.6,375.6 1336.9,375.6 1337.8,370.6 1338.5,368.7     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1295.4,339c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1295,340.2,1295.5,339.6,1295.4,339"
                />
                <polygon
                  class="st87"
                  points="1290.9,370.6 1292.1,370.6 1292.1,366.2 1290.6,366.2      "
                />
                <path
                  class="st87"
                  d="M1291.5,347c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1291.6,349,1291.1,347.8,1291.5,347"
                />
                <path
                  class="st88"
                  d="M1291,345.7c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1290.9,347.4,1291.3,346.4,1291,345.7"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_16_"
                    d="M1305.7,342.6c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1306,342.6,1305.8,342.6,1305.7,342.6"
                  />
                </defs>
                <clipPath id="SVGID_17_">
                  <use xlink:href="#SVGID_16_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_18_"
                  gradientUnits="userSpaceOnUse"
                  x1="-79.4099"
                  y1="836.8929"
                  x2="-78.424"
                  y2="836.8929"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st93"
                  points="1278.9,349.6 1304.6,334.7 1321.2,363.6 1295.5,378.4      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_19_"
                    d="M1274.2,344.4c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C1275.7,342.6,1274.6,343.3,1274.2,344.4"
                  />
                </defs>
                <clipPath id="SVGID_20_">
                  <use xlink:href="#SVGID_19_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_21_"
                  gradientUnits="userSpaceOnUse"
                  x1="-62.6427"
                  y1="837.1843"
                  x2="-61.6568"
                  y2="837.1843"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st94"
                  points="1278.4,334.7 1304.1,349.6 1287.5,378.4 1261.8,363.6      "
                />
              </g>
              <polygon
                class="st87"
                points="1289.7,368.7 1290.4,370.6 1291.4,375.6 1292.6,375.6 1293.5,370.6 1294.2,368.7     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1252.5,339c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1252.1,340.2,1252.6,339.6,1252.5,339"
                />
                <polygon
                  class="st87"
                  points="1247.9,370.6 1249.2,370.6 1249.2,366.2 1247.6,366.2      "
                />
                <path
                  class="st87"
                  d="M1248.6,347c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1248.7,349,1248.2,347.8,1248.6,347"
                />
                <path
                  class="st88"
                  d="M1248.1,345.7c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1248,347.4,1248.4,346.4,1248.1,345.7"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_22_"
                    d="M1262.7,342.6c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1263.1,342.6,1262.9,342.6,1262.7,342.6"
                  />
                </defs>
                <clipPath id="SVGID_23_">
                  <use xlink:href="#SVGID_22_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_24_"
                  gradientUnits="userSpaceOnUse"
                  x1="-80.717"
                  y1="837.6475"
                  x2="-79.7311"
                  y2="837.6475"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st95"
                  points="1235.9,349.6 1261.6,334.7 1278.3,363.6 1252.6,378.4      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_25_"
                    d="M1231.3,344.4c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C1232.8,342.6,1231.7,343.3,1231.3,344.4"
                  />
                </defs>
                <clipPath id="SVGID_26_">
                  <use xlink:href="#SVGID_25_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_27_"
                  gradientUnits="userSpaceOnUse"
                  x1="-63.9498"
                  y1="836.4296"
                  x2="-62.9639"
                  y2="836.4296"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st96"
                  points="1235.5,334.7 1261.2,349.6 1244.5,378.4 1218.8,363.6      "
                />
              </g>
              <polygon
                class="st87"
                points="1246.8,368.7 1247.5,370.6 1248.4,375.6 1249.7,375.6 1250.6,370.6 1251.3,368.7     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1209.6,339c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1209.2,340.2,1209.7,339.6,1209.6,339"
                />
                <polygon
                  class="st87"
                  points="1205,370.6 1206.3,370.6 1206.3,366.2 1204.7,366.2      "
                />
                <path
                  class="st87"
                  d="M1205.6,347c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1205.8,349,1205.3,347.8,1205.6,347"
                />
                <path
                  class="st88"
                  d="M1205.2,345.7c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1205,347.4,1205.5,346.4,1205.2,345.7"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_28_"
                    d="M1219.8,342.6c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1220.2,342.6,1220,342.6,1219.8,342.6"
                  />
                </defs>
                <clipPath id="SVGID_29_">
                  <use xlink:href="#SVGID_28_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_30_"
                  gradientUnits="userSpaceOnUse"
                  x1="-82.0241"
                  y1="838.4022"
                  x2="-81.0381"
                  y2="838.4022"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st97"
                  points="1193,349.6 1218.7,334.7 1235.4,363.6 1209.7,378.4      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_31_"
                    d="M1188.4,344.4c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C1189.8,342.6,1188.8,343.3,1188.4,344.4"
                  />
                </defs>
                <clipPath id="SVGID_32_">
                  <use xlink:href="#SVGID_31_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_33_"
                  gradientUnits="userSpaceOnUse"
                  x1="-65.2569"
                  y1="835.675"
                  x2="-64.2709"
                  y2="835.675"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st98"
                  points="1192.6,334.7 1218.3,349.6 1201.6,378.4 1175.9,363.6      "
                />
              </g>
              <polygon
                class="st87"
                points="1203.9,368.7 1204.6,370.6 1205.5,375.6 1206.8,375.6 1207.7,370.6 1208.4,368.7     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1165.3,339c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1164.9,340.2,1165.4,339.6,1165.3,339"
                />
                <polygon
                  class="st87"
                  points="1160.7,370.6 1162,370.6 1162,366.2 1160.4,366.2      "
                />
                <path
                  class="st87"
                  d="M1161.4,347c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1161.5,349,1161,347.8,1161.4,347"
                />
                <path
                  class="st88"
                  d="M1160.9,345.7c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1160.8,347.4,1161.2,346.4,1160.9,345.7"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_34_"
                    d="M1175.5,342.6c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1175.9,342.6,1175.7,342.6,1175.5,342.6"
                  />
                </defs>
                <clipPath id="SVGID_35_">
                  <use xlink:href="#SVGID_34_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_36_"
                  gradientUnits="userSpaceOnUse"
                  x1="-83.372"
                  y1="839.1804"
                  x2="-82.3861"
                  y2="839.1804"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st99"
                  points="1148.7,349.6 1174.5,334.7 1191.1,363.6 1165.4,378.4      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_37_"
                    d="M1144.1,344.4c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C1145.6,342.6,1144.5,343.3,1144.1,344.4"
                  />
                </defs>
                <clipPath id="SVGID_38_">
                  <use xlink:href="#SVGID_37_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_39_"
                  gradientUnits="userSpaceOnUse"
                  x1="-66.6048"
                  y1="834.8967"
                  x2="-65.6189"
                  y2="834.8967"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st100"
                  points="1148.3,334.7 1174,349.6 1157.4,378.4 1131.6,363.6      "
                />
              </g>
              <polygon
                class="st87"
                points="1159.6,368.7 1160.3,370.6 1161.2,375.6 1162.5,375.6 1163.4,370.6 1164.1,368.7     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1123.7,339c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1123.3,340.2,1123.8,339.6,1123.7,339"
                />
                <polygon
                  class="st87"
                  points="1119.2,370.6 1120.4,370.6 1120.4,366.2 1118.9,366.2      "
                />
                <path
                  class="st87"
                  d="M1119.8,347c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1119.9,349,1119.4,347.8,1119.8,347"
                />
                <path
                  class="st88"
                  d="M1119.3,345.7c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1119.2,347.4,1119.6,346.4,1119.3,345.7"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_40_"
                    d="M1134,342.6c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1134.3,342.6,1134.1,342.6,1134,342.6"
                  />
                </defs>
                <clipPath id="SVGID_41_">
                  <use xlink:href="#SVGID_40_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_42_"
                  gradientUnits="userSpaceOnUse"
                  x1="-84.6382"
                  y1="839.9114"
                  x2="-83.6523"
                  y2="839.9114"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st101"
                  points="1107.2,349.6 1132.9,334.7 1149.5,363.6 1123.8,378.4      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_43_"
                    d="M1102.5,344.4c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C1104,342.6,1102.9,343.3,1102.5,344.4"
                  />
                </defs>
                <clipPath id="SVGID_44_">
                  <use xlink:href="#SVGID_43_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_45_"
                  gradientUnits="userSpaceOnUse"
                  x1="-67.871"
                  y1="834.1657"
                  x2="-66.8851"
                  y2="834.1657"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st102"
                  points="1106.7,334.7 1132.4,349.6 1115.8,378.4 1090.1,363.6      "
                />
              </g>
              <polygon
                class="st87"
                points="1118,368.7 1118.8,370.6 1119.7,375.6 1120.9,375.6 1121.8,370.6 1122.6,368.7     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1080.8,339c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1080.4,340.2,1080.9,339.6,1080.8,339"
                />
                <polygon
                  class="st87"
                  points="1076.2,370.6 1077.5,370.6 1077.5,366.2 1075.9,366.2      "
                />
                <path
                  class="st87"
                  d="M1076.9,347c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1077,349,1076.5,347.8,1076.9,347"
                />
                <path
                  class="st88"
                  d="M1076.4,345.7c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1076.3,347.4,1076.7,346.4,1076.4,345.7"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_46_"
                    d="M1091,342.6c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1091.4,342.6,1091.2,342.6,1091,342.6"
                  />
                </defs>
                <clipPath id="SVGID_47_">
                  <use xlink:href="#SVGID_46_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_48_"
                  gradientUnits="userSpaceOnUse"
                  x1="-85.9453"
                  y1="840.6661"
                  x2="-84.9594"
                  y2="840.6661"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st103"
                  points="1064.2,349.6 1089.9,334.7 1106.6,363.6 1080.9,378.4      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_49_"
                    d="M1059.6,344.4c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C1061.1,342.6,1060,343.3,1059.6,344.4"
                  />
                </defs>
                <clipPath id="SVGID_50_">
                  <use xlink:href="#SVGID_49_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_51_"
                  gradientUnits="userSpaceOnUse"
                  x1="-69.1781"
                  y1="833.411"
                  x2="-68.1922"
                  y2="833.411"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st104"
                  points="1063.8,334.7 1089.5,349.6 1072.8,378.4 1047.1,363.6      "
                />
              </g>
              <polygon
                class="st87"
                points="1075.1,368.7 1075.8,370.6 1076.7,375.6 1078,375.6 1078.9,370.6 1079.6,368.7     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1036.5,339c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1036.1,340.2,1036.6,339.6,1036.5,339"
                />
                <polygon
                  class="st87"
                  points="1032,370.6 1033.2,370.6 1033.2,366.2 1031.7,366.2      "
                />
                <path
                  class="st87"
                  d="M1032.6,347c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1032.7,349,1032.2,347.8,1032.6,347"
                />
                <path
                  class="st88"
                  d="M1032.1,345.7c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1032,347.4,1032.4,346.4,1032.1,345.7"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_52_"
                    d="M1046.8,342.6c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1047.1,342.6,1046.9,342.6,1046.8,342.6"
                  />
                </defs>
                <clipPath id="SVGID_53_">
                  <use xlink:href="#SVGID_52_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_54_"
                  gradientUnits="userSpaceOnUse"
                  x1="-87.2932"
                  y1="841.4443"
                  x2="-86.3073"
                  y2="841.4443"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st105"
                  points="1020,349.6 1045.7,334.7 1062.3,363.6 1036.6,378.4      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_55_"
                    d="M1015.4,344.4c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C1016.8,342.6,1015.7,343.3,1015.4,344.4"
                  />
                </defs>
                <clipPath id="SVGID_56_">
                  <use xlink:href="#SVGID_55_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_57_"
                  gradientUnits="userSpaceOnUse"
                  x1="-70.526"
                  y1="832.6328"
                  x2="-69.5401"
                  y2="832.6328"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st106"
                  points="1019.5,334.7 1045.2,349.6 1028.6,378.4 1002.9,363.6      "
                />
              </g>
              <polygon
                class="st87"
                points="1030.9,368.7 1031.6,370.6 1032.5,375.6 1033.7,375.6 1034.7,370.6 1035.4,368.7     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M993.6,339c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C993.2,340.2,993.7,339.6,993.6,339"
                />
                <polygon
                  class="st87"
                  points="989,370.6 990.3,370.6 990.3,366.2 988.7,366.2      "
                />
                <path
                  class="st87"
                  d="M989.7,347c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C989.8,349,989.3,347.8,989.7,347"
                />
                <path
                  class="st88"
                  d="M989.2,345.7c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C989.1,347.4,989.5,346.4,989.2,345.7"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_58_"
                    d="M1003.9,342.6c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1004.2,342.6,1004,342.6,1003.9,342.6"
                  />
                </defs>
                <clipPath id="SVGID_59_">
                  <use xlink:href="#SVGID_58_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_60_"
                  gradientUnits="userSpaceOnUse"
                  x1="-88.6003"
                  y1="842.1989"
                  x2="-87.6144"
                  y2="842.1989"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st107"
                  points="977.1,349.6 1002.8,334.7 1019.4,363.6 993.7,378.4      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_61_"
                    d="M972.4,344.4c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C973.9,342.6,972.8,343.3,972.4,344.4"
                  />
                </defs>
                <clipPath id="SVGID_62_">
                  <use xlink:href="#SVGID_61_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_63_"
                  gradientUnits="userSpaceOnUse"
                  x1="-71.8331"
                  y1="831.8782"
                  x2="-70.8472"
                  y2="831.8782"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st108"
                  points="976.6,334.7 1002.3,349.6 985.7,378.4 959.9,363.6      "
                />
              </g>
              <polygon
                class="st87"
                points="987.9,368.7 988.6,370.6 989.5,375.6 990.8,375.6 991.7,370.6 992.4,368.7     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M950.7,339c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C950.3,340.2,950.8,339.6,950.7,339"
                />
                <polygon
                  class="st87"
                  points="946.1,370.6 947.4,370.6 947.4,366.2 945.8,366.2      "
                />
                <path
                  class="st87"
                  d="M946.7,347c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C946.9,349,946.4,347.8,946.7,347"
                />
                <path
                  class="st88"
                  d="M946.3,345.7c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C946.1,347.4,946.6,346.4,946.3,345.7"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_64_"
                    d="M960.9,342.6c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C961.3,342.6,961.1,342.6,960.9,342.6"
                  />
                </defs>
                <clipPath id="SVGID_65_">
                  <use xlink:href="#SVGID_64_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_66_"
                  gradientUnits="userSpaceOnUse"
                  x1="-89.9074"
                  y1="842.9536"
                  x2="-88.9215"
                  y2="842.9536"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st109"
                  points="934.1,349.6 959.8,334.7 976.5,363.6 950.8,378.4      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_67_"
                    d="M929.5,344.4c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C930.9,342.6,929.9,343.3,929.5,344.4"
                  />
                </defs>
                <clipPath id="SVGID_68_">
                  <use xlink:href="#SVGID_67_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_69_"
                  gradientUnits="userSpaceOnUse"
                  x1="-73.1402"
                  y1="831.1235"
                  x2="-72.1543"
                  y2="831.1235"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st110"
                  points="933.7,334.7 959.4,349.6 942.7,378.4 917,363.6      "
                />
              </g>
              <polygon
                class="st87"
                points="945,368.7 945.7,370.6 946.6,375.6 947.9,375.6 948.8,370.6 949.5,368.7     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M906.4,339c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C906,340.2,906.5,339.6,906.4,339"
                />
                <polygon
                  class="st87"
                  points="901.9,370.6 903.1,370.6 903.1,366.2 901.6,366.2      "
                />
                <path
                  class="st87"
                  d="M902.5,347c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C902.6,349,902.1,347.8,902.5,347"
                />
                <path
                  class="st88"
                  d="M902,345.7c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C901.9,347.4,902.3,346.4,902,345.7"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_70_"
                    d="M916.7,342.6c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C917,342.6,916.8,342.6,916.7,342.6"
                  />
                </defs>
                <clipPath id="SVGID_71_">
                  <use xlink:href="#SVGID_70_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_72_"
                  gradientUnits="userSpaceOnUse"
                  x1="-91.2553"
                  y1="843.7318"
                  x2="-90.2694"
                  y2="843.7318"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st111"
                  points="889.9,349.6 915.6,334.7 932.2,363.6 906.5,378.4      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_73_"
                    d="M885.2,344.4c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C886.7,342.6,885.6,343.3,885.2,344.4"
                  />
                </defs>
                <clipPath id="SVGID_74_">
                  <use xlink:href="#SVGID_73_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_75_"
                  gradientUnits="userSpaceOnUse"
                  x1="-74.4881"
                  y1="830.3453"
                  x2="-73.5022"
                  y2="830.3453"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st112"
                  points="889.4,334.7 915.1,349.6 898.5,378.4 872.8,363.6      "
                />
              </g>
              <polygon
                class="st87"
                points="900.7,368.7 901.4,370.6 902.4,375.6 903.6,375.6 904.5,370.6 905.2,368.7     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M864.9,339c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C864.4,340.2,864.9,339.6,864.9,339"
                />
                <polygon
                  class="st87"
                  points="860.3,370.6 861.6,370.6 861.6,366.2 860,366.2      "
                />
                <path
                  class="st87"
                  d="M860.9,347c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C861,349,860.6,347.8,860.9,347"
                />
                <path
                  class="st88"
                  d="M860.4,345.7c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C860.3,347.4,860.7,346.4,860.4,345.7"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_76_"
                    d="M875.1,342.6c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C875.4,342.6,875.3,342.6,875.1,342.6"
                  />
                </defs>
                <clipPath id="SVGID_77_">
                  <use xlink:href="#SVGID_76_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_78_"
                  gradientUnits="userSpaceOnUse"
                  x1="-92.5215"
                  y1="844.4628"
                  x2="-91.5356"
                  y2="844.4628"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st113"
                  points="848.3,349.6 874,334.7 890.7,363.6 864.9,378.4      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_79_"
                    d="M843.7,344.4c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C845.1,342.6,844,343.3,843.7,344.4"
                  />
                </defs>
                <clipPath id="SVGID_80_">
                  <use xlink:href="#SVGID_79_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_81_"
                  gradientUnits="userSpaceOnUse"
                  x1="-75.7543"
                  y1="829.6143"
                  x2="-74.7684"
                  y2="829.6143"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st114"
                  points="847.8,334.7 873.5,349.6 856.9,378.4 831.2,363.6      "
                />
              </g>
              <polygon
                class="st87"
                points="859.2,368.7 859.9,370.6 860.8,375.6 862,375.6 863,370.6 863.7,368.7     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M821.9,339c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C821.5,340.2,822,339.6,821.9,339"
                />
                <polygon
                  class="st87"
                  points="817.4,370.6 818.6,370.6 818.6,366.2 817,366.2      "
                />
                <path
                  class="st87"
                  d="M818,347c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C818.1,349,817.6,347.8,818,347"
                />
                <path
                  class="st88"
                  d="M817.5,345.7c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C817.4,347.4,817.8,346.4,817.5,345.7"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_82_"
                    d="M832.2,342.6c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C832.5,342.6,832.3,342.6,832.2,342.6"
                  />
                </defs>
                <clipPath id="SVGID_83_">
                  <use xlink:href="#SVGID_82_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_84_"
                  gradientUnits="userSpaceOnUse"
                  x1="-93.8286"
                  y1="845.2175"
                  x2="-92.8427"
                  y2="845.2175"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st115"
                  points="805.4,349.6 831.1,334.7 847.7,363.6 822,378.4      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_85_"
                    d="M800.7,344.4c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C802.2,342.6,801.1,343.3,800.7,344.4"
                  />
                </defs>
                <clipPath id="SVGID_86_">
                  <use xlink:href="#SVGID_85_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_87_"
                  gradientUnits="userSpaceOnUse"
                  x1="-77.0614"
                  y1="828.8596"
                  x2="-76.0755"
                  y2="828.8596"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st116"
                  points="804.9,334.7 830.6,349.6 814,378.4 788.3,363.6      "
                />
              </g>
              <polygon
                class="st87"
                points="816.2,368.7 816.9,370.6 817.8,375.6 819.1,375.6 820,370.6 820.7,368.7     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M779,339c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C778.6,340.2,779.1,339.6,779,339"
                />
                <polygon
                  class="st87"
                  points="774.4,370.6 775.7,370.6 775.7,366.2 774.1,366.2      "
                />
                <path
                  class="st87"
                  d="M775,347c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C775.2,349,774.7,347.8,775,347"
                />
                <path
                  class="st88"
                  d="M774.6,345.7c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C774.5,347.4,774.9,346.4,774.6,345.7"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_88_"
                    d="M789.2,342.6c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C789.6,342.6,789.4,342.6,789.2,342.6"
                  />
                </defs>
                <clipPath id="SVGID_89_">
                  <use xlink:href="#SVGID_88_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_90_"
                  gradientUnits="userSpaceOnUse"
                  x1="-95.1357"
                  y1="845.9721"
                  x2="-94.1498"
                  y2="845.9721"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st117"
                  points="762.4,349.6 788.1,334.7 804.8,363.6 779.1,378.4      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_91_"
                    d="M757.8,344.4c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C759.3,342.6,758.2,343.3,757.8,344.4"
                  />
                </defs>
                <clipPath id="SVGID_92_">
                  <use xlink:href="#SVGID_91_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_93_"
                  gradientUnits="userSpaceOnUse"
                  x1="-78.3685"
                  y1="828.105"
                  x2="-77.3826"
                  y2="828.105"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st118"
                  points="762,334.7 787.7,349.6 771,378.4 745.3,363.6      "
                />
              </g>
              <polygon
                class="st87"
                points="773.3,368.7 774,370.6 774.9,375.6 776.2,375.6 777.1,370.6 777.8,368.7     "
              />
            </g>
          </g>
          <path
            class="st119"
            d="M1408.9,399.9H752.1c-7.7,0-14-6.3-14-14c0-7.7,6.3-14,14-14h656.8c7.7,0,14,6.3,14,14    C1422.9,393.6,1416.6,399.9,1408.9,399.9"
          />
          <g>
            <path
              class="st120"
              d="M1391.5,371.9c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1348.4,371.9c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M788,371.9c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M831.1,371.9c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M874.2,371.9c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M917.3,371.9c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M960.4,371.9c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1003.5,371.9c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1046.7,371.9c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1089.8,371.9c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1132.9,371.9c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1176,371.9c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1219.1,371.9c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1262.2,371.9c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1305.3,371.9c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1382.9,219.8c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1382.5,221,1383,220.4,1382.9,219.8"
                />
                <polygon
                  class="st87"
                  points="1378.4,251.5 1379.6,251.5 1379.6,247.1 1378.1,247.1      "
                />
                <path
                  class="st87"
                  d="M1379,227.9c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1379.1,229.8,1378.7,228.7,1379,227.9"
                />
                <path
                  class="st88"
                  d="M1378.5,226.5c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1378.4,228.3,1378.8,227.3,1378.5,226.5"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_94_"
                    d="M1393.2,223.5c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1393.5,223.4,1393.3,223.4,1393.2,223.5"
                  />
                </defs>
                <clipPath id="SVGID_95_">
                  <use xlink:href="#SVGID_94_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_96_"
                  gradientUnits="userSpaceOnUse"
                  x1="-74.6502"
                  y1="838.9825"
                  x2="-73.6643"
                  y2="838.9825"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st121"
                  points="1366.4,230.4 1392.1,215.6 1408.8,244.4 1383,259.3      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_97_"
                    d="M1361.8,225.2c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C1363.2,223.4,1362.1,224.1,1361.8,225.2"
                  />
                </defs>
                <clipPath id="SVGID_98_">
                  <use xlink:href="#SVGID_97_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_99_"
                  gradientUnits="userSpaceOnUse"
                  x1="-62.0726"
                  y1="842.3511"
                  x2="-61.0867"
                  y2="842.3511"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st122"
                  points="1365.9,215.6 1391.6,230.4 1375,259.3 1349.3,244.4      "
                />
              </g>
              <polygon
                class="st87"
                points="1377.3,249.6 1378,251.5 1378.9,256.4 1380.1,256.4 1381.1,251.5 1381.8,249.6     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1340,219.8c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1339.6,221,1340.1,220.4,1340,219.8"
                />
                <polygon
                  class="st87"
                  points="1335.5,251.5 1336.7,251.5 1336.7,247.1 1335.1,247.1      "
                />
                <path
                  class="st87"
                  d="M1336.1,227.9c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1336.2,229.8,1335.7,228.7,1336.1,227.9"
                />
                <path
                  class="st88"
                  d="M1335.6,226.5c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1335.5,228.3,1335.9,227.3,1335.6,226.5"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_100_"
                    d="M1350.3,223.5c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1350.6,223.4,1350.4,223.4,1350.3,223.5"
                  />
                </defs>
                <clipPath id="SVGID_101_">
                  <use xlink:href="#SVGID_100_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_102_"
                  gradientUnits="userSpaceOnUse"
                  x1="-75.9573"
                  y1="839.7372"
                  x2="-74.9713"
                  y2="839.7372"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st123"
                  points="1323.5,230.4 1349.2,215.6 1365.8,244.4 1340.1,259.3      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_103_"
                    d="M1318.8,225.2c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3        c0.1,1,1.2,1.8,1.5,2.8c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6        c0.7,0.7,0.9,2,1.7,2.6c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4        c0-1,0.2-3.2,0.1-4.2c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3        c-0.6-0.8-1.9-0.9-2.7-1.7c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1        c-0.2,0-0.3-0.1-0.5-0.1C1320.3,223.4,1319.2,224.1,1318.8,225.2"
                  />
                </defs>
                <clipPath id="SVGID_104_">
                  <use xlink:href="#SVGID_103_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_105_"
                  gradientUnits="userSpaceOnUse"
                  x1="-63.3797"
                  y1="841.5965"
                  x2="-62.3937"
                  y2="841.5965"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st124"
                  points="1323,215.6 1348.7,230.4 1332.1,259.3 1306.4,244.4      "
                />
              </g>
              <polygon
                class="st87"
                points="1334.3,249.6 1335,251.5 1335.9,256.4 1337.2,256.4 1338.1,251.5 1338.8,249.6     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1295.8,219.8c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1295.3,221,1295.8,220.4,1295.8,219.8"
                />
                <polygon
                  class="st87"
                  points="1291.2,251.5 1292.5,251.5 1292.5,247.1 1290.9,247.1      "
                />
                <path
                  class="st87"
                  d="M1291.8,227.9c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1292,229.8,1291.5,228.7,1291.8,227.9"
                />
                <path
                  class="st88"
                  d="M1291.3,226.5c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1291.2,228.3,1291.7,227.3,1291.3,226.5"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_106_"
                    d="M1306,223.5c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1306.3,223.4,1306.2,223.4,1306,223.5"
                  />
                </defs>
                <clipPath id="SVGID_107_">
                  <use xlink:href="#SVGID_106_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_108_"
                  gradientUnits="userSpaceOnUse"
                  x1="-77.3052"
                  y1="840.5154"
                  x2="-76.3193"
                  y2="840.5154"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st125"
                  points="1279.2,230.4 1304.9,215.6 1321.6,244.4 1295.9,259.3      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_109_"
                    d="M1274.6,225.2c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3        c0.1,1,1.2,1.8,1.5,2.8c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3s0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6        c0.7,0.7,0.9,2,1.7,2.6c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4        c0-1,0.2-3.2,0.1-4.2c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3        c-0.6-0.8-1.9-0.9-2.7-1.7c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1        c-0.2,0-0.3-0.1-0.5-0.1C1276,223.4,1274.9,224.1,1274.6,225.2"
                  />
                </defs>
                <clipPath id="SVGID_110_">
                  <use xlink:href="#SVGID_109_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_111_"
                  gradientUnits="userSpaceOnUse"
                  x1="-64.7276"
                  y1="840.8183"
                  x2="-63.7417"
                  y2="840.8183"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st126"
                  points="1278.7,215.6 1304.5,230.4 1287.8,259.3 1262.1,244.4      "
                />
              </g>
              <polygon
                class="st87"
                points="1290.1,249.6 1290.8,251.5 1291.7,256.4 1293,256.4 1293.9,251.5 1294.6,249.6     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1252.8,219.8c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1252.4,221,1252.9,220.4,1252.8,219.8"
                />
                <polygon
                  class="st87"
                  points="1248.3,251.5 1249.5,251.5 1249.5,247.1 1248,247.1      "
                />
                <path
                  class="st87"
                  d="M1248.9,227.9c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1249,229.8,1248.5,228.7,1248.9,227.9"
                />
                <path
                  class="st88"
                  d="M1248.4,226.5c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1248.3,228.3,1248.7,227.3,1248.4,226.5"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_112_"
                    d="M1263.1,223.5c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1263.4,223.4,1263.2,223.4,1263.1,223.5"
                  />
                </defs>
                <clipPath id="SVGID_113_">
                  <use xlink:href="#SVGID_112_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_114_"
                  gradientUnits="userSpaceOnUse"
                  x1="-78.6123"
                  y1="841.2701"
                  x2="-77.6263"
                  y2="841.2701"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st127"
                  points="1236.3,230.4 1262,215.6 1278.6,244.4 1252.9,259.3      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_115_"
                    d="M1231.6,225.2c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3        c0.1,1,1.2,1.8,1.5,2.8c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3s0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6        c0.7,0.7,0.9,2,1.7,2.6c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4        c0-1,0.2-3.2,0.1-4.2c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3        c-0.6-0.8-1.9-0.9-2.7-1.7c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1        c-0.2,0-0.3-0.1-0.5-0.1C1233.1,223.4,1232,224.1,1231.6,225.2"
                  />
                </defs>
                <clipPath id="SVGID_116_">
                  <use xlink:href="#SVGID_115_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_117_"
                  gradientUnits="userSpaceOnUse"
                  x1="-66.0347"
                  y1="840.0637"
                  x2="-65.0487"
                  y2="840.0637"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st128"
                  points="1235.8,215.6 1261.5,230.4 1244.9,259.3 1219.2,244.4      "
                />
              </g>
              <polygon
                class="st87"
                points="1247.1,249.6 1247.8,251.5 1248.8,256.4 1250,256.4 1250.9,251.5 1251.6,249.6     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1209.9,219.8c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1209.5,221,1210,220.4,1209.9,219.8"
                />
                <polygon
                  class="st87"
                  points="1205.3,251.5 1206.6,251.5 1206.6,247.1 1205,247.1      "
                />
                <path
                  class="st87"
                  d="M1206,227.9c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1206.1,229.8,1205.6,228.7,1206,227.9"
                />
                <path
                  class="st88"
                  d="M1205.5,226.5c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1205.4,228.3,1205.8,227.3,1205.5,226.5"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_118_"
                    d="M1220.1,223.5c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1220.5,223.4,1220.3,223.4,1220.1,223.5"
                  />
                </defs>
                <clipPath id="SVGID_119_">
                  <use xlink:href="#SVGID_118_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_120_"
                  gradientUnits="userSpaceOnUse"
                  x1="-79.9193"
                  y1="842.0247"
                  x2="-78.9334"
                  y2="842.0247"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st129"
                  points="1193.3,230.4 1219,215.6 1235.7,244.4 1210,259.3      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_121_"
                    d="M1188.7,225.2c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3        c0.1,1,1.2,1.8,1.5,2.8c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6        c0.7,0.7,0.9,2,1.7,2.6c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4        c0-1,0.2-3.2,0.1-4.2c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3        c-0.6-0.8-1.9-0.9-2.7-1.7c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1        c-0.2,0-0.3-0.1-0.5-0.1C1190.2,223.4,1189.1,224.1,1188.7,225.2"
                  />
                </defs>
                <clipPath id="SVGID_122_">
                  <use xlink:href="#SVGID_121_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_123_"
                  gradientUnits="userSpaceOnUse"
                  x1="-67.3417"
                  y1="839.309"
                  x2="-66.3558"
                  y2="839.309"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st130"
                  points="1192.9,215.6 1218.6,230.4 1201.9,259.3 1176.2,244.4      "
                />
              </g>
              <polygon
                class="st87"
                points="1204.2,249.6 1204.9,251.5 1205.8,256.4 1207.1,256.4 1208,251.5 1208.7,249.6     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1165.6,219.8c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1165.2,221,1165.7,220.4,1165.6,219.8"
                />
                <polygon
                  class="st87"
                  points="1161.1,251.5 1162.3,251.5 1162.3,247.1 1160.8,247.1      "
                />
                <path
                  class="st87"
                  d="M1161.7,227.9c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1161.8,229.8,1161.3,228.7,1161.7,227.9"
                />
                <path
                  class="st88"
                  d="M1161.2,226.5c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1161.1,228.3,1161.5,227.3,1161.2,226.5"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_124_"
                    d="M1175.9,223.5c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1176.2,223.4,1176,223.4,1175.9,223.5"
                  />
                </defs>
                <clipPath id="SVGID_125_">
                  <use xlink:href="#SVGID_124_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_126_"
                  gradientUnits="userSpaceOnUse"
                  x1="-81.2673"
                  y1="842.8029"
                  x2="-80.2813"
                  y2="842.8029"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st131"
                  points="1149.1,230.4 1174.8,215.6 1191.4,244.4 1165.7,259.3      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_127_"
                    d="M1144.5,225.2c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3        c0.1,1,1.2,1.8,1.5,2.8c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3s0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6        c0.7,0.7,0.9,2,1.7,2.6c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4        c0-1,0.2-3.2,0.1-4.2c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3        c-0.6-0.8-1.9-0.9-2.7-1.7c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1        c-0.2,0-0.3-0.1-0.5-0.1C1145.9,223.4,1144.8,224.1,1144.5,225.2"
                  />
                </defs>
                <clipPath id="SVGID_128_">
                  <use xlink:href="#SVGID_127_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_129_"
                  gradientUnits="userSpaceOnUse"
                  x1="-68.6897"
                  y1="838.5308"
                  x2="-67.7038"
                  y2="838.5308"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st132"
                  points="1148.6,215.6 1174.3,230.4 1157.7,259.3 1132,244.4      "
                />
              </g>
              <polygon
                class="st87"
                points="1160,249.6 1160.7,251.5 1161.6,256.4 1162.8,256.4 1163.8,251.5 1164.5,249.6     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1124.1,219.8c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1123.6,221,1124.1,220.4,1124.1,219.8"
                />
                <polygon
                  class="st87"
                  points="1119.5,251.5 1120.8,251.5 1120.8,247.1 1119.2,247.1      "
                />
                <path
                  class="st87"
                  d="M1120.1,227.9c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1120.3,229.8,1119.8,228.7,1120.1,227.9"
                />
                <path
                  class="st88"
                  d="M1119.6,226.5c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1119.5,228.3,1120,227.3,1119.6,226.5"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_130_"
                    d="M1134.3,223.5c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1134.6,223.4,1134.5,223.4,1134.3,223.5"
                  />
                </defs>
                <clipPath id="SVGID_131_">
                  <use xlink:href="#SVGID_130_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_132_"
                  gradientUnits="userSpaceOnUse"
                  x1="-82.5335"
                  y1="843.534"
                  x2="-81.5476"
                  y2="843.534"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st133"
                  points="1107.5,230.4 1133.2,215.6 1149.9,244.4 1124.2,259.3      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_133_"
                    d="M1102.9,225.2c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3        c0.1,1,1.2,1.8,1.5,2.8c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6        c0.7,0.7,0.9,2,1.7,2.6c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4        c0-1,0.2-3.2,0.1-4.2c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3        c-0.6-0.8-1.9-0.9-2.7-1.7c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1        c-0.2,0-0.3-0.1-0.5-0.1C1104.3,223.4,1103.2,224.1,1102.9,225.2"
                  />
                </defs>
                <clipPath id="SVGID_134_">
                  <use xlink:href="#SVGID_133_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_135_"
                  gradientUnits="userSpaceOnUse"
                  x1="-69.9559"
                  y1="837.7997"
                  x2="-68.97"
                  y2="837.7997"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st134"
                  points="1107.1,215.6 1132.8,230.4 1116.1,259.3 1090.4,244.4      "
                />
              </g>
              <polygon
                class="st87"
                points="1118.4,249.6 1119.1,251.5 1120,256.4 1121.3,256.4 1122.2,251.5 1122.9,249.6     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1081.1,219.8c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1080.7,221,1081.2,220.4,1081.1,219.8"
                />
                <polygon
                  class="st87"
                  points="1076.6,251.5 1077.8,251.5 1077.8,247.1 1076.3,247.1      "
                />
                <path
                  class="st87"
                  d="M1077.2,227.9c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1077.3,229.8,1076.8,228.7,1077.2,227.9"
                />
                <path
                  class="st88"
                  d="M1076.7,226.5c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1076.6,228.3,1077,227.3,1076.7,226.5"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_136_"
                    d="M1091.4,223.5c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1091.7,223.4,1091.5,223.4,1091.4,223.5"
                  />
                </defs>
                <clipPath id="SVGID_137_">
                  <use xlink:href="#SVGID_136_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_138_"
                  gradientUnits="userSpaceOnUse"
                  x1="-83.8406"
                  y1="844.2886"
                  x2="-82.8547"
                  y2="844.2886"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st135"
                  points="1064.6,230.4 1090.3,215.6 1106.9,244.4 1081.2,259.3      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_139_"
                    d="M1059.9,225.2c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3        c0.1,1,1.2,1.8,1.5,2.8c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3s0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6        c0.7,0.7,0.9,2,1.7,2.6c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4        c0-1,0.2-3.2,0.1-4.2c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3        c-0.6-0.8-1.9-0.9-2.7-1.7c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1        c-0.2,0-0.3-0.1-0.5-0.1C1061.4,223.4,1060.3,224.1,1059.9,225.2"
                  />
                </defs>
                <clipPath id="SVGID_140_">
                  <use xlink:href="#SVGID_139_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_141_"
                  gradientUnits="userSpaceOnUse"
                  x1="-71.263"
                  y1="837.0451"
                  x2="-70.2771"
                  y2="837.0451"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st136"
                  points="1064.1,215.6 1089.8,230.4 1073.2,259.3 1047.5,244.4      "
                />
              </g>
              <polygon
                class="st87"
                points="1075.4,249.6 1076.2,251.5 1077.1,256.4 1078.3,256.4 1079.2,251.5 1080,249.6     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1036.9,219.8c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1036.4,221,1036.9,220.4,1036.9,219.8"
                />
                <polygon
                  class="st87"
                  points="1032.3,251.5 1033.6,251.5 1033.6,247.1 1032,247.1      "
                />
                <path
                  class="st87"
                  d="M1032.9,227.9c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1033.1,229.8,1032.6,228.7,1032.9,227.9"
                />
                <path
                  class="st88"
                  d="M1032.5,226.5c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1032.3,228.3,1032.8,227.3,1032.5,226.5"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_142_"
                    d="M1047.1,223.5c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1047.4,223.4,1047.3,223.4,1047.1,223.5"
                  />
                </defs>
                <clipPath id="SVGID_143_">
                  <use xlink:href="#SVGID_142_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_144_"
                  gradientUnits="userSpaceOnUse"
                  x1="-85.1885"
                  y1="845.0669"
                  x2="-84.2026"
                  y2="845.0669"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st137"
                  points="1020.3,230.4 1046,215.6 1062.7,244.4 1037,259.3      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_145_"
                    d="M1015.7,225.2c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3        c0.1,1,1.2,1.8,1.5,2.8c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6        c0.7,0.7,0.9,2,1.7,2.6c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4        c0-1,0.2-3.2,0.1-4.2c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3        c-0.6-0.8-1.9-0.9-2.7-1.7c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1        c-0.2,0-0.3-0.1-0.5-0.1C1017.1,223.4,1016.1,224.1,1015.7,225.2"
                  />
                </defs>
                <clipPath id="SVGID_146_">
                  <use xlink:href="#SVGID_145_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_147_"
                  gradientUnits="userSpaceOnUse"
                  x1="-72.6109"
                  y1="836.2668"
                  x2="-71.625"
                  y2="836.2668"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st138"
                  points="1019.9,215.6 1045.6,230.4 1028.9,259.3 1003.2,244.4      "
                />
              </g>
              <polygon
                class="st87"
                points="1031.2,249.6 1031.9,251.5 1032.8,256.4 1034.1,256.4 1035,251.5 1035.7,249.6     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M993.9,219.8c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C993.5,221,994,220.4,993.9,219.8"
                />
                <polygon
                  class="st87"
                  points="989.4,251.5 990.6,251.5 990.6,247.1 989.1,247.1      "
                />
                <path
                  class="st87"
                  d="M990,227.9c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C990.1,229.8,989.7,228.7,990,227.9"
                />
                <path
                  class="st88"
                  d="M989.5,226.5c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C989.4,228.3,989.8,227.3,989.5,226.5"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_148_"
                    d="M1004.2,223.5c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1004.5,223.4,1004.3,223.4,1004.2,223.5"
                  />
                </defs>
                <clipPath id="SVGID_149_">
                  <use xlink:href="#SVGID_148_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_150_"
                  gradientUnits="userSpaceOnUse"
                  x1="-86.4956"
                  y1="845.8215"
                  x2="-85.5097"
                  y2="845.8215"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st139"
                  points="977.4,230.4 1003.1,215.6 1019.7,244.4 994,259.3      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_151_"
                    d="M972.8,225.2c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C974.2,223.4,973.1,224.1,972.8,225.2"
                  />
                </defs>
                <clipPath id="SVGID_152_">
                  <use xlink:href="#SVGID_151_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_153_"
                  gradientUnits="userSpaceOnUse"
                  x1="-73.918"
                  y1="835.5122"
                  x2="-72.9321"
                  y2="835.5122"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st140"
                  points="976.9,215.6 1002.6,230.4 986,259.3 960.3,244.4      "
                />
              </g>
              <polygon
                class="st87"
                points="988.3,249.6 989,251.5 989.9,256.4 991.1,256.4 992.1,251.5 992.8,249.6     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M951,219.8c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C950.6,221,951.1,220.4,951,219.8"
                />
                <polygon
                  class="st87"
                  points="946.5,251.5 947.7,251.5 947.7,247.1 946.1,247.1      "
                />
                <path
                  class="st87"
                  d="M947.1,227.9c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C947.2,229.8,946.7,228.7,947.1,227.9"
                />
                <path
                  class="st88"
                  d="M946.6,226.5c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C946.5,228.3,946.9,227.3,946.6,226.5"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_154_"
                    d="M961.3,223.5c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C961.6,223.4,961.4,223.4,961.3,223.5"
                  />
                </defs>
                <clipPath id="SVGID_155_">
                  <use xlink:href="#SVGID_154_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_156_"
                  gradientUnits="userSpaceOnUse"
                  x1="-87.8027"
                  y1="846.5762"
                  x2="-86.8167"
                  y2="846.5762"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st141"
                  points="934.5,230.4 960.2,215.6 976.8,244.4 951.1,259.3      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_157_"
                    d="M929.8,225.2c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C931.3,223.4,930.2,224.1,929.8,225.2"
                  />
                </defs>
                <clipPath id="SVGID_158_">
                  <use xlink:href="#SVGID_157_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_159_"
                  gradientUnits="userSpaceOnUse"
                  x1="-75.2251"
                  y1="834.7576"
                  x2="-74.2391"
                  y2="834.7576"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st142"
                  points="934,215.6 959.7,230.4 943.1,259.3 917.4,244.4      "
                />
              </g>
              <polygon
                class="st87"
                points="945.3,249.6 946,251.5 946.9,256.4 948.2,256.4 949.1,251.5 949.8,249.6     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M906.8,219.8c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C906.3,221,906.8,220.4,906.8,219.8"
                />
                <polygon
                  class="st87"
                  points="902.2,251.5 903.5,251.5 903.5,247.1 901.9,247.1      "
                />
                <path
                  class="st87"
                  d="M902.8,227.9c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C903,229.8,902.5,228.7,902.8,227.9"
                />
                <path
                  class="st88"
                  d="M902.3,226.5c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C902.2,228.3,902.7,227.3,902.3,226.5"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_160_"
                    d="M917,223.5c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C917.3,223.4,917.2,223.4,917,223.5"
                  />
                </defs>
                <clipPath id="SVGID_161_">
                  <use xlink:href="#SVGID_160_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_162_"
                  gradientUnits="userSpaceOnUse"
                  x1="-89.1506"
                  y1="847.3544"
                  x2="-88.1647"
                  y2="847.3544"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st143"
                  points="890.2,230.4 915.9,215.6 932.6,244.4 906.9,259.3      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_163_"
                    d="M885.6,225.2c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C887,223.4,885.9,224.1,885.6,225.2"
                  />
                </defs>
                <clipPath id="SVGID_164_">
                  <use xlink:href="#SVGID_163_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_165_"
                  gradientUnits="userSpaceOnUse"
                  x1="-76.573"
                  y1="833.9794"
                  x2="-75.5871"
                  y2="833.9794"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st144"
                  points="889.7,215.6 915.5,230.4 898.8,259.3 873.1,244.4      "
                />
              </g>
              <polygon
                class="st87"
                points="901.1,249.6 901.8,251.5 902.7,256.4 904,256.4 904.9,251.5 905.6,249.6     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M865.2,219.8c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C864.7,221,865.3,220.4,865.2,219.8"
                />
                <polygon
                  class="st87"
                  points="860.6,251.5 861.9,251.5 861.9,247.1 860.3,247.1      "
                />
                <path
                  class="st87"
                  d="M861.2,227.9c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C861.4,229.8,860.9,228.7,861.2,227.9"
                />
                <path
                  class="st88"
                  d="M860.8,226.5c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C860.6,228.3,861.1,227.3,860.8,226.5"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_166_"
                    d="M875.4,223.5c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4L861,251l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C875.7,223.4,875.6,223.4,875.4,223.5"
                  />
                </defs>
                <clipPath id="SVGID_167_">
                  <use xlink:href="#SVGID_166_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_168_"
                  gradientUnits="userSpaceOnUse"
                  x1="-90.4168"
                  y1="848.0854"
                  x2="-89.4309"
                  y2="848.0854"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st145"
                  points="848.6,230.4 874.3,215.6 891,244.4 865.3,259.3      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_169_"
                    d="M844,225.2c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C845.4,223.4,844.4,224.1,844,225.2"
                  />
                </defs>
                <clipPath id="SVGID_170_">
                  <use xlink:href="#SVGID_169_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_171_"
                  gradientUnits="userSpaceOnUse"
                  x1="-77.8392"
                  y1="833.2483"
                  x2="-76.8533"
                  y2="833.2483"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st146"
                  points="848.2,215.6 873.9,230.4 857.2,259.3 831.5,244.4      "
                />
              </g>
              <polygon
                class="st87"
                points="859.5,249.6 860.2,251.5 861.1,256.4 862.4,256.4 863.3,251.5 864,249.6     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M822.3,219.8c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C821.8,221,822.3,220.4,822.3,219.8"
                />
                <polygon
                  class="st87"
                  points="817.7,251.5 819,251.5 819,247.1 817.4,247.1      "
                />
                <path
                  class="st87"
                  d="M818.3,227.9c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C818.4,229.8,818,228.7,818.3,227.9"
                />
                <path
                  class="st88"
                  d="M817.8,226.5c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C817.7,228.3,818.1,227.3,817.8,226.5"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_172_"
                    d="M832.5,223.5c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C832.8,223.4,832.7,223.4,832.5,223.5"
                  />
                </defs>
                <clipPath id="SVGID_173_">
                  <use xlink:href="#SVGID_172_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_174_"
                  gradientUnits="userSpaceOnUse"
                  x1="-91.7239"
                  y1="848.8401"
                  x2="-90.738"
                  y2="848.8401"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st147"
                  points="805.7,230.4 831.4,215.6 848.1,244.4 822.3,259.3      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_175_"
                    d="M801.1,225.2c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C802.5,223.4,801.4,224.1,801.1,225.2"
                  />
                </defs>
                <clipPath id="SVGID_176_">
                  <use xlink:href="#SVGID_175_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_177_"
                  gradientUnits="userSpaceOnUse"
                  x1="-79.1463"
                  y1="832.4937"
                  x2="-78.1604"
                  y2="832.4937"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st148"
                  points="805.2,215.6 831,230.4 814.3,259.3 788.6,244.4      "
                />
              </g>
              <polygon
                class="st87"
                points="816.6,249.6 817.3,251.5 818.2,256.4 819.4,256.4 820.4,251.5 821.1,249.6     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M779.3,219.8c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C778.9,221,779.4,220.4,779.3,219.8"
                />
                <polygon
                  class="st87"
                  points="774.8,251.5 776,251.5 776,247.1 774.4,247.1      "
                />
                <path
                  class="st87"
                  d="M775.4,227.9c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C775.5,229.8,775,228.7,775.4,227.9"
                />
                <path
                  class="st88"
                  d="M774.9,226.5c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C774.8,228.3,775.2,227.3,774.9,226.5"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_178_"
                    d="M789.6,223.5c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C789.9,223.4,789.7,223.4,789.6,223.5"
                  />
                </defs>
                <clipPath id="SVGID_179_">
                  <use xlink:href="#SVGID_178_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_180_"
                  gradientUnits="userSpaceOnUse"
                  x1="-93.031"
                  y1="849.5947"
                  x2="-92.045"
                  y2="849.5947"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st149"
                  points="762.8,230.4 788.5,215.6 805.1,244.4 779.4,259.3      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_181_"
                    d="M758.1,225.2c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C759.6,223.4,758.5,224.1,758.1,225.2"
                  />
                </defs>
                <clipPath id="SVGID_182_">
                  <use xlink:href="#SVGID_181_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_183_"
                  gradientUnits="userSpaceOnUse"
                  x1="-80.4534"
                  y1="831.739"
                  x2="-79.4674"
                  y2="831.739"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st150"
                  points="762.3,215.6 788,230.4 771.4,259.3 745.7,244.4      "
                />
              </g>
              <polygon
                class="st87"
                points="773.6,249.6 774.3,251.5 775.3,256.4 776.5,256.4 777.4,251.5 778.1,249.6     "
              />
            </g>
          </g>
          <path
            class="st119"
            d="M1409.2,280.7H752.4c-7.7,0-14-6.3-14-14c0-7.7,6.3-14,14-14h656.8c7.7,0,14,6.3,14,14    C1423.2,274.5,1417,280.7,1409.2,280.7"
          />
          <g>
            <path
              class="st120"
              d="M1391.8,252.8c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1348.7,252.8c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M788.4,252.8c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M831.5,252.8c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M874.6,252.8c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M917.7,252.8c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M960.8,252.8c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1003.9,252.8c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1047,252.8c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1090.1,252.8c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1133.2,252.8c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1176.3,252.8c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1219.4,252.8c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1262.5,252.8c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1305.6,252.8c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1383.5,101.7c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1383,102.9,1383.5,102.2,1383.5,101.7"
                />
                <polygon
                  class="st87"
                  points="1378.9,133.3 1380.2,133.3 1380.2,128.9 1378.6,128.9      "
                />
                <path
                  class="st87"
                  d="M1379.5,109.7c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1379.7,111.6,1379.2,110.5,1379.5,109.7"
                />
                <path
                  class="st88"
                  d="M1379,108.3c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1378.9,110.1,1379.4,109.1,1379,108.3"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_184_"
                    d="M1393.7,105.3c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1394,105.3,1393.9,105.3,1393.7,105.3"
                  />
                </defs>
                <clipPath id="SVGID_185_">
                  <use xlink:href="#SVGID_184_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_186_"
                  gradientUnits="userSpaceOnUse"
                  x1="-72.5572"
                  y1="842.5717"
                  x2="-71.5713"
                  y2="842.5717"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st151"
                  points="1366.9,112.3 1392.6,97.4 1409.3,126.3 1383.6,141.1      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_187_"
                    d="M1362.3,107.1c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3        c0.1,1,1.2,1.8,1.5,2.8c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6        c0.7,0.7,0.9,2,1.7,2.6c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4        c0-1,0.2-3.2,0.1-4.2c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3        c-0.6-0.8-1.9-0.9-2.7-1.7c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1        c-0.2,0-0.3-0.1-0.5-0.1C1363.7,105.3,1362.6,106,1362.3,107.1"
                  />
                </defs>
                <clipPath id="SVGID_188_">
                  <use xlink:href="#SVGID_187_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_189_"
                  gradientUnits="userSpaceOnUse"
                  x1="-64.1343"
                  y1="845.9583"
                  x2="-63.1484"
                  y2="845.9583"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st152"
                  points="1366.5,97.4 1392.2,112.3 1375.5,141.1 1349.8,126.3      "
                />
              </g>
              <polygon
                class="st87"
                points="1377.8,131.4 1378.5,133.3 1379.4,138.3 1380.7,138.3 1381.6,133.3 1382.3,131.4     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1340.5,101.7c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1340.1,102.9,1340.6,102.2,1340.5,101.7"
                />
                <polygon
                  class="st87"
                  points="1336,133.3 1337.2,133.3 1337.2,128.9 1335.7,128.9      "
                />
                <path
                  class="st87"
                  d="M1336.6,109.7c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1336.7,111.6,1336.2,110.5,1336.6,109.7"
                />
                <path
                  class="st88"
                  d="M1336.1,108.3c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1336,110.1,1336.4,109.1,1336.1,108.3"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_190_"
                    d="M1350.8,105.3c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1351.1,105.3,1350.9,105.3,1350.8,105.3"
                  />
                </defs>
                <clipPath id="SVGID_191_">
                  <use xlink:href="#SVGID_190_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_192_"
                  gradientUnits="userSpaceOnUse"
                  x1="-73.8643"
                  y1="843.3263"
                  x2="-72.8784"
                  y2="843.3263"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st153"
                  points="1324,112.3 1349.7,97.4 1366.3,126.3 1340.6,141.1      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_193_"
                    d="M1319.3,107.1c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3        c0.1,1,1.2,1.8,1.5,2.8c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6        c0.7,0.7,0.9,2,1.7,2.6c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4        c0-1,0.2-3.2,0.1-4.2c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3        c-0.6-0.8-1.9-0.9-2.7-1.7c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1        c-0.2,0-0.3-0.1-0.5-0.1C1320.8,105.3,1319.7,106,1319.3,107.1"
                  />
                </defs>
                <clipPath id="SVGID_194_">
                  <use xlink:href="#SVGID_193_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_195_"
                  gradientUnits="userSpaceOnUse"
                  x1="-65.4414"
                  y1="845.2036"
                  x2="-64.4555"
                  y2="845.2036"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st154"
                  points="1323.5,97.4 1349.2,112.3 1332.6,141.1 1306.9,126.3      "
                />
              </g>
              <polygon
                class="st87"
                points="1334.8,131.4 1335.6,133.3 1336.5,138.3 1337.7,138.3 1338.6,133.3 1339.4,131.4     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1296.3,101.7c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1295.8,102.9,1296.3,102.2,1296.3,101.7"
                />
                <polygon
                  class="st87"
                  points="1291.7,133.3 1293,133.3 1293,128.9 1291.4,128.9      "
                />
                <path
                  class="st87"
                  d="M1292.3,109.7c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1292.5,111.6,1292,110.5,1292.3,109.7"
                />
                <path
                  class="st88"
                  d="M1291.9,108.3c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1291.7,110.1,1292.2,109.1,1291.9,108.3"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_196_"
                    d="M1306.5,105.3c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1306.8,105.3,1306.7,105.3,1306.5,105.3"
                  />
                </defs>
                <clipPath id="SVGID_197_">
                  <use xlink:href="#SVGID_196_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_198_"
                  gradientUnits="userSpaceOnUse"
                  x1="-75.2122"
                  y1="844.1045"
                  x2="-74.2263"
                  y2="844.1045"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st155"
                  points="1279.7,112.3 1305.4,97.4 1322.1,126.3 1296.4,141.1      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_199_"
                    d="M1275.1,107.1c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3        c0.1,1,1.2,1.8,1.5,2.8c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6        c0.7,0.7,0.9,2,1.7,2.6c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4        c0-1,0.2-3.2,0.1-4.2c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3        c-0.6-0.8-1.9-0.9-2.7-1.7c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1        c-0.2,0-0.3-0.1-0.5-0.1C1276.5,105.3,1275.5,106,1275.1,107.1"
                  />
                </defs>
                <clipPath id="SVGID_200_">
                  <use xlink:href="#SVGID_199_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_201_"
                  gradientUnits="userSpaceOnUse"
                  x1="-66.7893"
                  y1="844.4254"
                  x2="-65.8034"
                  y2="844.4254"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st156"
                  points="1279.3,97.4 1305,112.3 1288.3,141.1 1262.6,126.3      "
                />
              </g>
              <polygon
                class="st87"
                points="1290.6,131.4 1291.3,133.3 1292.2,138.3 1293.5,138.3 1294.4,133.3 1295.1,131.4     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1253.3,101.7c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1252.9,102.9,1253.4,102.2,1253.3,101.7"
                />
                <polygon
                  class="st87"
                  points="1248.8,133.3 1250,133.3 1250,128.9 1248.5,128.9      "
                />
                <path
                  class="st87"
                  d="M1249.4,109.7c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1249.5,111.6,1249.1,110.5,1249.4,109.7"
                />
                <path
                  class="st88"
                  d="M1248.9,108.3c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1248.8,110.1,1249.2,109.1,1248.9,108.3"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_202_"
                    d="M1263.6,105.3c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1263.9,105.3,1263.7,105.3,1263.6,105.3"
                  />
                </defs>
                <clipPath id="SVGID_203_">
                  <use xlink:href="#SVGID_202_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_204_"
                  gradientUnits="userSpaceOnUse"
                  x1="-76.5193"
                  y1="844.8591"
                  x2="-75.5334"
                  y2="844.8591"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st157"
                  points="1236.8,112.3 1262.5,97.4 1279.1,126.3 1253.4,141.1      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_205_"
                    d="M1232.2,107.1c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3        c0.1,1,1.2,1.8,1.5,2.8c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6        c0.7,0.7,0.9,2,1.7,2.6c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4        c0-1,0.2-3.2,0.1-4.2c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3        c-0.6-0.8-1.9-0.9-2.7-1.7c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1        c-0.2,0-0.3-0.1-0.5-0.1C1233.6,105.3,1232.5,106,1232.2,107.1"
                  />
                </defs>
                <clipPath id="SVGID_206_">
                  <use xlink:href="#SVGID_205_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_207_"
                  gradientUnits="userSpaceOnUse"
                  x1="-68.0964"
                  y1="843.6708"
                  x2="-67.1105"
                  y2="843.6708"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st158"
                  points="1236.3,97.4 1262,112.3 1245.4,141.1 1219.7,126.3      "
                />
              </g>
              <polygon
                class="st87"
                points="1247.7,131.4 1248.4,133.3 1249.3,138.3 1250.5,138.3 1251.5,133.3 1252.2,131.4     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1210.4,101.7c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1210,102.9,1210.5,102.2,1210.4,101.7"
                />
                <polygon
                  class="st87"
                  points="1205.9,133.3 1207.1,133.3 1207.1,128.9 1205.5,128.9      "
                />
                <path
                  class="st87"
                  d="M1206.5,109.7c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1206.6,111.6,1206.1,110.5,1206.5,109.7"
                />
                <path
                  class="st88"
                  d="M1206,108.3c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1205.9,110.1,1206.3,109.1,1206,108.3"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_208_"
                    d="M1220.7,105.3c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1221,105.3,1220.8,105.3,1220.7,105.3"
                  />
                </defs>
                <clipPath id="SVGID_209_">
                  <use xlink:href="#SVGID_208_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_210_"
                  gradientUnits="userSpaceOnUse"
                  x1="-77.8264"
                  y1="845.6138"
                  x2="-76.8404"
                  y2="845.6138"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st159"
                  points="1193.9,112.3 1219.6,97.4 1236.2,126.3 1210.5,141.1      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_211_"
                    d="M1189.2,107.1c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3        c0.1,1,1.2,1.8,1.5,2.8c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6        c0.7,0.7,0.9,2,1.7,2.6c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4        c0-1,0.2-3.2,0.1-4.2c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3        c-0.6-0.8-1.9-0.9-2.7-1.7c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1        c-0.2,0-0.3-0.1-0.5-0.1C1190.7,105.3,1189.6,106,1189.2,107.1"
                  />
                </defs>
                <clipPath id="SVGID_212_">
                  <use xlink:href="#SVGID_211_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_213_"
                  gradientUnits="userSpaceOnUse"
                  x1="-69.4035"
                  y1="842.9161"
                  x2="-68.4176"
                  y2="842.9161"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st160"
                  points="1193.4,97.4 1219.1,112.3 1202.5,141.1 1176.8,126.3      "
                />
              </g>
              <polygon
                class="st87"
                points="1204.7,131.4 1205.4,133.3 1206.3,138.3 1207.6,138.3 1208.5,133.3 1209.2,131.4     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1166.2,101.7c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1165.7,102.9,1166.2,102.2,1166.2,101.7"
                />
                <polygon
                  class="st87"
                  points="1161.6,133.3 1162.9,133.3 1162.9,128.9 1161.3,128.9      "
                />
                <path
                  class="st87"
                  d="M1162.2,109.7c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1162.4,111.6,1161.9,110.5,1162.2,109.7"
                />
                <path
                  class="st88"
                  d="M1161.7,108.3c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1161.6,110.1,1162.1,109.1,1161.7,108.3"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_214_"
                    d="M1176.4,105.3c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1176.7,105.3,1176.6,105.3,1176.4,105.3"
                  />
                </defs>
                <clipPath id="SVGID_215_">
                  <use xlink:href="#SVGID_214_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_216_"
                  gradientUnits="userSpaceOnUse"
                  x1="-79.1743"
                  y1="846.392"
                  x2="-78.1884"
                  y2="846.392"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st161"
                  points="1149.6,112.3 1175.3,97.4 1192,126.3 1166.3,141.1      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_217_"
                    d="M1145,107.1c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C1146.4,105.3,1145.3,106,1145,107.1"
                  />
                </defs>
                <clipPath id="SVGID_218_">
                  <use xlink:href="#SVGID_217_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_219_"
                  gradientUnits="userSpaceOnUse"
                  x1="-70.7514"
                  y1="842.1379"
                  x2="-69.7655"
                  y2="842.1379"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st162"
                  points="1149.1,97.4 1174.9,112.3 1158.2,141.1 1132.5,126.3      "
                />
              </g>
              <polygon
                class="st87"
                points="1160.5,131.4 1161.2,133.3 1162.1,138.3 1163.4,138.3 1164.3,133.3 1165,131.4     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1124.6,101.7c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1124.1,102.9,1124.7,102.2,1124.6,101.7"
                />
                <polygon
                  class="st87"
                  points="1120,133.3 1121.3,133.3 1121.3,128.9 1119.7,128.9      "
                />
                <path
                  class="st87"
                  d="M1120.6,109.7c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1120.8,111.6,1120.3,110.5,1120.6,109.7"
                />
                <path
                  class="st88"
                  d="M1120.2,108.3c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1120,110.1,1120.5,109.1,1120.2,108.3"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_220_"
                    d="M1134.8,105.3c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1135.1,105.3,1135,105.3,1134.8,105.3"
                  />
                </defs>
                <clipPath id="SVGID_221_">
                  <use xlink:href="#SVGID_220_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_222_"
                  gradientUnits="userSpaceOnUse"
                  x1="-80.4405"
                  y1="847.123"
                  x2="-79.4546"
                  y2="847.123"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st163"
                  points="1108,112.3 1133.7,97.4 1150.4,126.3 1124.7,141.1      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_223_"
                    d="M1103.4,107.1c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3        c0.1,1,1.2,1.8,1.5,2.8c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3s0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6        c0.7,0.7,0.9,2,1.7,2.6c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4        c0-1,0.2-3.2,0.1-4.2c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3        c-0.6-0.8-1.9-0.9-2.7-1.7c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1        c-0.2,0-0.3-0.1-0.5-0.1C1104.8,105.3,1103.8,106,1103.4,107.1"
                  />
                </defs>
                <clipPath id="SVGID_224_">
                  <use xlink:href="#SVGID_223_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_225_"
                  gradientUnits="userSpaceOnUse"
                  x1="-72.0176"
                  y1="841.4069"
                  x2="-71.0317"
                  y2="841.4069"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st164"
                  points="1107.6,97.4 1133.3,112.3 1116.6,141.1 1090.9,126.3      "
                />
              </g>
              <polygon
                class="st87"
                points="1118.9,131.4 1119.6,133.3 1120.5,138.3 1121.8,138.3 1122.7,133.3 1123.4,131.4     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1081.7,101.7c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1081.2,102.9,1081.7,102.2,1081.7,101.7"
                />
                <polygon
                  class="st87"
                  points="1077.1,133.3 1078.4,133.3 1078.4,128.9 1076.8,128.9      "
                />
                <path
                  class="st87"
                  d="M1077.7,109.7c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1077.8,111.6,1077.4,110.5,1077.7,109.7"
                />
                <path
                  class="st88"
                  d="M1077.2,108.3c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1077.1,110.1,1077.5,109.1,1077.2,108.3"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_226_"
                    d="M1091.9,105.3c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1092.2,105.3,1092.1,105.3,1091.9,105.3"
                  />
                </defs>
                <clipPath id="SVGID_227_">
                  <use xlink:href="#SVGID_226_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_228_"
                  gradientUnits="userSpaceOnUse"
                  x1="-81.7476"
                  y1="847.8777"
                  x2="-80.7617"
                  y2="847.8777"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st165"
                  points="1065.1,112.3 1090.8,97.4 1107.5,126.3 1081.7,141.1      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_229_"
                    d="M1060.5,107.1c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3        c0.1,1,1.2,1.8,1.5,2.8c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3s0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6        c0.7,0.7,0.9,2,1.7,2.6c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4        c0-1,0.2-3.2,0.1-4.2c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3        c-0.6-0.8-1.9-0.9-2.7-1.7c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1        c-0.2,0-0.3-0.1-0.5-0.1C1061.9,105.3,1060.8,106,1060.5,107.1"
                  />
                </defs>
                <clipPath id="SVGID_230_">
                  <use xlink:href="#SVGID_229_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_231_"
                  gradientUnits="userSpaceOnUse"
                  x1="-73.3247"
                  y1="840.6522"
                  x2="-72.3388"
                  y2="840.6522"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st166"
                  points="1064.6,97.4 1090.3,112.3 1073.7,141.1 1048,126.3      "
                />
              </g>
              <polygon
                class="st87"
                points="1076,131.4 1076.7,133.3 1077.6,138.3 1078.8,138.3 1079.8,133.3 1080.5,131.4     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M1037.4,101.7c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C1037,102.9,1037.5,102.2,1037.4,101.7"
                />
                <polygon
                  class="st87"
                  points="1032.8,133.3 1034.1,133.3 1034.1,128.9 1032.5,128.9      "
                />
                <path
                  class="st87"
                  d="M1033.4,109.7c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5s0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C1033.6,111.6,1033.1,110.5,1033.4,109.7"
                />
                <path
                  class="st88"
                  d="M1033,108.3c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C1032.8,110.1,1033.3,109.1,1033,108.3"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_232_"
                    d="M1047.6,105.3c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1048,105.3,1047.8,105.3,1047.6,105.3"
                  />
                </defs>
                <clipPath id="SVGID_233_">
                  <use xlink:href="#SVGID_232_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_234_"
                  gradientUnits="userSpaceOnUse"
                  x1="-83.0955"
                  y1="848.6559"
                  x2="-82.1096"
                  y2="848.6559"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st167"
                  points="1020.8,112.3 1046.5,97.4 1063.2,126.3 1037.5,141.1      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_235_"
                    d="M1016.2,107.1c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3        c0.1,1,1.2,1.8,1.5,2.8c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6        c0.7,0.7,0.9,2,1.7,2.6c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4        c0-1,0.2-3.2,0.1-4.2c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3        c-0.6-0.8-1.9-0.9-2.7-1.7c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1        c-0.2,0-0.3-0.1-0.5-0.1C1017.6,105.3,1016.6,106,1016.2,107.1"
                  />
                </defs>
                <clipPath id="SVGID_236_">
                  <use xlink:href="#SVGID_235_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_237_"
                  gradientUnits="userSpaceOnUse"
                  x1="-74.6726"
                  y1="839.874"
                  x2="-73.6867"
                  y2="839.874"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st168"
                  points="1020.4,97.4 1046.1,112.3 1029.4,141.1 1003.7,126.3      "
                />
              </g>
              <polygon
                class="st87"
                points="1031.7,131.4 1032.4,133.3 1033.3,138.3 1034.6,138.3 1035.5,133.3 1036.2,131.4     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M994.5,101.7c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C994,102.9,994.5,102.2,994.5,101.7"
                />
                <polygon
                  class="st87"
                  points="989.9,133.3 991.2,133.3 991.2,128.9 989.6,128.9      "
                />
                <path
                  class="st87"
                  d="M990.5,109.7c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C990.7,111.6,990.2,110.5,990.5,109.7"
                />
                <path
                  class="st88"
                  d="M990,108.3c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C989.9,110.1,990.4,109.1,990,108.3"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_238_"
                    d="M1004.7,105.3c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C1005,105.3,1004.9,105.3,1004.7,105.3"
                  />
                </defs>
                <clipPath id="SVGID_239_">
                  <use xlink:href="#SVGID_238_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_240_"
                  gradientUnits="userSpaceOnUse"
                  x1="-84.4026"
                  y1="849.4106"
                  x2="-83.4167"
                  y2="849.4106"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st169"
                  points="977.9,112.3 1003.6,97.4 1020.3,126.3 994.6,141.1      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_241_"
                    d="M973.3,107.1c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C974.7,105.3,973.6,106,973.3,107.1"
                  />
                </defs>
                <clipPath id="SVGID_242_">
                  <use xlink:href="#SVGID_241_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_243_"
                  gradientUnits="userSpaceOnUse"
                  x1="-75.9797"
                  y1="839.1193"
                  x2="-74.9938"
                  y2="839.1193"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st170"
                  points="977.5,97.4 1003.2,112.3 986.5,141.1 960.8,126.3      "
                />
              </g>
              <polygon
                class="st87"
                points="988.8,131.4 989.5,133.3 990.4,138.3 991.7,138.3 992.6,133.3 993.3,131.4     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M951.5,101.7c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C951.1,102.9,951.6,102.2,951.5,101.7"
                />
                <polygon
                  class="st87"
                  points="947,133.3 948.2,133.3 948.2,128.9 946.7,128.9      "
                />
                <path
                  class="st87"
                  d="M947.6,109.7c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C947.7,111.6,947.2,110.5,947.6,109.7"
                />
                <path
                  class="st88"
                  d="M947.1,108.3c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C947,110.1,947.4,109.1,947.1,108.3"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_244_"
                    d="M961.8,105.3c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C962.1,105.3,961.9,105.3,961.8,105.3"
                  />
                </defs>
                <clipPath id="SVGID_245_">
                  <use xlink:href="#SVGID_244_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_246_"
                  gradientUnits="userSpaceOnUse"
                  x1="-85.7097"
                  y1="850.1652"
                  x2="-84.7237"
                  y2="850.1652"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st171"
                  points="935,112.3 960.7,97.4 977.3,126.3 951.6,141.1      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_247_"
                    d="M930.3,107.1c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C931.8,105.3,930.7,106,930.3,107.1"
                  />
                </defs>
                <clipPath id="SVGID_248_">
                  <use xlink:href="#SVGID_247_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_249_"
                  gradientUnits="userSpaceOnUse"
                  x1="-77.2868"
                  y1="838.3647"
                  x2="-76.3009"
                  y2="838.3647"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st172"
                  points="934.5,97.4 960.2,112.3 943.6,141.1 917.9,126.3      "
                />
              </g>
              <polygon
                class="st87"
                points="945.8,131.4 946.6,133.3 947.5,138.3 948.7,138.3 949.6,133.3 950.4,131.4     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M907.3,101.7c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C906.8,102.9,907.3,102.2,907.3,101.7"
                />
                <polygon
                  class="st87"
                  points="902.7,133.3 904,133.3 904,128.9 902.4,128.9      "
                />
                <path
                  class="st87"
                  d="M903.3,109.7c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C903.5,111.6,903,110.5,903.3,109.7"
                />
                <path
                  class="st88"
                  d="M902.9,108.3c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C902.7,110.1,903.2,109.1,902.9,108.3"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_250_"
                    d="M917.5,105.3c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C917.8,105.3,917.7,105.3,917.5,105.3"
                  />
                </defs>
                <clipPath id="SVGID_251_">
                  <use xlink:href="#SVGID_250_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_252_"
                  gradientUnits="userSpaceOnUse"
                  x1="-87.0576"
                  y1="850.9434"
                  x2="-86.0717"
                  y2="850.9434"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st173"
                  points="890.7,112.3 916.4,97.4 933.1,126.3 907.4,141.1      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_253_"
                    d="M886.1,107.1c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C887.5,105.3,886.5,106,886.1,107.1"
                  />
                </defs>
                <clipPath id="SVGID_254_">
                  <use xlink:href="#SVGID_253_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_255_"
                  gradientUnits="userSpaceOnUse"
                  x1="-78.6347"
                  y1="837.5865"
                  x2="-77.6488"
                  y2="837.5865"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st174"
                  points="890.3,97.4 916,112.3 899.3,141.1 873.6,126.3      "
                />
              </g>
              <polygon
                class="st87"
                points="901.6,131.4 902.3,133.3 903.2,138.3 904.5,138.3 905.4,133.3 906.1,131.4     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M865.7,101.7c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C865.3,102.9,865.8,102.2,865.7,101.7"
                />
                <polygon
                  class="st87"
                  points="861.1,133.3 862.4,133.3 862.4,128.9 860.8,128.9      "
                />
                <path
                  class="st87"
                  d="M861.7,109.7c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C861.9,111.6,861.4,110.5,861.7,109.7"
                />
                <path
                  class="st88"
                  d="M861.3,108.3c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C861.1,110.1,861.6,109.1,861.3,108.3"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_256_"
                    d="M875.9,105.3c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C876.3,105.3,876.1,105.3,875.9,105.3"
                  />
                </defs>
                <clipPath id="SVGID_257_">
                  <use xlink:href="#SVGID_256_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_258_"
                  gradientUnits="userSpaceOnUse"
                  x1="-88.3238"
                  y1="851.6745"
                  x2="-87.3379"
                  y2="851.6745"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st175"
                  points="849.1,112.3 874.8,97.4 891.5,126.3 865.8,141.1      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_259_"
                    d="M844.5,107.1c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C845.9,105.3,844.9,106,844.5,107.1"
                  />
                </defs>
                <clipPath id="SVGID_260_">
                  <use xlink:href="#SVGID_259_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_261_"
                  gradientUnits="userSpaceOnUse"
                  x1="-79.9009"
                  y1="836.8554"
                  x2="-78.915"
                  y2="836.8554"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st176"
                  points="848.7,97.4 874.4,112.3 857.7,141.1 832,126.3      "
                />
              </g>
              <polygon
                class="st87"
                points="860,131.4 860.7,133.3 861.6,138.3 862.9,138.3 863.8,133.3 864.5,131.4     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M822.8,101.7c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C822.3,102.9,822.8,102.2,822.8,101.7"
                />
                <polygon
                  class="st87"
                  points="818.2,133.3 819.5,133.3 819.5,128.9 817.9,128.9      "
                />
                <path
                  class="st87"
                  d="M818.8,109.7c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C819,111.6,818.5,110.5,818.8,109.7"
                />
                <path
                  class="st88"
                  d="M818.4,108.3c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C818.2,110.1,818.7,109.1,818.4,108.3"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_262_"
                    d="M833,105.3c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C833.3,105.3,833.2,105.3,833,105.3"
                  />
                </defs>
                <clipPath id="SVGID_263_">
                  <use xlink:href="#SVGID_262_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_264_"
                  gradientUnits="userSpaceOnUse"
                  x1="-89.6309"
                  y1="852.4291"
                  x2="-88.645"
                  y2="852.4291"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st177"
                  points="806.2,112.3 831.9,97.4 848.6,126.3 822.9,141.1      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_265_"
                    d="M801.6,107.1c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C803,105.3,801.9,106,801.6,107.1"
                  />
                </defs>
                <clipPath id="SVGID_266_">
                  <use xlink:href="#SVGID_265_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_267_"
                  gradientUnits="userSpaceOnUse"
                  x1="-81.208"
                  y1="836.1008"
                  x2="-80.2221"
                  y2="836.1008"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st178"
                  points="805.8,97.4 831.5,112.3 814.8,141.1 789.1,126.3      "
                />
              </g>
              <polygon
                class="st87"
                points="817.1,131.4 817.8,133.3 818.7,138.3 820,138.3 820.9,133.3 821.6,131.4     "
              />
            </g>
            <g>
              <g>
                <path
                  class="st86"
                  d="M779.8,101.7c-0.1-0.6-0.7-1.1-0.9-1.6c-0.2-0.6,0.2-1.3-0.1-1.9c-0.2-0.5-1-0.8-1.3-1.3       c-0.3-0.5-0.2-1.3-0.6-1.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6-0.5-1.5-0.5-2.1,0c-0.1,0.1-0.1,0.1-0.2,0.2       c-0.4,0.5-0.3,1.3-0.6,1.8c-0.3,0.5-1.1,0.8-1.3,1.3c-0.2,0.6,0.1,1.3-0.1,1.9c-0.2,0.6-0.8,1.1-0.9,1.6       c-0.1,0.6,0.4,1.2,0.4,1.8c0,0.6-0.5,1.2-0.4,1.8c0.1,0.6,0.7,1.1,0.9,1.6c0.2,0.6-0.1,1.3,0.1,1.9c0.2,0.5,1,1.5,1.3,2       c0.3,0.5,0.8,0.6,1.2,1.1l0.3,1.5h0.6l0.3-1.5c0.4-0.5,0.8-0.5,1.2-1c0.3-0.5,1.1-1.6,1.3-2.1c0.2-0.5-0.1-1.3,0.1-1.9       c0.2-0.6,0.8-1,0.9-1.6c0.1-0.6-0.4-1.2-0.4-1.8C779.4,102.9,779.9,102.2,779.8,101.7"
                />
                <polygon
                  class="st87"
                  points="775.3,133.3 776.5,133.3 776.5,128.9 775,128.9      "
                />
                <path
                  class="st87"
                  d="M775.9,109.7c0.3-0.8,1.5-1.3,1.9-2.1c0.4-0.8,0.3-2,0.8-2.7c0.5-0.7,1.8-0.8,2.4-1.5       c0.6-0.6,0.8-1.8,1.5-2.4c0.1-0.1,0.2-0.2,0.4-0.2c1.1-0.5,2.4-0.2,3.1,0.8c0.1,0.1,0.1,0.2,0.2,0.4c0.4,0.8-0.1,2,0.2,2.8       c0.2,0.9,1.2,1.6,1.4,2.5c0.1,0.9-0.6,1.8-0.6,2.7c0,0.9,0.8,1.8,0.6,2.7c-0.1,0.9-1.1,1.6-1.3,2.5c-0.2,0.9,0.2,2-0.1,2.8       c-0.4,0.8-1.5,1.2-2,2c-0.5,0.8-0.3,2-0.9,2.7c-0.6,0.7-2,1.8-2.7,2.4c-0.6,0.6-1.4,0.6-2.1,1.1l-1,2l-0.9-0.2l0.2-2.2       c-0.4-0.8-1-1-1.3-1.9c-0.3-0.9-1-2.7-1.1-3.6c-0.1-0.9,0.6-1.9,0.6-2.8c0-0.9-0.8-1.8-0.7-2.7c0.1-0.9,1.1-1.6,1.3-2.5       C776,111.6,775.5,110.5,775.9,109.7"
                />
                <path
                  class="st88"
                  d="M775.4,108.3c-0.3-0.8-1.3-1.2-1.7-1.9c-0.4-0.7-0.3-1.8-0.8-2.4c-0.5-0.6-1.6-0.7-2.2-1.3       c-0.6-0.6-0.7-1.7-1.4-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1-0.5-2.2-0.2-2.8,0.8c-0.1,0.1-0.1,0.2-0.2,0.3       c-0.3,0.8,0.1,1.8-0.1,2.5c-0.2,0.8-1.1,1.4-1.2,2.2c-0.1,0.8,0.6,1.7,0.6,2.5c0,0.8-0.7,1.7-0.6,2.5c0.1,0.8,1,1.5,1.2,2.2       c0.2,0.8-0.2,1.8,0.1,2.5c0.3,0.7,1.4,1.1,1.8,1.8c0.4,0.7,0.3,1.8,0.8,2.4c0.5,0.6,1.9,1.6,2.5,2.2c0.6,0.6,1.2,0.5,1.9,1       l0.9,1.8l0.8-0.2l-0.2-2c0.3-0.7,0.9-0.9,1.2-1.7c0.2-0.8,0.9-2.4,1-3.2c0.1-0.8-0.5-1.7-0.5-2.5c0-0.8,0.7-1.7,0.6-2.5       c-0.1-0.8-1-1.5-1.2-2.3C775.3,110.1,775.7,109.1,775.4,108.3"
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_268_"
                    d="M790.1,105.3c-0.1,0-0.3,0.1-0.4,0.1c-0.9,0.4-1.5,1.6-2.3,2.1c-0.9,0.5-2.2,0.3-3,0.9        c-0.8,0.6-1,1.9-1.7,2.6c-0.7,0.7-2.1,0.9-2.7,1.7c-0.6,0.8-0.4,2.1-0.9,3c-0.5,0.9-1.7,1.4-2.1,2.3c-0.4,0.9,0.2,2.2,0,3.1        c-0.2,1-1.3,1.8-1.4,2.8c-0.1,1,0.1,3.2,0.1,4.2c0,1,0.7,1.4,0.9,2.4l-0.8,2.3l0.9,0.5l1.6-1.9c0.9-0.3,1.7-0.1,2.6-0.6        c0.9-0.5,2.8-1.2,3.6-1.8c0.8-0.6,1-1.9,1.7-2.6c0.7-0.7,2.1-0.8,2.7-1.6c0.6-0.8,0.4-2.1,0.9-3c0.5-0.9,1.8-1.3,2.2-2.3        c0.4-0.9-0.2-2.2,0.1-3.1c0.3-1,1.3-1.8,1.5-2.8c0.1-1-0.7-2-0.8-3c0-1,0.8-2.1,0.6-3.1c0-0.2-0.1-0.3-0.1-0.4        c-0.4-1.1-1.4-1.8-2.6-1.8C790.4,105.3,790.2,105.3,790.1,105.3"
                  />
                </defs>
                <clipPath id="SVGID_269_">
                  <use xlink:href="#SVGID_268_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_270_"
                  gradientUnits="userSpaceOnUse"
                  x1="-90.938"
                  y1="853.1838"
                  x2="-89.9521"
                  y2="853.1838"
                  gradientTransform="matrix(24.6298 -14.22 -14.22 -24.6298 15144.127 19847.0938)"
                >
                  <stop offset="0" style="stop-color: #709941" />
                  <stop offset="0.3968" style="stop-color: #648936" />
                  <stop offset="0.5145" style="stop-color: #608332" />
                  <stop offset="1" style="stop-color: #5f8231" />
                </linearGradient>
                <polygon
                  class="st179"
                  points="763.3,112.3 789,97.4 805.6,126.3 779.9,141.1      "
                />
              </g>
              <g>
                <defs>
                  <path
                    id="SVGID_271_"
                    d="M758.6,107.1c0,0.1-0.1,0.3-0.1,0.4c-0.2,1,0.7,2.1,0.6,3.1c0,1-0.9,2.1-0.8,3c0.1,1,1.2,1.8,1.5,2.8        c0.3,1-0.3,2.2,0.1,3.1c0.4,0.9,1.6,1.4,2.2,2.3c0.5,0.9,0.3,2.2,0.9,3c0.6,0.8,2,0.9,2.7,1.6c0.7,0.7,0.9,2,1.7,2.6        c0.8,0.6,2.7,1.3,3.6,1.8c0.9,0.5,1.6,0.2,2.6,0.6l1.6,1.9l0.9-0.5l-0.8-2.3c0.2-1,0.8-1.4,0.9-2.4c0-1,0.2-3.2,0.1-4.2        c-0.1-1-1.2-1.8-1.4-2.8c-0.2-1,0.3-2.2,0-3.1c-0.4-0.9-1.6-1.4-2.1-2.3c-0.5-0.9-0.3-2.2-0.9-3c-0.6-0.8-1.9-0.9-2.7-1.7        c-0.7-0.7-0.9-2-1.7-2.6c-0.8-0.6-2.1-0.4-3-0.9c-0.9-0.5-1.4-1.7-2.3-2.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1        C760.1,105.3,759,106,758.6,107.1"
                  />
                </defs>
                <clipPath id="SVGID_272_">
                  <use xlink:href="#SVGID_271_" style="overflow: visible" />
                </clipPath>

                <linearGradient
                  id="SVGID_273_"
                  gradientUnits="userSpaceOnUse"
                  x1="-82.5151"
                  y1="835.3461"
                  x2="-81.5292"
                  y2="835.3461"
                  gradientTransform="matrix(24.6298 14.22 14.22 -24.6298 -9090.8252 21860.2461)"
                >
                  <stop offset="0" style="stop-color: #9cc666" />
                  <stop offset="0.1832" style="stop-color: #9cc666" />
                  <stop offset="0.2722" style="stop-color: #93bd5e" />
                  <stop offset="0.513" style="stop-color: #80a94e" />
                  <stop offset="0.7554" style="stop-color: #749d44" />
                  <stop offset="1" style="stop-color: #709941" />
                  <stop offset="1" style="stop-color: #231f20" />
                </linearGradient>
                <polygon
                  class="st180"
                  points="762.8,97.4 788.5,112.3 771.9,141.1 746.2,126.3      "
                />
              </g>
              <polygon
                class="st87"
                points="774.1,131.4 774.9,133.3 775.8,138.3 777,138.3 777.9,133.3 778.7,131.4     "
              />
            </g>
          </g>
          <path
            class="st119"
            d="M1409.8,162.6H752.9c-7.7,0-14-6.3-14-14c0-7.7,6.3-14,14-14h656.8c7.7,0,14,6.3,14,14    C1423.7,156.3,1417.5,162.6,1409.8,162.6"
          />
          <g>
            <path
              class="st120"
              d="M1392.3,134.6c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1349.2,134.6c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M788.9,134.6c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M832,134.6c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M875.1,134.6c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M918.2,134.6c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M961.3,134.6c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1004.4,134.6c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1047.5,134.6c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1090.6,134.6c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1133.7,134.6c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1176.8,134.6c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1219.9,134.6c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1263,134.6c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
            <path
              class="st120"
              d="M1306.1,134.6c0,4-5.7,7.3-12.7,7.3c-7,0-12.7-3.3-12.7-7.3"
            />
          </g>
        </g>
        <path
          class="st119"
          d="M1409.8,50H752.9c-7.7,0-14-6.3-14-14c0-7.7,6.3-14,14-14h656.8c7.7,0,14,6.3,14,14   C1423.7,43.7,1417.5,50,1409.8,50"
        />
      </g>
      <g>
        <path
          v-if="getRealTime.Valve[17].On || getRealTime.Valve[2].On"
          class="st30"
          d="M1417.5,263.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6s-8.6-3.6-17.3-3.6   c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6s-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6   c-8.6,0-8.6-3.6-17.3-3.6s-8.6,3.6-17.3,3.6s-8.6-3.6-17.3-3.6s-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6   c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6s-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6   c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6   c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6   c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6   c-8.6,0-8.6-3.6-17.3-3.6s-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-1.9,0-4.1,0.3-5.4,0   c0.5,7.8,7.4,13.4,13.4,13.4h658.3c3.6-0.8,4.7-1.1,6.6-2.3c4.2-2.7,6.3-6.8,6.3-12.7c0-0.5-0.2-1.3-0.2-1.8   C1421.8,263.8,1418.9,263.6,1417.5,263.6"
        />
        <path
          v-if="getRealTime.Valve[16].On || getRealTime.Valve[1].On"
          class="st30"
          d="M1417.1,382.8c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6s-8.6-3.6-17.3-3.6   c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6s-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6   c-8.6,0-8.6-3.6-17.3-3.6s-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6s-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6   c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6   c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6s-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6   s-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6   c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6s-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6   c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6s-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6   c-1.9,0-4.1,0.3-5.4,0c0.5,7.8,7.4,13.4,13.4,13.4h658.3c3.6-0.8,4.7-1.1,6.6-2.3c4.2-2.7,6.3-6.8,6.3-12.7c0-0.5-0.2-1.3-0.2-1.8   C1421.5,383,1418.5,382.8,1417.1,382.8"
        />
        <path
          v-if="getRealTime.Valve[18].On || getRealTime.Valve[3].On"
          class="st30"
          d="M1418,145.7c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6s-8.6-3.6-17.3-3.6   c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6   c-8.6,0-8.6-3.6-17.3-3.6s-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6s-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6   c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6   c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6   c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6   c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6s-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6   c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6s-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6   c-1.9,0-4.1,0.3-5.4,0c0.5,7.8,7.4,13.4,13.4,13.4h658.3c3.6-0.8,4.7-1.1,6.6-2.3c4.2-2.7,6.3-6.8,6.3-12.7c0-0.5-0.2-1.3-0.2-1.8   C1422.3,145.9,1419.4,145.7,1418,145.7"
        />
      </g>
      <g>
        <path
          v-if="getRealTime.Valve[12].On"
          class="st38"
          d="M1417.5,263.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6s-8.6-3.6-17.3-3.6   c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6s-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6   c-8.6,0-8.6-3.6-17.3-3.6s-8.6,3.6-17.3,3.6s-8.6-3.6-17.3-3.6s-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6   c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6s-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6   c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6   c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6   c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6   c-8.6,0-8.6-3.6-17.3-3.6s-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-1.9,0-4.1,0.3-5.4,0   c0.5,7.8,7.4,13.4,13.4,13.4h658.3c3.6-0.8,4.7-1.1,6.6-2.3c4.2-2.7,6.3-6.8,6.3-12.7c0-0.5-0.2-1.3-0.2-1.8   C1421.8,263.8,1418.9,263.6,1417.5,263.6"
        />
        <path
          v-if="getRealTime.Valve[11].On"
          class="st38"
          d="M1417.1,382.8c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6s-8.6-3.6-17.3-3.6   c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6s-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6   c-8.6,0-8.6-3.6-17.3-3.6s-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6s-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6   c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6   c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6s-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6   s-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6   c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6s-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6   c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6s-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6   c-1.9,0-4.1,0.3-5.4,0c0.5,7.8,7.4,13.4,13.4,13.4h658.3c3.6-0.8,4.7-1.1,6.6-2.3c4.2-2.7,6.3-6.8,6.3-12.7c0-0.5-0.2-1.3-0.2-1.8   C1421.5,383,1418.5,382.8,1417.1,382.8"
        />
        <path
          v-if="getRealTime.Valve[13].On"
          class="st38"
          d="M1418,145.7c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6s-8.6-3.6-17.3-3.6   c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6   c-8.6,0-8.6-3.6-17.3-3.6s-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6s-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6   c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6   c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6   c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6   c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6s-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6   c-8.6,0-8.6,3.6-17.3,3.6c-8.6,0-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6s-8.6-3.6-17.3-3.6c-8.6,0-8.6,3.6-17.3,3.6   c-1.9,0-4.1,0.3-5.4,0c0.5,7.8,7.4,13.4,13.4,13.4h658.3c3.6-0.8,4.7-1.1,6.6-2.3c4.2-2.7,6.3-6.8,6.3-12.7c0-0.5-0.2-1.3-0.2-1.8   C1422.3,145.9,1419.4,145.7,1418,145.7"
        />
      </g>
      <g></g>
      <g>
        <g v-if="getRealTime.Valve[0].On">
          <path
            class="st32"
            d="M792.9,636.1c-1.2,7.1-5.8,13.7-4.8,20.8c0.4,2.9,1.7,5.5,2.4,8.3c1.1,4.8,0,10.2-3,13.8    c-0.7,0.9-1.5,1.7-2.2,2.6c-1,1.4-1.7,3.2-2.1,5c-1.5,6.6,0.5,14.1,4.9,18.8c-5.9-3.6-8.4-11.9-8.1-19.5c0.1-2,0.3-4.1,1-6    c0.7-1.9,1.7-3.6,2.7-5.4c1.3-2.3,2.6-4.8,2.7-7.5c0.2-5.1-3.3-9.4-4-14.4c-0.4-3.4,0.5-6.9,1.8-10c1.3-3.1,3-6,4.1-9.3    c0.9-2.5,1.4-5.2,1.5-7.9c0.1-3,0-6.1-0.4-9c-0.1-0.8-0.1-4.1-0.1-4.1c1-0.3,3,0,3.7,0c0.7,0,0.8,11.1,0.8,12.1    C793.9,628.3,793.5,632.4,792.9,636.1"
          />
          <path
            class="st33"
            d="M790.4,698.6c0.1,0,0.2,0,0.2-0.1c0.4-0.2-0.4-1.9-0.5-2.3c-0.2-1.4,0.2-3,0.4-4.4c0.4-2.4,1.1-4.9,1.2-7.4    c0-0.7,0-1.4-0.1-2.1c-0.4-2.8-1.5-5.5-2.8-7.9c-1.6-3.1-3.5-6.1-4.5-9.5c-1.4-4.8-1-10.2,1.2-14.6c2.2-4.5,6.1-7.9,7.5-12.8    c0.7-2.4,0.7-5,0.7-7.5c0-6.3,2.7-12.8-0.7-17.7c0.9,5.8-1.9,11.4-2.1,17.3c-0.1,2.8-0.3,5.6-1.4,8.1c-1.5,3.5-4.5,5.8-6.6,9    c-1.9,2.9-3,6.5-3,10.1c0,3.3,0.8,6.6,1.7,9.7c1,3.6,2.2,7.2,4.4,10.1c1.7,2.2,2.7,3.2,3,6c0.5,4.1-0.6,8.1-0.2,12    C788.9,695,789.4,698.8,790.4,698.6"
          />
          <path
            class="st34"
            d="M796.4,636.6c-1.4,4-4,7.6-4,11.9c0.1,2.8,1.3,5.3,2.1,7.9c2.5,7.9,1.2,17.1-3.2,23.8    c-1.2,1.8-2.5,3.4-3.6,5.2c-3.1,5.2-3.4,12.4-0.9,18c1.3,2.9,3.3,5.4,4.1,8.5c0.3,1.2,0.8,3.6,0,4.7c-0.4-0.8-0.3-1.7-0.6-2.6    c-0.8-2.2-2.2-3.9-3.5-5.7c-2.1-2.9-3.9-6-4.9-9.5c-1.9-6.8-0.3-14.4,2.9-20.6c1.6-3.1,3.6-6.2,3.9-9.7c0.4-4.5-2-8.9-2.1-13.4    c-0.1-6.4,4.1-11.6,6.7-17.2c1.4-3,2.4-6.3,2.9-9.6c0.8-5.1,0.1-10.6,0-15.8C798.4,619.6,799,629.3,796.4,636.6"
          />
          <path
            class="st35"
            d="M793,645.3c-1.5,3.4-3.6,6.8-3.4,10.5c0.1,1.8,0.7,3.5,1.2,5.2c2.1,6.7,2.9,14.5,0,20.9    c-1.2,2.7-3.1,5-3.9,7.9c-1,3.5,0,9.1,2,12c-5.2-4.7-5.4-13.3-2.9-19.9c1.2-3,2.7-5.3,3.1-8.6c0.5-3.9-0.9-7.3-2-10.9    c-1.5-4.4-1.2-8.5,0.5-12.8c1.5-3.8,3.7-7.2,5.2-11c1-2.7,0.9-5.9,1.1-8.8c0.4-3.6-0.8-13.9-0.8-17.4c0.7,4.3,2.8,12.6,2.6,17    C795.5,633.9,794.8,641.2,793,645.3"
          />
          <path
            class="st36"
            d="M792.4,612.3h4.7c1.4,6,0.7,12.5-0.1,18.6c-0.4,2.9-0.9,5.9-2,8.6c-1.6,4.1-4.3,7.6-5.3,11.9    c-1.1,4.6,0,9.5,1,14.2c0.8,3.9,1.6,8.3,0.5,12.2c-1,3.7-3.6,6.6-4.1,10.6c-0.4,2.6-0.1,5.4,0.3,8c0.2,1.5,0.6,2.9,1,4.4    c0.4,1.2,1.3,2.6,1.1,3.8c-2.3-1.6-3.6-6.4-4.1-9c-0.6-3.5-0.3-7.1,0.7-10.4c1.3-4.1,4.3-7.7,4.2-12c0-5.1-4.1-9-4.9-14    c-0.6-3.5,0.6-7.1,2.1-10.1c1.6-3.1,3.6-5.8,5.1-8.9C796.8,631.9,796.5,620.6,792.4,612.3"
          />
        </g>
        <g>
          <rect
            x="785.6"
            y="545.1"
            :class="getRealTime.Valve[0].On ? 'st64' : 'st84'"
            width="15.3"
            height="48.5"
          />
          <rect x="800.9" y="559.5" class="st12" width="4.9" height="19" />
          <rect x="805.9" y="566.4" class="st12" width="15.5" height="5" />
          <polygon
            :class="getRealTime.Valve[0].On ? 'st64' : 'st84'"
            points="817.5,566.4 821.5,553.6 809.9,553.6 809.9,566.4   "
          />
          <polygon
            :class="getRealTime.Valve[0].On ? 'st64' : 'st84'"
            points="817.5,572 821.5,584.9 809.9,584.9 809.9,572   "
          />
          <rect
            x="809.9"
            y="566.4"
            :class="getRealTime.Valve[0].On ? 'st64' : 'st84'"
            width="7.6"
            height="5.6"
          />
        </g>
        <path
          :class="
            getRealTime.Valve[16].On ||
            getRealTime.Valve[17].On ||
            getRealTime.Valve[18].On ||
            getRealTime.Valve[0].On
              ? 'st19'
              : 'st8'
          "
          d="M794.4,510.2h665.2c2.7,0,4.9-2.2,4.9-4.9v-49.1c0-2.1-1.7-3.7-3.7-3.7h-17.5v-9.7h16.8c2.5,0,4.6-2,4.6-4.6   l0-100.7c0-2.5-2-4.6-4.6-4.6h-16.8l0-9.4l16.4,0c2.2,0,4-1.8,4-4l-0.2-101.3c0-1.9-1.5-3.3-3.4-3.3h-16.8v-9.1l24.7,0   c3.8,0,7,3.1,7,7v230.1v69.4c0,4-3.3,7.3-7.3,7.3l-668.6-1.6c-1.2,0-2.2,1-2.2,2.2v25h-8v-24.7c0-1.4-1.2-2.6-2.7-2.6H602.6   c-2.4,0-4.4-2-4.4-4.4v-34.1c0-1.4-1.2-2.6-2.7-2.6l-254.4-0.2v-7l254.4-0.4c5.9,0,10.7,4.6,10.7,10.3v27.8c0,1.6,1.3,2.9,2.9,2.9   H794.4z"
        />
        <rect
          x="789.1"
          y="593.7"
          :class="getRealTime.Valve[0].On ? 'st19' : 'st8'"
          width="8.4"
          height="13"
        />
      </g>
      <g>
        <g>
          <polygon
            class="st8"
            points="702.1,482.3 702.1,329.9 717.1,329.9 717.1,320.8 693.5,320.6 693.5,482.3   "
          />
          <path
            class="st8"
            d="M702.1,482.3l0-269.1c0-1.5,1.2-2.6,2.6-2.6h11.6V202h-18.4c-2.4,0-4.4,2-4.4,4.4v275.9H702.1z"
          />
          <polygon
            class="st8"
            points="702.1,482.3 702.1,448.6 717,448.6 717,439.3 693.5,439.3 693.5,482.3   "
          />
        </g>
        <g>
          <polygon
            v-if="getRealTime.Valve[12].On == true"
            class="st38"
            points="702.1,482.3 702.1,329.9 717.1,329.9 717.1,320.8 693.5,320.6 693.5,482.3   "
          />
          <path
            class="st38"
            v-if="getRealTime.Valve[13].On == true"
            d="M702.1,482.3l0-269.1c0-1.5,1.2-2.6,2.6-2.6h11.6V202h-18.4c-2.4,0-4.4,2-4.4,4.4v275.9H702.1z"
          />
          <polygon
            v-if="getRealTime.Valve[11].On == true"
            class="st38"
            points="702.1,482.3 702.1,448.6 717,448.6 717,439.3 693.5,439.3 693.5,482.3   "
          />
        </g>
        <path
          :class="
            getRealTime.Valve[13].On ||
            getRealTime.Valve[12].On ||
            getRealTime.Valve[11].On
              ? 'st38'
              : 'st8'
          "
          d="M1164.4,490.6H697.9c-2.4,0-4.4-2-4.4-4.4v-4h473.3c3,0,5.4,2.4,5.4,5.4l0.1,98.9h-7.6L1164.4,490.6z"
        />
        <g>
          <g>
            <rect
              x="717.1"
              y="319.9"
              :class="getRealTime.Valve[12].On ? 'st64' : 'st84'"
              width="38.1"
              height="11.4"
            />
            <rect x="728.3" y="316.2" class="st12" width="14.1" height="3.7" />
            <rect x="733.5" y="304.7" class="st12" width="3.8" height="11.5" />
            <polygon
              :class="getRealTime.Valve[12].On ? 'st64' : 'st84'"
              points="737.2,307.6 746.8,304.6 746.8,313.3 737.2,313.3    "
            />
            <polygon
              :class="getRealTime.Valve[12].On ? 'st64' : 'st84'"
              points="733.1,307.6 723.5,304.6 723.5,313.3 733.1,313.3    "
            />
            <rect
              x="733.1"
              y="307.6"
              :class="getRealTime.Valve[12].On ? 'st64' : 'st84'"
              width="4.2"
              height="5.7"
            />
          </g>
          <path
            :class="
              getRealTime.Valve[17].On ||
              getRealTime.Valve[2].On ||
              getRealTime.Valve[12].On
                ? 'st38'
                : 'st8'
            "
            d="M755.2,321.1h24.3l0-40.4h9v43.8c0,3.1-2.5,5.6-5.6,5.6h-27.6V321.1z"
          />
        </g>
        <g>
          <g>
            <rect
              x="717"
              y="438.6"
              :class="getRealTime.Valve[11].On ? 'st64' : 'st84'"
              width="38.1"
              height="11.4"
            />
            <rect x="728.3" y="434.9" class="st12" width="14.1" height="3.7" />
            <rect x="733.5" y="423.4" class="st12" width="3.8" height="11.5" />
            <polygon
              :class="getRealTime.Valve[11].On ? 'st64' : 'st84'"
              points="737.3,426.2 746.8,423.3 746.8,431.9 737.3,431.9    "
            />
            <polygon
              :class="getRealTime.Valve[11].On ? 'st64' : 'st84'"
              points="733.1,426.2 723.5,423.3 723.5,431.9 733.1,431.9    "
            />
            <rect
              x="733.1"
              y="426.2"
              :class="getRealTime.Valve[11].On ? 'st64' : 'st84'"
              width="4.2"
              height="5.7"
            />
          </g>
          <path
            :class="
              getRealTime.Valve[16].On ||
              getRealTime.Valve[1].On ||
              getRealTime.Valve[11].On
                ? 'st38'
                : 'st8'
            "
            d="M755.1,439.9h24.3l0-40h9v43.8c0,2.9-2.3,5.2-5.2,5.2h-28V439.9z"
          />
        </g>
        <g>
          <g>
            <rect
              x="716.3"
              y="200.6"
              :class="getRealTime.Valve[13].On ? 'st64' : 'st84'"
              width="38.1"
              height="11.4"
            />
            <g>
              <rect
                x="727.5"
                y="196.9"
                class="st12"
                width="14.1"
                height="3.7"
              />
              <rect
                x="732.7"
                y="185.4"
                class="st12"
                width="3.8"
                height="11.5"
              />
              <polygon
                :class="getRealTime.Valve[13].On ? 'st64' : 'st84'"
                points="736.4,188.3 746,185.3 746,194 736.4,194     "
              />
              <polygon
                :class="getRealTime.Valve[13].On ? 'st64' : 'st84'"
                points="732.3,188.3 722.7,185.3 722.7,194 732.3,194     "
              />
              <rect
                x="732.3"
                y="188.3"
                :class="getRealTime.Valve[13].On ? 'st64' : 'st84'"
                width="4.2"
                height="5.7"
              />
            </g>
          </g>
          <path
            :class="
              getRealTime.Valve[18].On ||
              getRealTime.Valve[3].On ||
              getRealTime.Valve[13].On
                ? 'st38'
                : 'st8'
            "
            d="M754.5,201.7l24.3,0l0-39.7h9v43.5c0,2.9-2.3,5.2-5.2,5.2h-27.9V201.7z"
          />
        </g>
      </g>
      <g id="setLayer">
        <g id="layer3">
          <g>
            <path
              v-if="getAccess.role != 'User'"
              id="setLayer3"
              class="st185 pointer"
              d="M1561.7,148.5c0-7.4,6-13.4,13.5-13.4c7.4,0,13.5,6,13.5,13.4c0,7.4-6,13.4-13.5,13.4     C1567.7,161.7,1561.7,155.7,1561.7,148.5"
            />
            <path
              v-if="getAccess.role != 'User'"
              id="setLayer3"
              class="st25 pointer"
              d="M1582.2,149.4c0-0.3,0.1-0.7,0.1-0.9s0-0.7-0.1-0.9l2-1.6c0.1-0.1,0.3-0.4,0.1-0.7l-1.9-3.3     c-0.1-0.3-0.4-0.3-0.5-0.3l-2.4,0.9c-0.5-0.4-1.1-0.7-1.6-0.9l-0.4-2.5c0-0.3-0.3-0.4-0.5-0.4h-3.8c-0.3,0-0.4,0.1-0.5,0.4     l-0.4,2.5c-0.5,0.3-1.1,0.5-1.6,0.9l-2.4-0.9c-0.3-0.1-0.4,0-0.5,0.3l-1.9,3.3c-0.1,0.3-0.1,0.4,0.1,0.7l2,1.6     c0,0.3-0.1,0.7-0.1,0.9s0,0.7,0.1,0.9l-2,1.6c-0.1,0.1-0.3,0.4-0.1,0.7l1.9,3.3c0.1,0.3,0.4,0.3,0.5,0.3l2.4-0.9     c0.5,0.4,1.1,0.7,1.6,0.9l0.4,2.5c0,0.3,0.3,0.4,0.5,0.4h3.8c0.3,0,0.4-0.1,0.5-0.4l0.4-2.5c0.5-0.3,1.1-0.5,1.6-0.9l2.4,0.9     c0.3,0.1,0.4,0,0.5-0.3l1.9-3.3c0.1-0.3,0.1-0.4-0.1-0.7L1582.2,149.4z M1575.2,151.8c-1.9,0-3.4-1.6-3.4-3.4s1.6-3.4,3.4-3.4     c1.9,0,3.4,1.6,3.4,3.4S1577.1,151.8,1575.2,151.8z"
            />
          </g>
        </g>
        <g id="layer2">
          <g>
            <path
              v-if="getAccess.role != 'User'"
              id="setLayer2"
              class="st185 pointer"
              d="M1561.7,265.8c0-7.4,6-13.4,13.5-13.4c7.4,0,13.5,6,13.5,13.4c0,7.4-6,13.4-13.5,13.4     C1567.7,279.1,1561.7,273.1,1561.7,265.8"
            />
            <path
              v-if="getAccess.role != 'User'"
              id="setLayer2"
              class="st25 pointer"
              d="M1582.2,266.8c0-0.3,0.1-0.7,0.1-0.9c0-0.3,0-0.7-0.1-0.9l2-1.6c0.1-0.1,0.3-0.4,0.1-0.7l-1.9-3.3     c-0.1-0.3-0.4-0.3-0.5-0.3l-2.4,0.9c-0.5-0.4-1.1-0.7-1.6-0.9l-0.4-2.5c0-0.3-0.3-0.4-0.5-0.4h-3.8c-0.3,0-0.4,0.1-0.5,0.4     l-0.4,2.5c-0.5,0.3-1.1,0.5-1.6,0.9l-2.4-0.9c-0.3-0.1-0.4,0-0.5,0.3l-1.9,3.3c-0.1,0.3-0.1,0.4,0.1,0.7l2,1.6     c0,0.3-0.1,0.7-0.1,0.9c0,0.3,0,0.7,0.1,0.9l-2,1.6c-0.1,0.1-0.3,0.4-0.1,0.7l1.9,3.3c0.1,0.3,0.4,0.3,0.5,0.3l2.4-0.9     c0.5,0.4,1.1,0.7,1.6,0.9l0.4,2.5c0,0.3,0.3,0.4,0.5,0.4h3.8c0.3,0,0.4-0.1,0.5-0.4l0.4-2.5c0.5-0.3,1.1-0.5,1.6-0.9l2.4,0.9     c0.3,0.1,0.4,0,0.5-0.3l1.9-3.3c0.1-0.3,0.1-0.4-0.1-0.7L1582.2,266.8z M1575.2,269.1c-1.9,0-3.4-1.6-3.4-3.4s1.6-3.4,3.4-3.4     c1.9,0,3.4,1.6,3.4,3.4S1577.1,269.1,1575.2,269.1z"
            />
          </g>
        </g>
        <g id="layer1">
          <g>
            <path
              v-if="getAccess.role != 'User'"
              id="setLayer1 "
              class="st185 pointer"
              d="M1561.7,385.3c0-7.4,6-13.4,13.5-13.4c7.4,0,13.5,6,13.5,13.4s-6,13.4-13.5,13.4     C1567.7,398.5,1561.7,392.5,1561.7,385.3"
            />
            <path
              v-if="getAccess.role != 'User'"
              id="setLayer1 "
              class="st25 pointer"
              d="M1582.2,386.2c0-0.3,0.1-0.7,0.1-0.9s0-0.7-0.1-0.9l2-1.6c0.1-0.1,0.3-0.4,0.1-0.7l-1.9-3.3     c-0.1-0.3-0.4-0.3-0.5-0.3l-2.4,0.9c-0.5-0.4-1.1-0.7-1.6-0.9l-0.4-2.5c0-0.3-0.3-0.4-0.5-0.4h-3.8c-0.3,0-0.4,0.1-0.5,0.4     l-0.4,2.5c-0.5,0.3-1.1,0.5-1.6,0.9l-2.4-0.9c-0.3-0.1-0.4,0-0.5,0.3l-1.9,3.3c-0.1,0.3-0.1,0.4,0.1,0.7l2,1.6     c0,0.3-0.1,0.7-0.1,0.9s0,0.7,0.1,0.9l-2,1.6c-0.1,0.1-0.3,0.4-0.1,0.7l1.9,3.3c0.1,0.3,0.4,0.3,0.5,0.3l2.4-0.9     c0.5,0.4,1.1,0.7,1.6,0.9l0.4,2.5c0,0.3,0.3,0.4,0.5,0.4h3.8c0.3,0,0.4-0.1,0.5-0.4l0.4-2.5c0.5-0.3,1.1-0.5,1.6-0.9l2.4,0.9     c0.3,0.1,0.4,0,0.5-0.3l1.9-3.3c0.1-0.3,0.1-0.4-0.1-0.7L1582.2,386.2z M1575.2,388.6c-1.9,0-3.4-1.6-3.4-3.4     c0-1.9,1.6-3.4,3.4-3.4c1.9,0,3.4,1.6,3.4,3.4C1578.7,387,1577.1,388.6,1575.2,388.6z"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <circle
            id="V108"
            class="st186"
            cx="670.6"
            cy="114.5"
            r="12"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
          />
          <text
            id="V108"
            transform="matrix(1 0 0 1 663.5715 120.9234)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            v-if="getRealTime.Valve[8].Mode == 'Auto'"
          >
            A
          </text>
          <text
            id="V108"
            transform="matrix(1 0 0 1 662.5715 120.9234)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            v-else
          >
            M
          </text>
        </g>
        <g>
          <circle
            id="V107"
            class="st186"
            cx="670.5"
            cy="232.7"
            r="12"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
          />

          <text
            id="V107"
            transform="matrix(1 0 0 1 663.4108 239.0842)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            v-if="getRealTime.Valve[7].Mode == 'Auto'"
          >
            A
          </text>
          <text
            id="V107"
            transform="matrix(1 0 0 1 662.4108 239.0842)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            v-else
          >
            M
          </text>
        </g>
        <g>
          <circle
            id="V106"
            class="st186"
            cx="670.7"
            cy="350"
            r="12"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
          />

          <text
            id="V106"
            transform="matrix(1 0 0 1 663.6213 356.4312)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            v-if="getRealTime.Valve[6].Mode == 'Auto'"
          >
            A
          </text>
          <text
            id="V106"
            transform="matrix(1 0 0 1 662.6213 356.4312)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            v-else
          >
            M
          </text>
        </g>
      </g>
      <g>
        <g>
          <circle
            id="V113"
            class="st186"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            cx="735"
            cy="171.9"
            r="12"
          />
          <text
            transform="matrix(1 0 0 1 727.9528 178.3056)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            id="V113"
            v-if="getRealTime.Valve[13].Mode == 'Auto'"
          >
            A
          </text>
          <text
            id="V113"
            transform="matrix(1 0 0 1 726.9528 178.3056)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            v-else
          >
            M
          </text>
        </g>
        <g>
          <circle
            id="V112"
            class="st186"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            cx="735.2"
            cy="290.5"
            r="12"
          />

          <text
            id="V112"
            transform="matrix(1 0 0 1 728.1604 296.9099)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            v-if="getRealTime.Valve[12].Mode == 'Auto'"
          >
            A
          </text>
          <text
            id="V112"
            transform="matrix(1 0 0 1 727.1604 296.9099)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            v-else
          >
            M
          </text>
        </g>
        <g>
          <circle
            id="V111"
            class="st186"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            cx="735"
            cy="409.2"
            r="12"
          />
          <text
            transform="matrix(1 0 0 1 727.9527 415.5612)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            id="V111"
            v-if="getRealTime.Valve[11].Mode == 'Auto'"
          >
            A
          </text>
          <text
            transform="matrix(1 0 0 1 726.5 415.5612)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            id="V111"
            v-else
          >
            M
          </text>
        </g>
      </g>
      <g>
        <g>
          <circle
            id="V116"
            class="st186"
            cx="1424.3"
            cy="411.9"
            r="12"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
          />
          <text
            transform="matrix(1.0132 0 0 1 1417.2584 418.2338)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            id="V116"
            v-if="getRealTime.Valve[16].Mode == 'Auto'"
          >
            A
          </text>
          <text
            transform="matrix(1.0132 0 0 1 1416.2584 418.2338)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            id="V116"
            v-else
          >
            M
          </text>
        </g>
        <g>
          <circle
            id="V117"
            class="st186"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            cx="1423.4"
            cy="292.8"
            r="12"
          />

          <text
            transform="matrix(1.0132 0 0 1 1416.3531 299.2317)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            id="V117"
            v-if="getRealTime.Valve[17].Mode == 'Auto'"
          >
            A
          </text>
          <text
            transform="matrix(1.0132 0 0 1 1415.3531 299.2317)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            id="V117"
            v-else
          >
            M
          </text>
        </g>
        <g>
          <circle
            id="118"
            class="st186"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            cx="1424.3"
            cy="174.8"
            r="12"
          />

          <text
            transform="matrix(1.0132 0 0 1 1417.2584 181.1976)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            id="V118"
            v-if="getRealTime.Valve[18].Mode == 'Auto'"
          >
            A
          </text>
          <text
            transform="matrix(1.0132 0 0 1 1416 181.1976)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            id="V118"
            v-else
          >
            M
          </text>
        </g>
      </g>
      <g>
        <g>
          <circle
            id="V103"
            class="st186"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            cx="1503.9"
            cy="114.5"
            r="12"
          />

          <text
            id="V103"
            transform="matrix(1.0132 0 0 1 1496.8903 120.9231)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            v-if="getRealTime.Valve[3].Mode == 'Auto'"
          >
            A
          </text>
          <text
            id="V103"
            transform="matrix(1.0132 0 0 1 1495.8903 120.9231)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            v-else
          >
            M
          </text>
        </g>
        <g>
          <circle
            id="V102"
            class="st186"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            cx="1503.9"
            cy="230.9"
            r="12"
          />

          <text
            id="V102"
            transform="matrix(1.0132 0 0 1 1496.8571 237.2779)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            v-if="getRealTime.Valve[2].Mode == 'Auto'"
          >
            A
          </text>
          <text
            id="V102"
            transform="matrix(1.0132 0 0 1 1495.8571 237.2779)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            v-else
          >
            M
          </text>
        </g>
        <g>
          <circle
            id="V101"
            class="st186"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            cx="1505.2"
            cy="350.7"
            r="12"
          />
          <text
            transform="matrix(1.0132 0 0 1 1498.1489 357.0453)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            id="V101"
            v-if="getRealTime.Valve[1].Mode == 'Auto'"
          >
            A
          </text>
          <text
            v-else
            transform="matrix(1.0132 0 0 1 1497.1489 357.0453)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            id="V101"
          >
            M
          </text>
        </g>
      </g>
      <g>
        <g>
          <circle
            id="P102"
            class="st186"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            cx="959.4"
            cy="663.7"
            r="12"
          />

          <text
            transform="matrix(1.0132 0 0 1 952.3641 670.0806)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            id="P102"
            v-if="getRealTime.Pump[1].Mode == 'Auto'"
          >
            A
          </text>
          <text
            transform="matrix(1.0132 0 0 1 951.3641 670.0806)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            id="P102"
            v-else
          >
            M
          </text>
        </g>
        <g>
          <circle id="V100" class="st186" cx="836.4" cy="569" r="12" />
          <text
            v-if="getRealTime.Valve[0].Mode == 'Auto'"
            id="V100"
            transform="matrix(1.0132 0 0 1 829.3967 575.3483)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
          >
            A
          </text>
          <text
            v-else
            id="V100"
            transform="matrix(1.0132 0 0 1 828.3967 575.3483)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
          >
            M
          </text>
        </g>
        <g v-if="getAccess.role != 'User'">
          <circle id="setpHEC" class="st186" cx="994.4" cy="592.6" r="12" />
          <text
            id="setpHEC"
            transform="matrix(1.0132 0 0 1 992 599.3503)"
            class="st25 st182 st187 pointer"
          >
            i
          </text>
        </g>
      </g>
      <g>
        <g>
          <circle
            class="st186"
            cx="1320.4"
            cy="658"
            r="12"
            id="P104"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
          />
          <text
            v-if="getRealTime.Pump[3].Mode == 'Auto'"
            transform="matrix(1.0132 0 0 1 1313.3281 664.4188)"
            class="st25 st182 st187"
            id="P104"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
          >
            A
          </text>
          <text
            v-else
            transform="matrix(1.0132 0 0 1 1312 664.4188)"
            class="st25 st182 st187"
            id="P104"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
          >
            M
          </text>
        </g>
        <g>
          <circle
            id="V121"
            class="st186"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
            cx="1391"
            cy="666.9"
            r="12"
          />
          <text
            id="V121"
            v-if="getRealTime.Valve[21].Mode == 'Auto'"
            transform="matrix(1.0132 0 0 1 1383.9104 673.2691)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
          >
            A
          </text>
          <text
            v-else
            id="V121"
            transform="matrix(1.0132 0 0 1 1382 673.2691)"
            class="st25 st182 st187"
            :class="getAccess.role != 'User' ? 'pointer' : ''"
          >
            M
          </text>
        </g>
        <g v-if="getAccess.role != 'User'">
          <circle
            id="setDrain"
            class="st186 pointer"
            cx="1344.4"
            cy="590.6"
            r="12"
          />

          <text
            transform="matrix(1.0132 0 0 1 1342 597.336)"
            class="st25 st182 st187 pointer"
            id="setDrain"
          >
            i
          </text>
        </g>
      </g>
      <g>
        <circle
          id="P105"
          class="st186"
          :class="getAccess.role != 'User' ? 'pointer' : ''"
          cx="140"
          cy="588.9"
          r="12"
        />
        <text
          id="P105"
          transform="matrix(1.0132 0 0 1 132.9167 595.302)"
          class="st25 st182 st187"
          :class="getAccess.role != 'User' ? 'pointer' : ''"
          v-if="getRealTime.Pump[4].Mode == 'Auto'"
        >
          A
        </text>
        <text
          id="P105"
          transform="matrix(1.0132 0 0 1 131.9167 595.302)"
          class="st25 st182 st187"
          :class="getAccess.role != 'User' ? 'pointer' : ''"
          v-else
        >
          M
        </text>
      </g>
      <g>
        <circle
          id="P106"
          class="st186"
          :class="getAccess.role != 'User' ? 'pointer' : ''"
          cx="268.2"
          cy="588.9"
          r="12"
        />
        <text
          id="P106"
          transform="matrix(1.0132 0 0 1 261.1863 595.302)"
          class="st25 st182 st187"
          :class="getAccess.role != 'User' ? 'pointer' : ''"
          v-if="getRealTime.Pump[5].Mode == 'Auto'"
        >
          A
        </text>
        <text
          id="P106"
          v-else
          transform="matrix(1.0132 0 0 1 260.1863 595.302)"
          class="st25 st182 st187"
          :class="getAccess.role != 'User' ? 'pointer' : ''"
        >
          M
        </text>
      </g>
      <g>
        <circle
          id="P107"
          class="st186"
          :class="getAccess.role != 'User' ? 'pointer' : ''"
          cx="396.7"
          cy="588.9"
          r="12"
        />
        <text
          id="P107"
          v-if="getRealTime.Pump[6].Mode == 'Auto'"
          transform="matrix(1.0132 0 0 1 389.6863 595.3017)"
          class="st25 st182 st187"
          :class="getAccess.role != 'User' ? 'pointer' : ''"
        >
          A
        </text>
        <text
          id="P107"
          v-else
          transform="matrix(1.0132 0 0 1 388.6863 595.3017)"
          class="st25 st182 st187"
          :class="getAccess.role != 'User' ? 'pointer' : ''"
        >
          M
        </text>
      </g>
      <g>
        <circle
          id="P108"
          class="st186"
          :class="getAccess.role != 'User' ? 'pointer' : ''"
          cx="524.6"
          cy="588.9"
          r="12"
        />
        <text
          id="P108"
          v-if="getRealTime.Pump[7].Mode == 'Auto'"
          transform="matrix(1.0132 0 0 1 517.5869 595.3017)"
          class="st25 st182 st187"
          :class="getAccess.role != 'User' ? 'pointer' : ''"
        >
          A
        </text>
        <text
          v-else
          id="P108"
          transform="matrix(1.0132 0 0 1 516.5869 595.3017)"
          class="st25 st182 st187"
          :class="getAccess.role != 'User' ? 'pointer' : ''"
        >
          M
        </text>
      </g>
      <g>
        <path
          class="st188"
          d="M569.2,423.3H420.8c-4.5,0-8.1-3.6-8.1-8.1v-75.7c0-4.5,3.6-8.1,8.1-8.1h148.4c4.5,0,8.1,3.6,8.1,8.1v75.7   C577.3,419.6,573.7,423.3,569.2,423.3z"
        />
        <path
          class="st189"
          d="M577.3,374.5H412.7v-34.9c0-4.5,3.7-8.2,8.2-8.2h148.2c4.5,0,8.2,3.7,8.2,8.2V374.5z"
        />
        <rect x="467.9" y="342.9" class="st181" width="55.3" height="24" />
        <text
          transform="matrix(1 0 0 1 467.9142 360.3295)"
          class="st190 st182 st191"
        >
          Flow
        </text>
        <text transform="matrix(1 0 0 1 460.6071 408.2143)" class="st182 st191">
          {{ getRealTime.Status.ROTank.calFlow.toFixed(2) }} L
        </text>
      </g>
      <text transform="matrix(1 0 0 1 78.3569 673.0706)">
        <tspan x="0" y="0" class="st182 st192">A</tspan>
        <tspan x="-27.7" y="21.6" class="st182 st192">
          {{ getRealTime.Status.FertilizerTank.Level[0].Value.toFixed(2) }} %
        </tspan>
      </text>
      <text transform="matrix(1 0 0 1 205.4348 673.0704)">
        <tspan x="0" y="0" class="st182 st192">B</tspan>
        <tspan x="-27.7" y="21.6" class="st182 st192">
          {{ getRealTime.Status.FertilizerTank.Level[1].Value.toFixed(2) }} %
        </tspan>
      </text>
      <text transform="matrix(1 0 0 1 323.3844 673.0707)">
        <tspan x="0" y="0" class="st182 st192">pH+</tspan>
        <tspan x="-16.4" y="21.6" class="st182 st192">
          {{ getRealTime.Status.pHTank.Level[0].Value.toFixed(2) }} %
        </tspan>
      </text>
      <text transform="matrix(1 0 0 1 454.7776 673.0698)">
        <tspan x="0" y="0" class="st182 st192">pH-</tspan>
        <tspan x="-18.7" y="21.6" class="st182 st192">
          {{ getRealTime.Status.pHTank.Level[1].Value.toFixed(2) }} %
        </tspan>
      </text>
      <rect x="749" y="681" class="st181" width="141.2" height="31.6" />
      <text transform="matrix(1 0 0 1 720 650)">
        <tspan x="0" y="0" class="st182 st192">Temperature</tspan>
        <tspan x="22.7" y="19.2" class="st182 st192">
          {{ getRealTime.Status.NutrientTank.Temperature.toFixed(2) }} °C
        </tspan>
      </text>
      <text transform="matrix(1 0 0 1 720 720)">
        <tspan x="0" y="0" class="st182 st192">Nutrient Tank</tspan>
        <tspan x="25" y="19" class="st182 st192">
          {{ getRealTime.Status.NutrientTank.Level.toFixed(2) }} %
        </tspan>
      </text>

      <rect x="1089.3" y="681.2" class="st181" width="141.2" height="31.6" />
      <text transform="matrix(1 0 0 1 1106.9126 692.8231)">
        <tspan x="0" y="0" class="st182 st192">Drain Tank</tspan>
        <tspan x="22.7" y="19.2" class="st182 st192">
          {{ getRealTime.Status.DrainTank.Level.toFixed(2) }} %
        </tspan>
      </text>
      <path
        v-if="getRealTime.Fan[0].Speed > 0"
        class="st194"
        d="M799.7,321.7c0.7-0.2,1.4-0.2,2.1-0.2c1.6,0,3.2,0.3,4.7,0.8c2.3,0.8,4.4,2,6.8,1.9c2.8,0.1,5.4-1.4,7.9-2.7  c-2.1,2.7-5.2,5.8-8.5,6.1c-4,0.8-7.8-2.1-11.7-2.8c-3-0.5-5.3,0.6-8.4,1.3C794.9,324.3,797.1,322.4,799.7,321.7 M814.9,340.6  c4.9-3.2,10.2-1.2,15,0.9c2.4,1.1,4.9,3,7.6,2.2c1.6-0.5,3.4-1.5,4.6-2.7c-0.8,0.3-1.6,0.5-2.4,0.6c-1.3,0.1-2.7,0.3-4-0.4  c-1.6-0.9-3.1-2.4-4.7-3.3c-2.2-1.2-4.6-2-7.1-2C820.5,335.8,817.3,337.2,814.9,340.6 M868.8,340.5c-2.8,0.5-5.6,1.8-7.8,4  c2.6-1.4,5.3-1.7,8.1-1.5c2.7,0.5,6.4,1.9,9.4,1.9c2.4-0.1,4.9-1,6.7-3c0.3-0.3,0.7-0.7,0.9-1c-0.5,0.3-1.1,0.6-1.7,0.8  c-3.6,1.7-6.9,0.4-10.4-0.7c-1.4-0.3-2.9-0.5-4.3-0.5C869.6,340.4,869.2,340.4,868.8,340.5 M866.6,317.8c3.2-1.7,7-2.7,10.6-1.9  c2.6,0.7,5,2.3,7.7,2.5c1,0.1,2.2-0.1,3.2-0.3c-0.6-0.1-1.3-0.3-1.9-0.5c-3-0.8-5.3-3.3-8.2-4.1c-0.6-0.1-1.2-0.2-1.9-0.2  C872.5,313.3,869,315.2,866.6,317.8 M838.6,330.9c9.8-11.5,14.9,4.3,25.2,4.4c4.4,0.5,9.6-4.3,10.8-8.5c-2.3,3-7.7,5.9-10.9,4.3  c-3-0.8-5.6-3.5-8.6-5.6c-2.4-1.6-4.8-2.5-7.1-2.5C844.1,323,840.8,325.4,838.6,330.9 M817.2,307.6c-2.5,0.5-4.8,1.3-7,2.5  c-2.3,1.2-4.4,2.8-6.7,4c3.2-0.8,6.2-2.3,9.5-2.8c3.9-0.7,7.8-0.8,11.1,0.2c1.1,0.3,2.5,0.9,4.7,2c2,1.1,4,2.3,6.2,3  c6.9,2.3,15.3,1,18.9-5.1c0.5-0.8,0.9-1.6,1.3-2.3c-0.1,0.1-0.1,0.1-0.2,0.2c-1.9,1.9-4,3.5-6.7,4.4c-4.2,1.3-8.9,0.3-12.8-1.7  c-2.9-1.7-5.7-3.4-9-4.3c-1.5-0.4-3.1-0.6-4.7-0.6C820.3,307.2,818.7,307.3,817.2,307.6 M922.1,308.1c-2.5,0.5-4.8,1.3-7,2.4  c-2.3,1.2-4.4,2.8-6.7,4c3.2-0.8,6.2-2.3,9.5-2.8c3.9-0.7,7.8-0.8,11.1,0.2c1.1,0.3,2.5,0.9,4.7,2c2,1.1,4,2.3,6.2,3  c6.9,2.3,15.3,1,18.9-5.1c0.5-0.8,0.9-1.6,1.3-2.3c-0.1,0.1-0.1,0.1-0.2,0.2c-1.9,1.9-4,3.5-6.7,4.4c-4.2,1.3-8.9,0.3-12.8-1.7  c-2.9-1.7-5.7-3.4-9-4.3c-1.5-0.4-3.1-0.6-4.7-0.6C925.2,307.6,923.6,307.8,922.1,308.1 M928.2,339.1c9.8-11.5,14.9,4.3,25.2,4.4  c4.4,0.5,9.6-4.3,10.8-8.5c-2.3,3-7.7,5.9-10.9,4.3c-3-0.8-5.6-3.5-8.6-5.6c-2.4-1.6-4.8-2.5-7.1-2.5  C933.7,331.2,930.4,333.6,928.2,339.1 M915.9,326.2c3-1.7,6.6-2.7,10-1.9c2.5,0.7,4.7,2.3,7.3,2.5c1,0.1,2.1-0.1,3-0.3  c-0.6-0.1-1.2-0.3-1.8-0.5c-2.8-0.8-4.9-3.3-7.8-4.1c-0.6-0.1-1.2-0.2-1.8-0.2C921.5,321.7,918.2,323.6,915.9,326.2 M957.7,322.8  c-2.8,0.5-5.6,1.8-7.8,4c2.6-1.4,5.3-1.7,8.1-1.5c2.7,0.5,6.3,1.9,9.4,1.9c2.4-0.1,4.9-1,6.7-3c0.3-0.3,0.6-0.7,0.9-1  c-0.5,0.3-1.1,0.6-1.7,0.8c-3.6,1.7-6.9,0.4-10.4-0.7c-1.4-0.3-2.9-0.5-4.3-0.5C958.4,322.8,958.1,322.8,957.7,322.8 M898.3,342.4  c4.9-3.2,10.2-1.2,15,0.9c2.4,1.1,4.9,3,7.6,2.2c1.6-0.5,3.4-1.5,4.6-2.7c-0.8,0.3-1.6,0.5-2.4,0.6c-1.3,0.1-2.7,0.3-4-0.4  c-1.6-0.9-3.1-2.4-4.7-3.3c-2.2-1.2-4.6-2-7.1-2C904,337.6,900.7,339,898.3,342.4 M888.9,324.9c-2.6,0.7-4.9,2.6-7.1,4.4  c3.1-0.7,5.4-1.8,8.4-1.3c3.9,0.7,7.7,3.6,11.7,2.8c3.3-0.3,6.5-3.5,8.5-6.1c-2.6,1.2-5.1,2.8-7.9,2.7c-2.3,0.1-4.4-1-6.8-1.9  c-1.6-0.4-3.2-0.8-4.7-0.8C890.4,324.6,889.6,324.7,888.9,324.9 M1002.9,320.8c0.7-0.2,1.4-0.2,2.1-0.2c1.6,0,3.2,0.3,4.7,0.8  c2.3,0.8,4.4,2,6.8,1.9c2.8,0.1,5.4-1.4,7.9-2.7c-2.1,2.7-5.2,5.8-8.5,6.1c-4,0.8-7.8-2.1-11.7-2.8c-3-0.5-5.3,0.6-8.4,1.3  C998,323.4,1000.3,321.5,1002.9,320.8 M1018.1,339.7c4.9-3.2,10.2-1.2,15,0.9c2.4,1.1,4.9,3,7.6,2.2c1.6-0.5,3.4-1.5,4.6-2.7  c-0.8,0.3-1.6,0.5-2.4,0.6c-1.3,0.1-2.7,0.3-4-0.4c-1.6-0.9-3.1-2.4-4.7-3.3c-2.2-1.2-4.6-2-7.1-2  C1023.7,334.9,1020.4,336.3,1018.1,339.7 M1072,339.6c-2.8,0.5-5.6,1.8-7.8,4c2.6-1.4,5.3-1.7,8.1-1.5c2.7,0.5,6.4,1.9,9.4,1.9  c2.4-0.1,4.9-1,6.7-3c0.3-0.3,0.7-0.7,0.9-1c-0.5,0.3-1.1,0.6-1.7,0.8c-3.6,1.7-6.9,0.4-10.4-0.7c-1.4-0.3-2.9-0.5-4.3-0.5  C1072.7,339.5,1072.4,339.5,1072,339.6 M1069.7,316.9c3.2-1.7,7-2.7,10.6-1.9c2.6,0.7,5,2.3,7.7,2.5c1,0.1,2.2-0.1,3.2-0.3  c-0.6-0.1-1.3-0.3-1.9-0.5c-3-0.8-5.3-3.3-8.2-4.1c-0.6-0.1-1.2-0.2-1.9-0.2C1075.7,312.4,1072.2,314.3,1069.7,316.9 M1041.8,330.1  c9.8-11.5,14.9,4.3,25.2,4.4c4.4,0.5,9.6-4.3,10.8-8.5c-2.3,3-7.7,5.9-10.9,4.3c-3-0.8-5.6-3.5-8.6-5.6c-2.4-1.6-4.8-2.5-7.1-2.5  C1047.3,322.1,1044,324.5,1041.8,330.1 M1020.4,306.8c-2.5,0.5-4.8,1.3-7,2.5c-2.3,1.2-4.4,2.8-6.7,4c3.2-0.8,6.2-2.3,9.5-2.8  c3.9-0.7,7.8-0.8,11.1,0.2c1.1,0.3,2.5,0.9,4.7,2c2,1.1,4,2.3,6.2,3c6.9,2.3,15.3,1,18.9-5.1c0.5-0.8,0.9-1.6,1.3-2.3  c-0.1,0.1-0.1,0.1-0.2,0.2c-1.9,1.9-4,3.5-6.7,4.4c-4.2,1.3-8.9,0.3-12.8-1.7c-2.9-1.7-5.7-3.4-9-4.3c-1.5-0.4-3.1-0.6-4.7-0.6  C1023.5,306.3,1021.9,306.5,1020.4,306.8 M1125.2,307.2c-2.5,0.5-4.8,1.3-7,2.4c-2.3,1.2-4.4,2.8-6.7,4c3.2-0.8,6.2-2.3,9.5-2.8  c3.9-0.7,7.8-0.8,11.1,0.2c1.1,0.3,2.5,0.9,4.7,2c2,1.1,4,2.3,6.2,3c6.9,2.3,15.3,1,18.9-5.1c0.5-0.8,0.9-1.6,1.3-2.3  c-0.1,0.1-0.1,0.1-0.2,0.2c-1.9,1.9-4,3.5-6.7,4.4c-4.2,1.3-8.9,0.3-12.8-1.7c-2.9-1.7-5.7-3.4-9-4.3c-1.5-0.4-3.1-0.6-4.7-0.6  C1128.4,306.7,1126.8,306.9,1125.2,307.2 M1131.3,338.2c9.8-11.5,14.9,4.3,25.2,4.4c4.4,0.5,9.6-4.3,10.8-8.5  c-2.3,3-7.7,5.9-10.9,4.3c-3-0.8-5.6-3.5-8.6-5.6c-2.4-1.6-4.8-2.5-7.1-2.5C1136.9,330.3,1133.5,332.7,1131.3,338.2 M1119.1,325.3  c3-1.7,6.6-2.7,10-1.9c2.5,0.7,4.7,2.3,7.3,2.5c1,0.1,2.1-0.1,3-0.3c-0.6-0.1-1.2-0.3-1.8-0.5c-2.8-0.8-4.9-3.3-7.8-4.1  c-0.6-0.1-1.2-0.2-1.8-0.2C1124.7,320.8,1121.4,322.7,1119.1,325.3 M1160.9,321.9c-2.8,0.5-5.6,1.8-7.8,4c2.6-1.4,5.3-1.7,8.1-1.5  c2.7,0.5,6.3,1.9,9.4,1.9c2.4-0.1,4.9-1,6.7-3c0.3-0.3,0.6-0.7,0.9-1c-0.5,0.3-1.1,0.6-1.7,0.8c-3.6,1.7-6.9,0.4-10.4-0.7  c-1.4-0.3-2.9-0.5-4.3-0.5C1161.6,321.9,1161.2,321.9,1160.9,321.9 M1101.5,341.5c4.9-3.2,10.2-1.2,15,0.9c2.4,1.1,4.9,3,7.6,2.2  c1.6-0.5,3.4-1.5,4.6-2.7c-0.8,0.3-1.6,0.5-2.4,0.6c-1.3,0.1-2.7,0.3-4-0.4c-1.6-0.9-3.1-2.4-4.7-3.3c-2.2-1.2-4.6-2-7.1-2  C1107.1,336.7,1103.8,338.1,1101.5,341.5 M1092.1,324c-2.6,0.7-4.9,2.6-7.1,4.4c3.1-0.7,5.4-1.8,8.4-1.3c3.9,0.7,7.7,3.6,11.7,2.8  c3.3-0.3,6.5-3.5,8.5-6.1c-2.6,1.2-5.1,2.8-7.9,2.7c-2.3,0.1-4.4-1-6.8-1.9c-1.6-0.4-3.2-0.8-4.7-0.8  C1093.5,323.7,1092.8,323.8,1092.1,324 M1205.4,320.7c0.7-0.2,1.4-0.2,2.1-0.2c1.6,0,3.2,0.3,4.7,0.8c2.3,0.8,4.4,2,6.8,1.9  c2.8,0.1,5.4-1.4,7.9-2.7c-2.1,2.7-5.2,5.8-8.5,6.1c-4,0.8-7.8-2.1-11.7-2.8c-3-0.5-5.3,0.6-8.4,1.3  C1200.5,323.3,1202.8,321.4,1205.4,320.7 M1220.6,339.6c4.9-3.2,10.2-1.2,15,0.9c2.4,1.1,4.9,3,7.6,2.2c1.6-0.5,3.4-1.5,4.6-2.7  c-0.8,0.3-1.6,0.5-2.4,0.6c-1.3,0.1-2.7,0.3-4-0.4c-1.6-0.9-3.1-2.4-4.7-3.3c-2.2-1.2-4.6-2-7.1-2  C1226.2,334.8,1222.9,336.2,1220.6,339.6 M1274.5,339.4c-2.8,0.5-5.6,1.8-7.8,4c2.6-1.4,5.3-1.7,8.1-1.5c2.7,0.5,6.4,1.9,9.4,1.9  c2.4-0.1,4.9-1,6.7-3c0.3-0.3,0.7-0.7,0.9-1c-0.5,0.3-1.1,0.6-1.7,0.8c-3.6,1.7-6.9,0.4-10.4-0.7c-1.4-0.3-2.9-0.5-4.3-0.5  C1275.2,339.4,1274.9,339.4,1274.5,339.4 M1272.2,316.7c3.2-1.7,7-2.7,10.6-1.9c2.6,0.7,5,2.3,7.7,2.5c1,0.1,2.2-0.1,3.2-0.3  c-0.6-0.1-1.3-0.3-1.9-0.5c-3-0.8-5.3-3.3-8.2-4.1c-0.6-0.1-1.2-0.2-1.9-0.2C1278.2,312.3,1274.7,314.2,1272.2,316.7 M1244.3,329.9  c9.8-11.5,14.9,4.3,25.2,4.4c4.4,0.5,9.6-4.3,10.8-8.5c-2.3,3-7.7,5.9-10.9,4.3c-3-0.8-5.6-3.5-8.6-5.6c-2.4-1.6-4.8-2.5-7.1-2.5  C1249.8,322,1246.5,324.4,1244.3,329.9 M1222.8,306.6c-2.5,0.5-4.8,1.3-7,2.5c-2.3,1.2-4.4,2.8-6.7,4c3.2-0.8,6.2-2.3,9.5-2.8  c3.9-0.7,7.8-0.8,11.1,0.2c1.1,0.3,2.5,0.9,4.7,2c2,1.1,4,2.3,6.2,3c6.9,2.3,15.3,1,18.9-5.1c0.5-0.8,0.9-1.6,1.3-2.3  c-0.1,0.1-0.1,0.1-0.2,0.2c-1.9,1.9-4,3.5-6.7,4.4c-4.2,1.3-8.9,0.3-12.8-1.7c-2.9-1.7-5.7-3.4-9-4.3c-1.5-0.4-3.1-0.6-4.7-0.6  C1226,306.1,1224.4,306.3,1222.8,306.6 M1327.7,307.1c-2.5,0.5-4.8,1.3-7,2.4c-2.3,1.2-4.4,2.8-6.7,4c3.2-0.8,6.2-2.3,9.5-2.8  c3.9-0.7,7.8-0.8,11.1,0.2c1.1,0.3,2.5,0.9,4.7,2c2,1.1,4,2.3,6.2,3c6.9,2.3,15.3,1,18.9-5.1c0.5-0.8,0.9-1.6,1.3-2.3  c-0.1,0.1-0.1,0.1-0.2,0.2c-1.9,1.9-4,3.5-6.7,4.4c-4.2,1.3-8.9,0.3-12.8-1.7c-2.9-1.7-5.7-3.4-9-4.3c-1.5-0.4-3.1-0.6-4.7-0.6  C1330.8,306.6,1329.3,306.8,1327.7,307.1 M1333.8,338.1c9.8-11.5,14.9,4.3,25.2,4.4c4.4,0.5,9.6-4.3,10.8-8.5  c-2.3,3-7.7,5.9-10.9,4.3c-3-0.8-5.6-3.5-8.6-5.6c-2.4-1.6-4.8-2.5-7.1-2.5C1339.4,330.1,1336,332.5,1333.8,338.1 M1321.5,325.1  c3-1.7,6.6-2.7,10-1.9c2.5,0.7,4.7,2.3,7.3,2.5c1,0.1,2.1-0.1,3-0.3c-0.6-0.1-1.2-0.3-1.8-0.5c-2.8-0.8-4.9-3.3-7.8-4.1  c-0.6-0.1-1.2-0.2-1.8-0.2C1327.1,320.7,1323.9,322.6,1321.5,325.1 M1363.4,321.8c-2.8,0.5-5.6,1.8-7.8,4c2.6-1.4,5.3-1.7,8.1-1.5  c2.7,0.5,6.3,1.9,9.4,1.9c2.4-0.1,4.9-1,6.7-3c0.3-0.3,0.6-0.7,0.9-1c-0.5,0.3-1.1,0.6-1.7,0.8c-3.6,1.7-6.9,0.4-10.4-0.7  c-1.4-0.3-2.9-0.5-4.3-0.5C1364.1,321.7,1363.7,321.8,1363.4,321.8 M1304,341.4c4.9-3.2,10.2-1.2,15,0.9c2.4,1.1,4.9,3,7.6,2.2  c1.6-0.5,3.4-1.5,4.6-2.7c-0.8,0.3-1.6,0.5-2.4,0.6c-1.3,0.1-2.7,0.3-4-0.4c-1.6-0.9-3.1-2.4-4.7-3.3c-2.2-1.2-4.6-2-7.1-2  C1309.6,336.6,1306.3,338,1304,341.4 M1294.6,323.8c-2.6,0.7-4.9,2.6-7.1,4.4c3.1-0.7,5.4-1.8,8.4-1.3c3.9,0.7,7.7,3.6,11.7,2.8  c3.3-0.3,6.5-3.5,8.5-6.1c-2.6,1.2-5.1,2.8-7.9,2.7c-2.3,0.1-4.4-1-6.8-1.9c-1.6-0.4-3.2-0.8-4.7-0.8  C1296,323.6,1295.3,323.7,1294.6,323.8"
      />
      <linearGradient
        id="SVGID_274_"
        gradientUnits="userSpaceOnUse"
        x1="788.6643"
        y1="28.5714"
        x2="1376.7643"
        y2="28.5714"
        gradientTransform="matrix(1 0 0 1 0 304)"
      >
        <stop
          offset="0"
          style="stop-opacity: 0.2"
          :style="
            getRealTime.Light[0].LED2 > 0 ||
            getRealTime.Light[0].LED3 > 0 ||
            getRealTime.Light[0].LED4 > 0
              ? 'stop-color: #fff;'
              : 'stop-color: #c3c7c7;'
          "
        />
        <stop
          offset="0.25"
          style="stop-opacity: 0.5"
          :style="
            getRealTime.Light[0].LED2 > 0 ||
            getRealTime.Light[0].LED3 > 0 ||
            getRealTime.Light[0].LED4 > 0
              ? 'stop-color: #fff;'
              : 'stop-color: #c3c7c7;'
          "
        />
        <stop
          offset="0.5"
          style="stop-opacity: 0.6"
          :style="
            getRealTime.Light[0].LED2 > 0 ||
            getRealTime.Light[0].LED3 > 0 ||
            getRealTime.Light[0].LED4 > 0
              ? 'stop-color: #fff;'
              : 'stop-color: #c3c7c7;'
          "
        />
        <stop
          offset="0.75"
          style="stop-opacity: 0.5"
          :style="
            getRealTime.Light[0].LED2 > 0 ||
            getRealTime.Light[0].LED3 > 0 ||
            getRealTime.Light[0].LED4 > 0
              ? 'stop-color: #fff;'
              : 'stop-color: #c3c7c7;'
          "
        />
        <stop
          offset="1"
          style="stop-opacity: 0.2"
          :style="
            getRealTime.Light[0].LED2 > 0 ||
            getRealTime.Light[0].LED3 > 0 ||
            getRealTime.Light[0].LED4 > 0
              ? 'stop-color: #fff;'
              : 'stop-color: #c3c7c7;'
          "
        />
      </linearGradient>
      <path
        v-if="getRealTime.Fan[1].Speed > 0"
        class="st195"
        d="M799.7,203c0.7-0.2,1.4-0.2,2.1-0.2c1.6,0,3.2,0.3,4.7,0.8c2.3,0.8,4.4,2,6.8,1.9c2.8,0.1,5.4-1.4,7.9-2.7  c-2.1,2.7-5.2,5.8-8.5,6.1c-4,0.8-7.8-2.1-11.7-2.8c-3-0.5-5.3,0.6-8.4,1.3C794.9,205.6,797.1,203.7,799.7,203 M814.9,221.9  c4.9-3.2,10.2-1.2,15,0.9c2.4,1.1,4.9,3,7.6,2.2c1.6-0.5,3.4-1.5,4.6-2.7c-0.8,0.3-1.6,0.5-2.4,0.6c-1.3,0.1-2.7,0.3-4-0.4  c-1.6-0.9-3.1-2.4-4.7-3.3c-2.2-1.2-4.6-2-7.1-2C820.5,217.1,817.3,218.5,814.9,221.9 M868.9,221.8c-2.8,0.5-5.6,1.8-7.8,4  c2.6-1.4,5.3-1.7,8.1-1.5c2.7,0.5,6.4,1.9,9.4,1.9c2.4-0.1,4.9-1,6.7-3c0.3-0.3,0.7-0.7,0.9-1c-0.5,0.3-1.1,0.6-1.7,0.8  c-3.6,1.7-6.9,0.4-10.4-0.7c-1.4-0.3-2.9-0.5-4.3-0.5C869.6,221.7,869.2,221.7,868.9,221.8 M866.6,199c3.2-1.7,7-2.7,10.6-1.9  c2.6,0.7,5,2.3,7.7,2.5c1,0.1,2.2-0.1,3.2-0.3c-0.6-0.1-1.3-0.3-1.9-0.5c-3-0.8-5.3-3.3-8.2-4.1c-0.6-0.1-1.2-0.2-1.9-0.2  C872.5,194.6,869,196.5,866.6,199 M838.6,212.2c9.8-11.5,14.9,4.3,25.2,4.4c4.4,0.5,9.6-4.3,10.8-8.5c-2.3,3-7.7,5.9-10.9,4.3  c-3-0.8-5.6-3.5-8.6-5.6c-2.4-1.6-4.8-2.5-7.1-2.5C844.1,204.3,840.8,206.7,838.6,212.2 M817.2,188.9c-2.5,0.5-4.8,1.3-7,2.5  c-2.3,1.2-4.4,2.8-6.7,4c3.2-0.8,6.2-2.3,9.5-2.8c3.9-0.7,7.8-0.8,11.1,0.2c1.1,0.3,2.5,0.9,4.7,2c2,1.1,4,2.3,6.2,3  c6.9,2.3,15.3,1,18.9-5.1c0.5-0.8,0.9-1.6,1.3-2.3c-0.1,0.1-0.1,0.1-0.2,0.2c-1.9,1.9-4,3.5-6.7,4.4c-4.2,1.3-8.9,0.3-12.8-1.7  c-2.9-1.7-5.7-3.4-9-4.3c-1.5-0.4-3.1-0.6-4.7-0.6C820.3,188.5,818.7,188.6,817.2,188.9 M922.1,189.4c-2.5,0.5-4.8,1.3-7,2.4  c-2.3,1.2-4.4,2.8-6.7,4c3.2-0.8,6.2-2.3,9.5-2.8c3.9-0.7,7.8-0.8,11.1,0.2c1.1,0.3,2.5,0.9,4.7,2c2,1.1,4,2.3,6.2,3  c6.9,2.3,15.3,1,18.9-5.1c0.5-0.8,0.9-1.6,1.3-2.3c-0.1,0.1-0.1,0.1-0.2,0.2c-1.9,1.9-4,3.5-6.7,4.4c-4.2,1.3-8.9,0.3-12.8-1.7  c-2.9-1.7-5.7-3.4-9-4.3c-1.5-0.4-3.1-0.6-4.7-0.6C925.2,188.9,923.6,189.1,922.1,189.4 M928.2,220.4c9.8-11.5,14.9,4.3,25.2,4.4  c4.4,0.5,9.6-4.3,10.8-8.5c-2.3,3-7.7,5.9-10.9,4.3c-3-0.8-5.6-3.5-8.6-5.6c-2.4-1.6-4.8-2.5-7.1-2.5  C933.7,212.4,930.4,214.8,928.2,220.4 M915.9,207.4c3-1.7,6.6-2.7,10-1.9c2.5,0.7,4.7,2.3,7.3,2.5c1,0.1,2.1-0.1,3-0.3  c-0.6-0.1-1.2-0.3-1.8-0.5c-2.8-0.8-4.9-3.3-7.8-4.1c-0.6-0.1-1.2-0.2-1.8-0.2C921.5,203,918.2,204.9,915.9,207.4 M957.7,204.1  c-2.8,0.5-5.6,1.8-7.8,4c2.6-1.4,5.3-1.7,8.1-1.5c2.7,0.5,6.3,1.9,9.4,1.9c2.4-0.1,4.9-1,6.7-3c0.3-0.3,0.6-0.7,0.9-1  c-0.5,0.3-1.1,0.6-1.7,0.8c-3.6,1.7-6.9,0.4-10.4-0.7c-1.4-0.3-2.9-0.5-4.3-0.5C958.4,204,958.1,204.1,957.7,204.1 M898.3,223.7  c4.9-3.2,10.2-1.2,15,0.9c2.4,1.1,4.9,3,7.6,2.2c1.6-0.5,3.4-1.5,4.6-2.7c-0.8,0.3-1.6,0.5-2.4,0.6c-1.3,0.1-2.7,0.3-4-0.4  c-1.6-0.9-3.1-2.4-4.7-3.3c-2.2-1.2-4.6-2-7.1-2C904,218.9,900.7,220.3,898.3,223.7 M888.9,206.1c-2.6,0.7-4.9,2.6-7.1,4.4  c3.1-0.7,5.4-1.8,8.4-1.3c3.9,0.7,7.7,3.6,11.7,2.8c3.3-0.3,6.5-3.5,8.5-6.1c-2.6,1.2-5.1,2.8-7.9,2.7c-2.3,0.1-4.4-1-6.8-1.9  c-1.6-0.4-3.2-0.8-4.7-0.8C890.4,205.9,889.6,206,888.9,206.1 M1002.9,202.1c0.7-0.2,1.4-0.2,2.1-0.2c1.6,0,3.2,0.3,4.7,0.8  c2.3,0.8,4.4,2,6.8,1.9c2.8,0.1,5.4-1.4,7.9-2.7c-2.1,2.7-5.2,5.8-8.5,6.1c-4,0.8-7.8-2.1-11.7-2.8c-3-0.5-5.3,0.6-8.4,1.3  C998,204.7,1000.3,202.8,1002.9,202.1 M1018.1,221c4.9-3.2,10.2-1.2,15,0.9c2.4,1.1,4.9,3,7.6,2.2c1.6-0.5,3.4-1.5,4.6-2.7  c-0.8,0.3-1.6,0.5-2.4,0.6c-1.3,0.1-2.7,0.3-4-0.4c-1.6-0.9-3.1-2.4-4.7-3.3c-2.2-1.2-4.6-2-7.1-2  C1023.7,216.2,1020.4,217.6,1018.1,221 M1072,220.9c-2.8,0.5-5.6,1.8-7.8,4c2.6-1.4,5.3-1.7,8.1-1.5c2.7,0.5,6.4,1.9,9.4,1.9  c2.4-0.1,4.9-1,6.7-3c0.3-0.3,0.7-0.7,0.9-1c-0.5,0.3-1.1,0.6-1.7,0.8c-3.6,1.7-6.9,0.4-10.4-0.7c-1.4-0.3-2.9-0.5-4.3-0.5  C1072.7,220.8,1072.4,220.8,1072,220.9 M1069.7,198.1c3.2-1.7,7-2.7,10.6-1.9c2.6,0.7,5,2.3,7.7,2.5c1,0.1,2.2-0.1,3.2-0.3  c-0.6-0.1-1.3-0.3-1.9-0.5c-3-0.8-5.3-3.3-8.2-4.1c-0.6-0.1-1.2-0.2-1.9-0.2C1075.7,193.7,1072.2,195.6,1069.7,198.1 M1041.8,211.3  c9.8-11.5,14.9,4.3,25.2,4.4c4.4,0.5,9.6-4.3,10.8-8.5c-2.3,3-7.7,5.9-10.9,4.3c-3-0.8-5.6-3.5-8.6-5.6c-2.4-1.6-4.8-2.5-7.1-2.5  C1047.3,203.4,1044,205.8,1041.8,211.3 M1020.4,188c-2.5,0.5-4.8,1.3-7,2.5c-2.3,1.2-4.4,2.8-6.7,4c3.2-0.8,6.2-2.3,9.5-2.8  c3.9-0.7,7.8-0.8,11.1,0.2c1.1,0.3,2.5,0.9,4.7,2c2,1.1,4,2.3,6.2,3c6.9,2.3,15.3,1,18.9-5.1c0.5-0.8,0.9-1.6,1.3-2.3  c-0.1,0.1-0.1,0.1-0.2,0.2c-1.9,1.9-4,3.5-6.7,4.4c-4.2,1.3-8.9,0.3-12.8-1.7c-2.9-1.7-5.7-3.4-9-4.3c-1.5-0.4-3.1-0.6-4.7-0.6  C1023.5,187.6,1021.9,187.7,1020.4,188 M1125.2,188.5c-2.5,0.5-4.8,1.3-7,2.4c-2.3,1.2-4.4,2.8-6.7,4c3.2-0.8,6.2-2.3,9.5-2.8  c3.9-0.7,7.8-0.8,11.1,0.2c1.1,0.3,2.5,0.9,4.7,2c2,1.1,4,2.3,6.2,3c6.9,2.3,15.3,1,18.9-5.1c0.5-0.8,0.9-1.6,1.3-2.3  c-0.1,0.1-0.1,0.1-0.2,0.2c-1.9,1.9-4,3.5-6.7,4.4c-4.2,1.3-8.9,0.3-12.8-1.7c-2.9-1.7-5.7-3.4-9-4.3c-1.5-0.4-3.1-0.6-4.7-0.6  C1128.4,188,1126.8,188.2,1125.2,188.5 M1131.3,219.5c9.8-11.5,14.9,4.3,25.2,4.4c4.4,0.5,9.6-4.3,10.8-8.5c-2.3,3-7.7,5.9-10.9,4.3  c-3-0.8-5.6-3.5-8.6-5.6c-2.4-1.6-4.8-2.5-7.1-2.5C1136.9,211.5,1133.5,213.9,1131.3,219.5 M1119.1,206.6c3-1.7,6.6-2.7,10-1.9  c2.5,0.7,4.7,2.3,7.3,2.5c1,0.1,2.1-0.1,3-0.3c-0.6-0.1-1.2-0.3-1.8-0.5c-2.8-0.8-4.9-3.3-7.8-4.1c-0.6-0.1-1.2-0.2-1.8-0.2  C1124.7,202.1,1121.4,204,1119.1,206.6 M1160.9,203.2c-2.8,0.5-5.6,1.8-7.8,4c2.6-1.4,5.3-1.7,8.1-1.5c2.7,0.5,6.3,1.9,9.4,1.9  c2.4-0.1,4.9-1,6.7-3c0.3-0.3,0.6-0.7,0.9-1c-0.5,0.3-1.1,0.6-1.7,0.8c-3.6,1.7-6.9,0.4-10.4-0.7c-1.4-0.3-2.9-0.5-4.3-0.5  C1161.6,203.2,1161.2,203.2,1160.9,203.2 M1101.5,222.8c4.9-3.2,10.2-1.2,15,0.9c2.4,1.1,4.9,3,7.6,2.2c1.6-0.5,3.4-1.5,4.6-2.7  c-0.8,0.3-1.6,0.5-2.4,0.6c-1.3,0.1-2.7,0.3-4-0.4c-1.6-0.9-3.1-2.4-4.7-3.3c-2.2-1.2-4.6-2-7.1-2  C1107.1,218,1103.8,219.4,1101.5,222.8 M1092.1,205.2c-2.6,0.7-4.9,2.6-7.1,4.4c3.1-0.7,5.4-1.8,8.4-1.3c3.9,0.7,7.7,3.6,11.7,2.8  c3.3-0.3,6.5-3.5,8.5-6.1c-2.6,1.2-5.1,2.8-7.9,2.7c-2.3,0.1-4.4-1-6.8-1.9c-1.6-0.4-3.2-0.8-4.7-0.8  C1093.5,205,1092.8,205.1,1092.1,205.2 M1205.4,201.9c0.7-0.2,1.4-0.2,2.1-0.2c1.6,0,3.2,0.3,4.7,0.8c2.3,0.8,4.4,2,6.8,1.9  c2.8,0.1,5.4-1.4,7.9-2.7c-2.1,2.7-5.2,5.8-8.5,6.1c-4,0.8-7.8-2.1-11.7-2.8c-3-0.5-5.3,0.6-8.4,1.3  C1200.5,204.6,1202.8,202.7,1205.4,201.9 M1220.6,220.9c4.9-3.2,10.2-1.2,15,0.9c2.4,1.1,4.9,3,7.6,2.2c1.6-0.5,3.4-1.5,4.6-2.7  c-0.8,0.3-1.6,0.5-2.4,0.6c-1.3,0.1-2.7,0.3-4-0.4c-1.6-0.9-3.1-2.4-4.7-3.3c-2.2-1.2-4.6-2-7.1-2  C1226.2,216.1,1222.9,217.5,1220.6,220.9 M1274.5,220.7c-2.8,0.5-5.6,1.8-7.8,4c2.6-1.4,5.3-1.7,8.1-1.5c2.7,0.5,6.4,1.9,9.4,1.9  c2.4-0.1,4.9-1,6.7-3c0.3-0.3,0.7-0.7,0.9-1c-0.5,0.3-1.1,0.6-1.7,0.8c-3.6,1.7-6.9,0.4-10.4-0.7c-1.4-0.3-2.9-0.5-4.3-0.5  C1275.2,220.7,1274.9,220.7,1274.5,220.7 M1272.2,198c3.2-1.7,7-2.7,10.6-1.9c2.6,0.7,5,2.3,7.7,2.5c1,0.1,2.2-0.1,3.2-0.3  c-0.6-0.1-1.3-0.3-1.9-0.5c-3-0.8-5.3-3.3-8.2-4.1c-0.6-0.1-1.2-0.2-1.9-0.2C1278.2,193.6,1274.7,195.4,1272.2,198 M1244.3,211.2  c9.8-11.5,14.9,4.3,25.2,4.4c4.4,0.5,9.6-4.3,10.8-8.5c-2.3,3-7.7,5.9-10.9,4.3c-3-0.8-5.6-3.5-8.6-5.6c-2.4-1.6-4.8-2.5-7.1-2.5  C1249.8,203.3,1246.5,205.7,1244.3,211.2 M1222.8,187.9c-2.5,0.5-4.8,1.3-7,2.5c-2.3,1.2-4.4,2.8-6.7,4c3.2-0.8,6.2-2.3,9.5-2.8  c3.9-0.7,7.8-0.8,11.1,0.2c1.1,0.3,2.5,0.9,4.7,2c2,1.1,4,2.3,6.2,3c6.9,2.3,15.3,1,18.9-5.1c0.5-0.8,0.9-1.6,1.3-2.3  c-0.1,0.1-0.1,0.1-0.2,0.2c-1.9,1.9-4,3.5-6.7,4.4c-4.2,1.3-8.9,0.3-12.8-1.7c-2.9-1.7-5.7-3.4-9-4.3c-1.5-0.4-3.1-0.6-4.7-0.6  C1226,187.4,1224.4,187.6,1222.8,187.9 M1327.7,188.4c-2.5,0.5-4.8,1.3-7,2.4c-2.3,1.2-4.4,2.8-6.7,4c3.2-0.8,6.2-2.3,9.5-2.8  c3.9-0.7,7.8-0.8,11.1,0.2c1.1,0.3,2.5,0.9,4.7,2c2,1.1,4,2.3,6.2,3c6.9,2.3,15.3,1,18.9-5.1c0.5-0.8,0.9-1.6,1.3-2.3  c-0.1,0.1-0.1,0.1-0.2,0.2c-1.9,1.9-4,3.5-6.7,4.4c-4.2,1.3-8.9,0.3-12.8-1.7c-2.9-1.7-5.7-3.4-9-4.3c-1.5-0.4-3.1-0.6-4.7-0.6  C1330.8,187.9,1329.3,188,1327.7,188.4 M1333.8,219.3c9.8-11.5,14.9,4.3,25.2,4.4c4.4,0.5,9.6-4.3,10.8-8.5c-2.3,3-7.7,5.9-10.9,4.3  c-3-0.8-5.6-3.5-8.6-5.6c-2.4-1.6-4.8-2.5-7.1-2.5C1339.4,211.4,1336,213.8,1333.8,219.3 M1321.5,206.4c3-1.7,6.6-2.7,10-1.9  c2.5,0.7,4.7,2.3,7.3,2.5c1,0.1,2.1-0.1,3-0.3c-0.6-0.1-1.2-0.3-1.8-0.5c-2.8-0.8-4.9-3.3-7.8-4.1c-0.6-0.1-1.2-0.2-1.8-0.2  C1327.1,202,1323.9,203.9,1321.5,206.4 M1363.4,203.1c-2.8,0.5-5.6,1.8-7.8,4c2.6-1.4,5.3-1.7,8.1-1.5c2.7,0.5,6.3,1.9,9.4,1.9  c2.4-0.1,4.9-1,6.7-3c0.3-0.3,0.6-0.7,0.9-1c-0.5,0.3-1.1,0.6-1.7,0.8c-3.6,1.7-6.9,0.4-10.4-0.7c-1.4-0.3-2.9-0.5-4.3-0.5  C1364.1,203,1363.7,203,1363.4,203.1 M1304,222.7c4.9-3.2,10.2-1.2,15,0.9c2.4,1.1,4.9,3,7.6,2.2c1.6-0.5,3.4-1.5,4.6-2.7  c-0.8,0.3-1.6,0.5-2.4,0.6c-1.3,0.1-2.7,0.3-4-0.4c-1.6-0.9-3.1-2.4-4.7-3.3c-2.2-1.2-4.6-2-7.1-2  C1309.6,217.9,1306.3,219.3,1304,222.7 M1294.6,205.1c-2.6,0.7-4.9,2.6-7.1,4.4c3.1-0.7,5.4-1.8,8.4-1.3c3.9,0.7,7.7,3.6,11.7,2.8  c3.3-0.3,6.5-3.5,8.5-6.1c-2.6,1.2-5.1,2.8-7.9,2.7c-2.3,0.1-4.4-1-6.8-1.9c-1.6-0.4-3.2-0.8-4.7-0.8  C1296,204.9,1295.3,204.9,1294.6,205.1"
      />
      <linearGradient
        id="SVGID_275_"
        gradientUnits="userSpaceOnUse"
        x1="788.6643"
        y1="-89.6567"
        x2="1376.7643"
        y2="-89.6567"
        gradientTransform="matrix(1 0 0 1 0 304)"
      >
        <stop
          offset="0"
          style="stop-opacity: 0.2"
          :style="
            getRealTime.Light[1].LED2 > 0 ||
            getRealTime.Light[1].LED3 > 0 ||
            getRealTime.Light[1].LED4 > 0
              ? 'stop-color: #fff;'
              : 'stop-color: #c3c7c7;'
          "
        />
        <stop
          offset="0.25"
          style="stop-opacity: 0.5"
          :style="
            getRealTime.Light[1].LED2 > 0 ||
            getRealTime.Light[1].LED3 > 0 ||
            getRealTime.Light[1].LED4 > 0
              ? 'stop-color: #fff;'
              : 'stop-color: #c3c7c7;'
          "
        />
        <stop
          offset="0.5"
          style="stop-opacity: 0.6"
          :style="
            getRealTime.Light[1].LED2 > 0 ||
            getRealTime.Light[1].LED3 > 0 ||
            getRealTime.Light[1].LED4 > 0
              ? 'stop-color: #fff;'
              : 'stop-color: #c3c7c7;'
          "
        />
        <stop
          offset="0.75"
          style="stop-opacity: 0.5"
          :style="
            getRealTime.Light[1].LED2 > 0 ||
            getRealTime.Light[1].LED3 > 0 ||
            getRealTime.Light[1].LED4 > 0
              ? 'stop-color: #fff;'
              : 'stop-color: #c3c7c7;'
          "
        />
        <stop
          offset="1"
          style="stop-opacity: 0.2"
          :style="
            getRealTime.Light[1].LED2 > 0 ||
            getRealTime.Light[1].LED3 > 0 ||
            getRealTime.Light[1].LED4 > 0
              ? 'stop-color: #fff;'
              : 'stop-color: #c3c7c7;'
          "
        />
      </linearGradient>
      <path
        v-if="getRealTime.Fan[2].Speed > 0"
        class="st196"
        d="M799.7,83.7c0.7-0.2,1.4-0.2,2.1-0.2c1.6,0,3.2,0.3,4.7,0.8c2.3,0.8,4.4,2,6.8,1.9c2.8,0.1,5.4-1.4,7.9-2.7  c-2.1,2.7-5.2,5.8-8.5,6.1c-4,0.8-7.8-2.1-11.7-2.8c-3-0.5-5.3,0.6-8.4,1.3C794.9,86.3,797.1,84.5,799.7,83.7 M814.9,102.6  c4.9-3.2,10.2-1.2,15,0.9c2.4,1.1,4.9,3,7.6,2.2c1.6-0.5,3.4-1.5,4.6-2.7c-0.8,0.3-1.6,0.5-2.4,0.6c-1.3,0.1-2.7,0.3-4-0.4  c-1.6-0.9-3.1-2.4-4.7-3.3c-2.2-1.2-4.6-2-7.1-2C820.5,97.9,817.3,99.3,814.9,102.6 M868.9,102.5c-2.8,0.5-5.6,1.8-7.8,4  c2.6-1.4,5.3-1.7,8.1-1.5c2.7,0.5,6.4,1.9,9.4,1.9c2.4-0.1,4.9-1,6.7-3c0.3-0.3,0.7-0.7,0.9-1c-0.5,0.3-1.1,0.6-1.7,0.8  c-3.6,1.7-6.9,0.4-10.4-0.7c-1.4-0.3-2.9-0.5-4.3-0.5C869.6,102.5,869.2,102.5,868.9,102.5 M866.6,79.8c3.2-1.7,7-2.7,10.6-1.9  c2.6,0.7,5,2.3,7.7,2.5c1,0.1,2.2-0.1,3.2-0.3c-0.6-0.1-1.3-0.3-1.9-0.5c-3-0.8-5.3-3.3-8.2-4.1c-0.6-0.1-1.2-0.2-1.9-0.2  C872.5,75.3,869,77.2,866.6,79.8 M838.6,93c9.8-11.5,14.9,4.3,25.2,4.4c4.4,0.5,9.6-4.3,10.8-8.5c-2.3,3-7.7,5.9-10.9,4.3  c-3-0.8-5.6-3.5-8.6-5.6c-2.4-1.6-4.8-2.5-7.1-2.5C844.1,85.1,840.8,87.4,838.6,93 M817.2,69.7c-2.5,0.5-4.8,1.3-7,2.5  c-2.3,1.2-4.4,2.8-6.7,4c3.2-0.8,6.2-2.3,9.5-2.8c3.9-0.7,7.8-0.8,11.1,0.2c1.1,0.3,2.5,0.9,4.7,2c2,1.1,4,2.3,6.2,3  c6.9,2.3,15.3,1,18.9-5.1c0.5-0.8,0.9-1.6,1.3-2.3c-0.1,0.1-0.1,0.1-0.2,0.2c-1.9,1.9-4,3.5-6.7,4.4c-4.2,1.3-8.9,0.3-12.8-1.7  c-2.9-1.7-5.7-3.4-9-4.3c-1.5-0.4-3.1-0.6-4.7-0.6C820.3,69.2,818.7,69.4,817.2,69.7 M922.1,70.1c-2.5,0.5-4.8,1.3-7,2.4  c-2.3,1.2-4.4,2.8-6.7,4c3.2-0.8,6.2-2.3,9.5-2.8c3.9-0.7,7.8-0.8,11.1,0.2c1.1,0.3,2.5,0.9,4.7,2c2,1.1,4,2.3,6.2,3  c6.9,2.3,15.3,1,18.9-5.1c0.5-0.8,0.9-1.6,1.3-2.3c-0.1,0.1-0.1,0.1-0.2,0.2c-1.9,1.9-4,3.5-6.7,4.4c-4.2,1.3-8.9,0.3-12.8-1.7  c-2.9-1.7-5.7-3.4-9-4.3c-1.5-0.4-3.1-0.6-4.7-0.6C925.2,69.7,923.6,69.8,922.1,70.1 M928.2,101.1c9.8-11.5,14.9,4.3,25.2,4.4  c4.4,0.5,9.6-4.3,10.8-8.5c-2.3,3-7.7,5.9-10.9,4.3c-3-0.8-5.6-3.5-8.6-5.6c-2.4-1.6-4.8-2.5-7.1-2.5  C933.7,93.2,930.4,95.6,928.2,101.1 M915.9,88.2c3-1.7,6.6-2.7,10-1.9c2.5,0.7,4.7,2.3,7.3,2.5c1,0.1,2.1-0.1,3-0.3  c-0.6-0.1-1.2-0.3-1.8-0.5c-2.8-0.8-4.9-3.3-7.8-4.1c-0.6-0.1-1.2-0.2-1.8-0.2C921.5,83.8,918.2,85.7,915.9,88.2 M957.7,84.9  c-2.8,0.5-5.6,1.8-7.8,4c2.6-1.4,5.3-1.7,8.1-1.5c2.7,0.5,6.3,1.9,9.4,1.9c2.4-0.1,4.9-1,6.7-3c0.3-0.3,0.6-0.7,0.9-1  c-0.5,0.3-1.1,0.6-1.7,0.8c-3.6,1.7-6.9,0.4-10.4-0.7c-1.4-0.3-2.9-0.5-4.3-0.5C958.4,84.8,958.1,84.8,957.7,84.9 M898.3,104.5  c4.9-3.2,10.2-1.2,15,0.9c2.4,1.1,4.9,3,7.6,2.2c1.6-0.5,3.4-1.5,4.6-2.7c-0.8,0.3-1.6,0.5-2.4,0.6c-1.3,0.1-2.7,0.3-4-0.4  c-1.6-0.9-3.1-2.4-4.7-3.3c-2.2-1.2-4.6-2-7.1-2C904,99.7,900.7,101.1,898.3,104.5 M888.9,86.9c-2.6,0.7-4.9,2.6-7.1,4.4  c3.1-0.7,5.4-1.8,8.4-1.3c3.9,0.7,7.7,3.6,11.7,2.8c3.3-0.3,6.5-3.5,8.5-6.1c-2.6,1.2-5.1,2.8-7.9,2.7c-2.3,0.1-4.4-1-6.8-1.9  c-1.6-0.4-3.2-0.8-4.7-0.8C890.4,86.7,889.6,86.7,888.9,86.9 M1002.9,82.8c0.7-0.2,1.4-0.2,2.1-0.2c1.6,0,3.2,0.3,4.7,0.8  c2.3,0.8,4.4,2,6.8,1.9c2.8,0.1,5.4-1.4,7.9-2.7c-2.1,2.7-5.2,5.8-8.5,6.1c-4,0.8-7.8-2.1-11.7-2.8c-3-0.5-5.3,0.6-8.4,1.3  C998,85.5,1000.3,83.6,1002.9,82.8 M1018.1,101.7c4.9-3.2,10.2-1.2,15,0.9c2.4,1.1,4.9,3,7.6,2.2c1.6-0.5,3.4-1.5,4.6-2.7  c-0.8,0.3-1.6,0.5-2.4,0.6c-1.3,0.1-2.7,0.3-4-0.4c-1.6-0.9-3.1-2.4-4.7-3.3c-2.2-1.2-4.6-2-7.1-2  C1023.7,97,1020.4,98.4,1018.1,101.7 M1072,101.6c-2.8,0.5-5.6,1.8-7.8,4c2.6-1.4,5.3-1.7,8.1-1.5c2.7,0.5,6.4,1.9,9.4,1.9  c2.4-0.1,4.9-1,6.7-3c0.3-0.3,0.7-0.7,0.9-1c-0.5,0.3-1.1,0.6-1.7,0.8c-3.6,1.7-6.9,0.4-10.4-0.7c-1.4-0.3-2.9-0.5-4.3-0.5  C1072.7,101.6,1072.4,101.6,1072,101.6 M1069.7,78.9c3.2-1.7,7-2.7,10.6-1.9c2.6,0.7,5,2.3,7.7,2.5c1,0.1,2.2-0.1,3.2-0.3  c-0.6-0.1-1.3-0.3-1.9-0.5c-3-0.8-5.3-3.3-8.2-4.1c-0.6-0.1-1.2-0.2-1.9-0.2C1075.7,74.5,1072.2,76.3,1069.7,78.9 M1041.8,92.1  c9.8-11.5,14.9,4.3,25.2,4.4c4.4,0.5,9.6-4.3,10.8-8.5c-2.3,3-7.7,5.9-10.9,4.3c-3-0.8-5.6-3.5-8.6-5.6c-2.4-1.6-4.8-2.5-7.1-2.5  C1047.3,84.2,1044,86.6,1041.8,92.1 M1020.4,68.8c-2.5,0.5-4.8,1.3-7,2.5c-2.3,1.2-4.4,2.8-6.7,4c3.2-0.8,6.2-2.3,9.5-2.8  c3.9-0.7,7.8-0.8,11.1,0.2c1.1,0.3,2.5,0.9,4.7,2c2,1.1,4,2.3,6.2,3c6.9,2.3,15.3,1,18.9-5.1c0.5-0.8,0.9-1.6,1.3-2.3  c-0.1,0.1-0.1,0.1-0.2,0.2c-1.9,1.9-4,3.5-6.7,4.4c-4.2,1.3-8.9,0.3-12.8-1.7c-2.9-1.7-5.7-3.4-9-4.3c-1.5-0.4-3.1-0.6-4.7-0.6  C1023.5,68.3,1021.9,68.5,1020.4,68.8 M1125.2,69.2c-2.5,0.5-4.8,1.3-7,2.4c-2.3,1.2-4.4,2.8-6.7,4c3.2-0.8,6.2-2.3,9.5-2.8  c3.9-0.7,7.8-0.8,11.1,0.2c1.1,0.3,2.5,0.9,4.7,2c2,1.1,4,2.3,6.2,3c6.9,2.3,15.3,1,18.9-5.1c0.5-0.8,0.9-1.6,1.3-2.3  c-0.1,0.1-0.1,0.1-0.2,0.2c-1.9,1.9-4,3.5-6.7,4.4c-4.2,1.3-8.9,0.3-12.8-1.7c-2.9-1.7-5.7-3.4-9-4.3c-1.5-0.4-3.1-0.6-4.7-0.6  C1128.4,68.8,1126.8,68.9,1125.2,69.2 M1131.3,100.2c9.8-11.5,14.9,4.3,25.2,4.4c4.4,0.5,9.6-4.3,10.8-8.5c-2.3,3-7.7,5.9-10.9,4.3  c-3-0.8-5.6-3.5-8.6-5.6c-2.4-1.6-4.8-2.5-7.1-2.5C1136.9,92.3,1133.5,94.7,1131.3,100.2 M1119.1,87.3c3-1.7,6.6-2.7,10-1.9  c2.5,0.7,4.7,2.3,7.3,2.5c1,0.1,2.1-0.1,3-0.3c-0.6-0.1-1.2-0.3-1.8-0.5c-2.8-0.8-4.9-3.3-7.8-4.1c-0.6-0.1-1.2-0.2-1.8-0.2  C1124.7,82.9,1121.4,84.8,1119.1,87.3 M1160.9,84c-2.8,0.5-5.6,1.8-7.8,4c2.6-1.4,5.3-1.7,8.1-1.5c2.7,0.5,6.3,1.9,9.4,1.9  c2.4-0.1,4.9-1,6.7-3c0.3-0.3,0.6-0.7,0.9-1c-0.5,0.3-1.1,0.6-1.7,0.8c-3.6,1.7-6.9,0.4-10.4-0.7c-1.4-0.3-2.9-0.5-4.3-0.5  C1161.6,83.9,1161.2,83.9,1160.9,84 M1101.5,103.6c4.9-3.2,10.2-1.2,15,0.9c2.4,1.1,4.9,3,7.6,2.2c1.6-0.5,3.4-1.5,4.6-2.7  c-0.8,0.3-1.6,0.5-2.4,0.6c-1.3,0.1-2.7,0.3-4-0.4c-1.6-0.9-3.1-2.4-4.7-3.3c-2.2-1.2-4.6-2-7.1-2  C1107.1,98.8,1103.8,100.2,1101.5,103.6 M1092.1,86c-2.6,0.7-4.9,2.6-7.1,4.4c3.1-0.7,5.4-1.8,8.4-1.3c3.9,0.7,7.7,3.6,11.7,2.8  c3.3-0.3,6.5-3.5,8.5-6.1c-2.6,1.2-5.1,2.8-7.9,2.7c-2.3,0.1-4.4-1-6.8-1.9c-1.6-0.4-3.2-0.8-4.7-0.8  C1093.5,85.8,1092.8,85.8,1092.1,86 M1205.4,82.7c0.7-0.2,1.4-0.2,2.1-0.2c1.6,0,3.2,0.3,4.7,0.8c2.3,0.8,4.4,2,6.8,1.9  c2.8,0.1,5.4-1.4,7.9-2.7c-2.1,2.7-5.2,5.8-8.5,6.1c-4,0.8-7.8-2.1-11.7-2.8c-3-0.5-5.3,0.6-8.4,1.3  C1200.5,85.3,1202.8,83.4,1205.4,82.7 M1220.6,101.6c4.9-3.2,10.2-1.2,15,0.9c2.4,1.1,4.9,3,7.6,2.2c1.6-0.5,3.4-1.5,4.6-2.7  c-0.8,0.3-1.6,0.5-2.4,0.6c-1.3,0.1-2.7,0.3-4-0.4c-1.6-0.9-3.1-2.4-4.7-3.3c-2.2-1.2-4.6-2-7.1-2  C1226.2,96.8,1222.9,98.2,1220.6,101.6 M1274.5,101.5c-2.8,0.5-5.6,1.8-7.8,4c2.6-1.4,5.3-1.7,8.1-1.5c2.7,0.5,6.4,1.9,9.4,1.9  c2.4-0.1,4.9-1,6.7-3c0.3-0.3,0.7-0.7,0.9-1c-0.5,0.3-1.1,0.6-1.7,0.8c-3.6,1.7-6.9,0.4-10.4-0.7c-1.4-0.3-2.9-0.5-4.3-0.5  C1275.2,101.4,1274.9,101.4,1274.5,101.5 M1272.2,78.8c3.2-1.7,7-2.7,10.6-1.9c2.6,0.7,5,2.3,7.7,2.5c1,0.1,2.2-0.1,3.2-0.3  c-0.6-0.1-1.3-0.3-1.9-0.5c-3-0.8-5.3-3.3-8.2-4.1c-0.6-0.1-1.2-0.2-1.9-0.2C1278.2,74.3,1274.7,76.2,1272.2,78.8 M1244.3,92  c9.8-11.5,14.9,4.3,25.2,4.4c4.4,0.5,9.6-4.3,10.8-8.5c-2.3,3-7.7,5.9-10.9,4.3c-3-0.8-5.6-3.5-8.6-5.6c-2.4-1.6-4.8-2.5-7.1-2.5  C1249.8,84,1246.5,86.4,1244.3,92 M1222.8,68.7c-2.5,0.5-4.8,1.3-7,2.5c-2.3,1.2-4.4,2.8-6.7,4c3.2-0.8,6.2-2.3,9.5-2.8  c3.9-0.7,7.8-0.8,11.1,0.2c1.1,0.3,2.5,0.9,4.7,2c2,1.1,4,2.3,6.2,3c6.9,2.3,15.3,1,18.9-5.1c0.5-0.8,0.9-1.6,1.3-2.3  c-0.1,0.1-0.1,0.1-0.2,0.2c-1.9,1.9-4,3.5-6.7,4.4c-4.2,1.3-8.9,0.3-12.8-1.7c-2.9-1.7-5.7-3.4-9-4.3c-1.5-0.4-3.1-0.6-4.7-0.6  C1226,68.2,1224.4,68.4,1222.8,68.7 M1327.7,69.1c-2.5,0.5-4.8,1.3-7,2.4c-2.3,1.2-4.4,2.8-6.7,4c3.2-0.8,6.2-2.3,9.5-2.8  c3.9-0.7,7.8-0.8,11.1,0.2c1.1,0.3,2.5,0.9,4.7,2c2,1.1,4,2.3,6.2,3c6.9,2.3,15.3,1,18.9-5.1c0.5-0.8,0.9-1.6,1.3-2.3  c-0.1,0.1-0.1,0.1-0.2,0.2c-1.9,1.9-4,3.5-6.7,4.4c-4.2,1.3-8.9,0.3-12.8-1.7c-2.9-1.7-5.7-3.4-9-4.3c-1.5-0.4-3.1-0.6-4.7-0.6  C1330.8,68.6,1329.3,68.8,1327.7,69.1 M1333.8,100.1c9.8-11.5,14.9,4.3,25.2,4.4c4.4,0.5,9.6-4.3,10.8-8.5c-2.3,3-7.7,5.9-10.9,4.3  c-3-0.8-5.6-3.5-8.6-5.6c-2.4-1.6-4.8-2.5-7.1-2.5C1339.4,92.2,1336,94.6,1333.8,100.1 M1321.5,87.2c3-1.7,6.6-2.7,10-1.9  c2.5,0.7,4.7,2.3,7.3,2.5c1,0.1,2.1-0.1,3-0.3c-0.6-0.1-1.2-0.3-1.8-0.5c-2.8-0.8-4.9-3.3-7.8-4.1c-0.6-0.1-1.2-0.2-1.8-0.2  C1327.1,82.7,1323.9,84.6,1321.5,87.2 M1363.4,83.8c-2.8,0.5-5.6,1.8-7.8,4c2.6-1.4,5.3-1.7,8.1-1.5c2.7,0.5,6.3,1.9,9.4,1.9  c2.4-0.1,4.9-1,6.7-3c0.3-0.3,0.6-0.7,0.9-1c-0.5,0.3-1.1,0.6-1.7,0.8c-3.6,1.7-6.9,0.4-10.4-0.7c-1.4-0.3-2.9-0.5-4.3-0.5  C1364.1,83.8,1363.7,83.8,1363.4,83.8 M1304,103.4c4.9-3.2,10.2-1.2,15,0.9c2.4,1.1,4.9,3,7.6,2.2c1.6-0.5,3.4-1.5,4.6-2.7  c-0.8,0.3-1.6,0.5-2.4,0.6c-1.3,0.1-2.7,0.3-4-0.4c-1.6-0.9-3.1-2.4-4.7-3.3c-2.2-1.2-4.6-2-7.1-2  C1309.6,98.6,1306.3,100,1304,103.4 M1294.6,85.9c-2.6,0.7-4.9,2.6-7.1,4.4c3.1-0.7,5.4-1.8,8.4-1.3c3.9,0.7,7.7,3.6,11.7,2.8  c3.3-0.3,6.5-3.5,8.5-6.1c-2.6,1.2-5.1,2.8-7.9,2.7c-2.3,0.1-4.4-1-6.8-1.9c-1.6-0.4-3.2-0.8-4.7-0.8  C1296,85.6,1295.3,85.7,1294.6,85.9"
      />
      <linearGradient
        id="SVGID_276_"
        gradientUnits="userSpaceOnUse"
        x1="788.6643"
        y1="-208.742"
        x2="1376.7643"
        y2="-208.742"
        gradientTransform="matrix(1 0 0 1 0 304)"
      >
        <stop
          offset="0"
          style="stop-opacity: 0.2"
          :style="
            getRealTime.Light[2].LED2 > 0 ||
            getRealTime.Light[2].LED3 > 0 ||
            getRealTime.Light[2].LED4 > 0
              ? 'stop-color: #fff;'
              : 'stop-color: #c3c7c7;'
          "
        />
        <stop
          offset="0.25"
          :style="
            getRealTime.Light[2].LED2 > 0 ||
            getRealTime.Light[2].LED3 > 0 ||
            getRealTime.Light[2].LED4 > 0
              ? 'stop-color: #fff;'
              : 'stop-color: #c3c7c7;'
          "
          style="stop-opacity: 0.5"
        />
        <stop
          offset="0.5"
          :style="
            getRealTime.Light[2].LED2 > 0 ||
            getRealTime.Light[2].LED3 > 0 ||
            getRealTime.Light[2].LED4 > 0
              ? 'stop-color: #fff;'
              : 'stop-color: #c3c7c7;'
          "
          style="stop-opacity: 0.6"
        />
        <stop
          offset="0.75"
          :style="
            getRealTime.Light[2].LED2 > 0 ||
            getRealTime.Light[2].LED3 > 0 ||
            getRealTime.Light[2].LED4 > 0
              ? 'stop-color: #fff;'
              : 'stop-color: #c3c7c7;'
          "
          style="stop-opacity: 0.5"
        />
        <stop
          offset="1"
          :style="
            getRealTime.Light[2].LED2 > 0 ||
            getRealTime.Light[2].LED3 > 0 ||
            getRealTime.Light[2].LED4 > 0
              ? 'stop-color: #fff;'
              : 'stop-color: #c3c7c7;'
          "
          style="stop-opacity: 0.2"
        />
      </linearGradient>
      <text
        transform="matrix(1 0 0 1 794.5811 76.796)"
        :class="
          getRealTime.Light[2].LED2 > 0 ||
          getRealTime.Light[2].LED3 > 0 ||
          getRealTime.Light[2].LED4 > 0
            ? 'st25'
            : 'st197'
        "
      >
        White: {{ getRealTime.Light[2].LED1 }} % Red:
        {{ getRealTime.Light[2].LED2 }} % Blue:
        {{ getRealTime.Light[2].LED3 }} % Fa-Red:
        {{ getRealTime.Light[2].LED4 }} %
      </text>
      <text
        transform="matrix(1 0 0 1 1293.6517 76.7959)"
        :class="
          getRealTime.Light[2].LED2 > 0 ||
          getRealTime.Light[2].LED3 > 0 ||
          getRealTime.Light[2].LED4 > 0
            ? 'st25'
            : 'st197'
        "
      >
        Fan: {{ getRealTime.Fan[2].Speed }} %
      </text>
      <text
        transform="matrix(1 0 0 1 794.5813 188.9717)"
        :class="
          getRealTime.Light[1].LED2 > 0 ||
          getRealTime.Light[1].LED3 > 0 ||
          getRealTime.Light[1].LED4 > 0
            ? 'st25'
            : 'st197'
        "
      >
        White: {{ getRealTime.Light[1].LED1 }} % Red:
        {{ getRealTime.Light[1].LED2 }} % Blue:
        {{ getRealTime.Light[1].LED3 }} % Fa-Red:
        {{ getRealTime.Light[1].LED4 }} %
      </text>
      <text
        transform="matrix(1 0 0 1 1293.6514 189.7958)"
        :class="
          getRealTime.Light[1].LED2 > 0 ||
          getRealTime.Light[1].LED3 > 0 ||
          getRealTime.Light[1].LED4 > 0
            ? 'st25'
            : 'st197'
        "
      >
        Fan: {{ getRealTime.Fan[1].Speed }} %
      </text>
      <text
        transform="matrix(1 0 0 1 794.5816 304.6182)"
        :class="
          getRealTime.Light[0].LED2 > 0 ||
          getRealTime.Light[0].LED3 > 0 ||
          getRealTime.Light[0].LED4 > 0
            ? 'st25'
            : 'st197'
        "
      >
        White: {{ getRealTime.Light[0].LED1 }} % Red:
        {{ getRealTime.Light[0].LED2 }} % Blue:
        {{ getRealTime.Light[0].LED3 }} % Fa-Red:
        {{ getRealTime.Light[0].LED4 }} %
      </text>
      <text
        transform="matrix(1 0 0 1 1293.1128 304.618)"
        class="st182"
        :class="
          getRealTime.Light[0].LED2 > 0 ||
          getRealTime.Light[0].LED3 > 0 ||
          getRealTime.Light[0].LED4 > 0
            ? 'st25'
            : 'st197'
        "
      >
        Fan: {{ getRealTime.Fan[0].Speed }} %
      </text>
      <g class="blink">
        <g v-if="getRealTime.Valve[8].On">
          <line class="st201" x1="627.2" y1="178.2" x2="627.2" y2="228.2" />
          <g>
            <line class="st203" x1="627.2" y1="178.2" x2="627.2" y2="223.2" />
            <g>
              <polygon points="623.7,222.2 627.2,228.2 630.7,222.2     " />
            </g>
          </g>
        </g>
        <g v-if="getRealTime.Valve[7].On">
          <line class="st201" x1="627.2" y1="300.6" x2="627.2" y2="350.6" />
          <g>
            <line class="st203" x1="627.2" y1="300.6" x2="627.2" y2="345.6" />
            <g>
              <polygon points="623.7,344.5 627.2,350.6 630.7,344.5     " />
            </g>
          </g>
        </g>
        <g v-if="getRealTime.Valve[6].On">
          <line class="st201" x1="627.2" y1="404.1" x2="627.2" y2="454.1" />
          <g>
            <line class="st203" x1="627.2" y1="404.1" x2="627.2" y2="449.1" />
            <g>
              <polygon points="623.7,448 627.2,454.1 630.7,448     " />
            </g>
          </g>
        </g>
        <g
          v-if="
            getRealTime.Valve[8].On ||
            getRealTime.Valve[7].On ||
            getRealTime.Valve[6].On
          "
        >
          <line class="st201" x1="864.3" y1="520.6" x2="864.3" y2="580.6" />
          <g>
            <line class="st203" x1="864.3" y1="520.6" x2="864.3" y2="575.5" />
            <g>
              <polygon points="860.8,574.5 864.3,580.6 867.8,574.5     " />
            </g>
          </g>
        </g>
        <g
          v-if="
            getRealTime.Valve[8].On ||
            getRealTime.Valve[7].On ||
            getRealTime.Valve[6].On
          "
        >
          <line class="st201" x1="746.8" y1="471.2" x2="796.8" y2="471.2" />
          <g>
            <line class="st203" x1="746.8" y1="471.2" x2="791.7" y2="471.2" />
            <g>
              <polygon points="790.7,474.7 796.8,471.2 790.7,467.7     " />
            </g>
          </g>
        </g>
      </g>
      <g class="blink">
        <g v-if="getRealTime.Valve[13].On">
          <line class="st25" x1="698" y1="233.6" x2="698" y2="283.6" />
          <g>
            <line class="st199" x1="698" y1="233.6" x2="698" y2="278.6" />
            <g>
              <polygon
                class="st200"
                points="694.5,277.6 698,283.6 701.5,277.6     "
              />
            </g>
          </g>
        </g>
        <g v-if="getRealTime.Valve[12].On">
          <line class="st25" x1="698" y1="352.3" x2="698" y2="402.3" />
          <g>
            <line class="st199" x1="698" y1="352.3" x2="698" y2="397.3" />
            <g>
              <polygon
                class="st200"
                points="694.5,396.3 698,402.3 701.5,396.3     "
              />
            </g>
          </g>
        </g>
        <g v-if="getRealTime.Valve[11].On">
          <line class="st25" x1="698" y1="443.3" x2="698" y2="479.8" />
          <g>
            <line class="st199" x1="698" y1="443.3" x2="698" y2="474.8" />
            <g>
              <polygon
                class="st200"
                points="694.5,473.8 698,479.8 701.5,473.8     "
              />
            </g>
          </g>
        </g>
        <g
          v-if="
            getRealTime.Valve[13].On ||
            getRealTime.Valve[12].On ||
            getRealTime.Valve[11].On
          "
        >
          <line class="st201" x1="899.8" y1="486.6" x2="983.2" y2="486.6" />
          <g>
            <line class="st202" x1="899.8" y1="486.6" x2="978.2" y2="486.6" />
            <g>
              <polygon
                class="st25"
                points="977.2,490.1 983.2,486.6 977.2,483.1     "
              />
            </g>
          </g>
        </g>
        <g
          v-if="
            getRealTime.Valve[13].On ||
            getRealTime.Valve[12].On ||
            getRealTime.Valve[11].On
          "
        >
          <line class="st201" x1="1168.2" y1="509.3" x2="1168.2" y2="569.3" />
          <g>
            <line class="st202" x1="1168.2" y1="509.3" x2="1168.2" y2="564.3" />
            <g>
              <polygon
                class="st25"
                points="1164.7,563.3 1168.2,569.3 1171.6,563.3     "
              />
            </g>
          </g>
        </g>
      </g>
      <g class="blink">
        <g
          v-if="
            getRealTime.Valve[0].On ||
            getRealTime.Valve[16].On ||
            getRealTime.Valve[17].On ||
            getRealTime.Valve[18].On
          "
        >
          <line class="st201" x1="630" y1="513.8" x2="701.7" y2="513.8" />
          <g>
            <line class="st203" x1="630" y1="513.8" x2="696.7" y2="513.8" />
            <g>
              <polygon points="695.7,517.3 701.7,513.8 695.7,510.3     " />
            </g>
          </g>
        </g>
        <g v-if="getRealTime.Valve[0].On">
          <line class="st201" x1="793.3" y1="513.8" x2="793.3" y2="541.6" />
          <g>
            <line class="st203" x1="793.3" y1="513.8" x2="793.3" y2="536.6" />
            <g>
              <polygon points="789.8,535.6 793.3,541.6 796.8,535.6     " />
            </g>
          </g>
        </g>
        <g v-if="getRealTime.Valve[16].On">
          <g>
            <line class="st201" x1="1450" y1="447.8" x2="1469.8" y2="447.8" />
            <g>
              <line class="st203" x1="1455" y1="447.8" x2="1469.8" y2="447.8" />
              <g>
                <polygon points="1456,451.3 1450,447.8 1456,444.4      " />
              </g>
            </g>
          </g>
          <line class="st203" x1="1469.8" y1="447.3" x2="1469.8" y2="480.6" />
        </g>
        <g v-if="getRealTime.Valve[17].On">
          <g>
            <line class="st201" x1="1449.8" y1="328.3" x2="1469.6" y2="328.3" />
            <g>
              <line
                class="st203"
                x1="1454.8"
                y1="328.3"
                x2="1469.6"
                y2="328.3"
              />
              <g>
                <polygon
                  points="1455.8,331.8 1449.8,328.3 1455.8,324.8      "
                />
              </g>
            </g>
          </g>
          <line class="st203" x1="1469.6" y1="327.8" x2="1469.6" y2="361" />
        </g>
        <g v-if="getRealTime.Valve[18].On">
          <g>
            <line class="st201" x1="1449.4" y1="210.2" x2="1469.2" y2="210.2" />
            <g>
              <line
                class="st203"
                x1="1454.4"
                y1="210.2"
                x2="1469.2"
                y2="210.2"
              />
              <g>
                <polygon
                  points="1455.4,213.7 1449.4,210.2 1455.4,206.7      "
                />
              </g>
            </g>
          </g>
          <line class="st203" x1="1469.2" y1="209.7" x2="1469.2" y2="242.9" />
        </g>
      </g>
      <g class="blink">
        <g v-if="getRealTime.Valve[1].On">
          <g>
            <line class="st201" x1="1527.6" y1="386" x2="1547.5" y2="386" />
            <g>
              <line class="st203" x1="1532.7" y1="386" x2="1547.5" y2="386" />
              <g>
                <polygon points="1533.7,389.5 1527.6,386 1533.7,382.5      " />
              </g>
            </g>
          </g>
          <line class="st203" x1="1547.5" y1="385.5" x2="1547.5" y2="418.7" />
        </g>
        <g v-if="getRealTime.Valve[2].On">
          <g>
            <line class="st201" x1="1527.2" y1="266.1" x2="1547.1" y2="266.1" />
            <g>
              <line
                class="st203"
                x1="1532.3"
                y1="266.1"
                x2="1547.1"
                y2="266.1"
              />
              <g>
                <polygon
                  points="1533.3,269.6 1527.2,266.1 1533.3,262.6      "
                />
              </g>
            </g>
          </g>
          <line class="st203" x1="1547.1" y1="265.6" x2="1547.1" y2="298.8" />
        </g>
        <g v-if="getRealTime.Valve[3].On">
          <g>
            <line class="st201" x1="1527.6" y1="149.5" x2="1547.4" y2="149.5" />
            <g>
              <line
                class="st203"
                x1="1532.6"
                y1="149.5"
                x2="1547.4"
                y2="149.5"
              />
              <g>
                <polygon points="1533.6,153 1527.6,149.5 1533.6,146      " />
              </g>
            </g>
          </g>
          <line class="st203" x1="1547.4" y1="149" x2="1547.4" y2="182.2" />
        </g>
        <g v-if="getRealTime.Pump[1].On">
          <line class="st201" x1="1019.6" y1="566.5" x2="1019.6" y2="626.5" />
          <g>
            <line class="st203" x1="1019.6" y1="571.6" x2="1019.6" y2="626.5" />
            <g>
              <polygon points="1016.1,572.6 1019.6,566.5 1023.1,572.6     " />
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>
<script>
import Cookies from "js-cookie";
export default {
  name: "TowerCom",
  async created() {
    if (this.$route.params.data != "" && this.$route.params.data != null) {
      this.idTower = this.$route.params.data;
      Cookies.set("idTower", this.idTower);
    } else {
      this.idTower = Cookies.get("idTower");
    }
    this.getData();
  },
  computed: {
    getAccess() {
      return this.$store.state.auth.access;
    },
    getRealTime() {
      return this.$store.getters.realTimeTower;
    },
  },
  data() {
    return {
      idTower: 0,
      idFarm: 0,
    };
  },
  methods: {
    fontSizeABpH(d) {
      if (d > 100) {
        d = 100;
      }
      let size = (d * 102) / 100;
      return size;
    },
    fontSizeTank(d) {
      if (d > 100) {
        d = 100;
      }
      let size = (d * 150) / 100;
      return size;
    },
    async getData() {
      this.idFarm = Cookies.get("idFarm");
      console.log(this.idFarm);
      this.$store.dispatch("getFarmByID", this.idFarm).then(() => {
        this.idTower = Cookies.get("idTower");
        this.$store.dispatch("getTowerByID", this.idTower).then(() => {
          this.$store.dispatch("getRealTime", this.idFarm);
        });
      });
    },
  },
};
</script>

<style type="text/css">
.st0 {
  fill: #0f141a;
}
.st1 {
  fill: #49565e;
}
.st2 {
  fill: #293334;
}
.st3 {
  fill: #56636b;
}
.st4 {
  fill: #67787f;
}
.st5 {
  fill: #213034;
}
.st6 {
  fill: none;
  stroke: #213034;
  stroke-width: 0.5;
  stroke-miterlimit: 10;
}
.st7 {
  fill: #45565c;
}
.st8 {
  fill: #a8b2b6;
}
.st9 {
  fill: #364042;
}
.st10 {
  fill: #384044;
}
.st11 {
  fill: #49565d;
}
.st12 {
  fill: #c1c1c1;
}
.st13 {
  fill: #bfc0c0;
}
.st14 {
  fill: #cbcbcb;
}
.st15 {
  fill: #dbdbdb;
}
.st16 {
  fill: #d4d4d4;
}
.st17 {
  fill: #d3d3d3;
}
.st18 {
  fill: #4a565d;
}
.st19 {
  fill: #60c8cb;
}
.st20 {
  fill: #299fa4;
}
.st21 {
  fill: #76d8dd;
}
.st22 {
  fill: #3fa7aa;
}
.st23 {
  fill: #8dd8d8;
}
.st24 {
  fill: #98e5ed;
}
.st25 {
  fill: #ffffff;
}
.st26 {
  fill: #a79790;
}
.st27 {
  fill: url(#SVGID_1_);
}
.st28 {
  fill: url(#SVGID_2_);
}
.st29 {
  fill: url(#SVGID_3_);
}
.st30 {
  fill: #88ccee;
}
.st31 {
  fill: #4d4344;
}
.st32 {
  fill: #4a8aab;
}
.st33 {
  fill: #4da2ae;
}
.st34 {
  fill: #63e8ec;
}
.st35 {
  fill: #bef3f6;
}
.st36 {
  fill: #51b8c7;
}
.st37 {
  fill: #293335;
}
.st38 {
  fill: #326377;
}
.st39 {
  fill: #f2f5f6;
}
.st40 {
  fill: #e8eff3;
}
.st41 {
  fill: #d8e0e4;
}
.st42 {
  fill: #d8e1e7;
}
.st43 {
  fill: #e1e6ea;
}
.st44 {
  fill: #cdd4d7;
}
.st45 {
  fill: #e7eef1;
}
.st46 {
  fill: #f1f5f6;
}
.st47 {
  fill: #e7eef2;
}
.st48 {
  fill: #e7eff1;
}
.st49 {
  fill: #2b5663;
}
.st50 {
  fill: #65c9ce;
}
.st51 {
  fill: #4aa0a0;
}
.st52 {
  fill: #7fbfc6;
}
.st53 {
  fill: #407b87;
}
.st54 {
  fill: #3a8e9c;
}
.st55 {
  fill: #247d89;
}
.st56 {
  fill: #28777c;
}
.st57 {
  fill: #86b9c4;
}
.st58 {
  fill: #47505a;
}
.st59 {
  fill: #817d84;
}
.st60 {
  fill: #465157;
}
.st61 {
  fill: #92a7ac;
}
.st62 {
  fill: #6c8a8c;
}
.st63 {
  fill: #708f92;
}
.st64 {
  fill: #6ac435;
}
.st65 {
  fill: #bdd3d6;
}
.st66 {
  fill: #3c7f84;
}
.st67 {
  fill: #c13636;
}
.st68 {
  fill: #d5d5d5;
}
.st69 {
  fill: #dee1de;
}
.st70 {
  fill: #5d4740;
}
.st71 {
  fill: #5d4743;
}
.st72 {
  fill: #6f5857;
}
.st73 {
  fill: #777a7e;
}
.st74 {
  fill: #939393;
}
.st75 {
  fill: #d36acc;
}
.st76 {
  fill: #d2d3d1;
}
.st77 {
  fill: #c654c4;
}
.sta8 {
  fill: #f2b225;
}
.sta9 {
  fill: #eda60a;
}
.st78 {
  fill: #d13030;
}
.st79 {
  fill: #c60000;
}
.st80 {
  fill: #48af2f;
}
.st81 {
  fill: #128e0c;
}
.st82 {
  fill: #65337f;
}
.st83 {
  fill: #4b176d;
}
.st84 {
  fill: #c63434;
}
.st85 {
  fill: #7a7a7a;
}
.st86 {
  fill: #9cc666;
}
.st87 {
  fill: #709941;
}
.st88 {
  fill: #5f8231;
}
.st89 {
  clip-path: url(#SVGID_5_);
  fill: url(#SVGID_6_);
}
.st90 {
  clip-path: url(#SVGID_8_);
  fill: url(#SVGID_9_);
}
.st91 {
  clip-path: url(#SVGID_11_);
  fill: url(#SVGID_12_);
}
.st92 {
  clip-path: url(#SVGID_14_);
  fill: url(#SVGID_15_);
}
.st93 {
  clip-path: url(#SVGID_17_);
  fill: url(#SVGID_18_);
}
.st94 {
  clip-path: url(#SVGID_20_);
  fill: url(#SVGID_21_);
}
.st95 {
  clip-path: url(#SVGID_23_);
  fill: url(#SVGID_24_);
}
.st96 {
  clip-path: url(#SVGID_26_);
  fill: url(#SVGID_27_);
}
.st97 {
  clip-path: url(#SVGID_29_);
  fill: url(#SVGID_30_);
}
.st98 {
  clip-path: url(#SVGID_32_);
  fill: url(#SVGID_33_);
}
.st99 {
  clip-path: url(#SVGID_35_);
  fill: url(#SVGID_36_);
}
.st100 {
  clip-path: url(#SVGID_38_);
  fill: url(#SVGID_39_);
}
.st101 {
  clip-path: url(#SVGID_41_);
  fill: url(#SVGID_42_);
}
.st102 {
  clip-path: url(#SVGID_44_);
  fill: url(#SVGID_45_);
}
.st103 {
  clip-path: url(#SVGID_47_);
  fill: url(#SVGID_48_);
}
.st104 {
  clip-path: url(#SVGID_50_);
  fill: url(#SVGID_51_);
}
.st105 {
  clip-path: url(#SVGID_53_);
  fill: url(#SVGID_54_);
}
.st106 {
  clip-path: url(#SVGID_56_);
  fill: url(#SVGID_57_);
}
.st107 {
  clip-path: url(#SVGID_59_);
  fill: url(#SVGID_60_);
}
.st108 {
  clip-path: url(#SVGID_62_);
  fill: url(#SVGID_63_);
}
.st109 {
  clip-path: url(#SVGID_65_);
  fill: url(#SVGID_66_);
}
.st110 {
  clip-path: url(#SVGID_68_);
  fill: url(#SVGID_69_);
}
.st111 {
  clip-path: url(#SVGID_71_);
  fill: url(#SVGID_72_);
}
.st112 {
  clip-path: url(#SVGID_74_);
  fill: url(#SVGID_75_);
}
.st113 {
  clip-path: url(#SVGID_77_);
  fill: url(#SVGID_78_);
}
.st114 {
  clip-path: url(#SVGID_80_);
  fill: url(#SVGID_81_);
}
.st115 {
  clip-path: url(#SVGID_83_);
  fill: url(#SVGID_84_);
}
.st116 {
  clip-path: url(#SVGID_86_);
  fill: url(#SVGID_87_);
}
.st117 {
  clip-path: url(#SVGID_89_);
  fill: url(#SVGID_90_);
}
.st118 {
  clip-path: url(#SVGID_92_);
  fill: url(#SVGID_93_);
}
.st119 {
  fill: #d4d4d4;
}
.st120 {
  fill: #855525;
}
.st121 {
  clip-path: url(#SVGID_95_);
  fill: url(#SVGID_96_);
}
.st122 {
  clip-path: url(#SVGID_98_);
  fill: url(#SVGID_99_);
}
.st123 {
  clip-path: url(#SVGID_101_);
  fill: url(#SVGID_102_);
}
.st124 {
  clip-path: url(#SVGID_104_);
  fill: url(#SVGID_105_);
}
.st125 {
  clip-path: url(#SVGID_107_);
  fill: url(#SVGID_108_);
}
.st126 {
  clip-path: url(#SVGID_110_);
  fill: url(#SVGID_111_);
}
.st127 {
  clip-path: url(#SVGID_113_);
  fill: url(#SVGID_114_);
}
.st128 {
  clip-path: url(#SVGID_116_);
  fill: url(#SVGID_117_);
}
.st129 {
  clip-path: url(#SVGID_119_);
  fill: url(#SVGID_120_);
}
.st130 {
  clip-path: url(#SVGID_122_);
  fill: url(#SVGID_123_);
}
.st131 {
  clip-path: url(#SVGID_125_);
  fill: url(#SVGID_126_);
}
.st132 {
  clip-path: url(#SVGID_128_);
  fill: url(#SVGID_129_);
}
.st133 {
  clip-path: url(#SVGID_131_);
  fill: url(#SVGID_132_);
}
.st134 {
  clip-path: url(#SVGID_134_);
  fill: url(#SVGID_135_);
}
.st135 {
  clip-path: url(#SVGID_137_);
  fill: url(#SVGID_138_);
}
.st136 {
  clip-path: url(#SVGID_140_);
  fill: url(#SVGID_141_);
}
.st137 {
  clip-path: url(#SVGID_143_);
  fill: url(#SVGID_144_);
}
.st138 {
  clip-path: url(#SVGID_146_);
  fill: url(#SVGID_147_);
}
.st139 {
  clip-path: url(#SVGID_149_);
  fill: url(#SVGID_150_);
}
.st140 {
  clip-path: url(#SVGID_152_);
  fill: url(#SVGID_153_);
}
.st141 {
  clip-path: url(#SVGID_155_);
  fill: url(#SVGID_156_);
}
.st142 {
  clip-path: url(#SVGID_158_);
  fill: url(#SVGID_159_);
}
.st143 {
  clip-path: url(#SVGID_161_);
  fill: url(#SVGID_162_);
}
.st144 {
  clip-path: url(#SVGID_164_);
  fill: url(#SVGID_165_);
}
.st145 {
  clip-path: url(#SVGID_167_);
  fill: url(#SVGID_168_);
}
.st146 {
  clip-path: url(#SVGID_170_);
  fill: url(#SVGID_171_);
}
.st147 {
  clip-path: url(#SVGID_173_);
  fill: url(#SVGID_174_);
}
.st148 {
  clip-path: url(#SVGID_176_);
  fill: url(#SVGID_177_);
}
.st149 {
  clip-path: url(#SVGID_179_);
  fill: url(#SVGID_180_);
}
.st150 {
  clip-path: url(#SVGID_182_);
  fill: url(#SVGID_183_);
}
.st151 {
  clip-path: url(#SVGID_185_);
  fill: url(#SVGID_186_);
}
.st152 {
  clip-path: url(#SVGID_188_);
  fill: url(#SVGID_189_);
}
.st153 {
  clip-path: url(#SVGID_191_);
  fill: url(#SVGID_192_);
}
.st154 {
  clip-path: url(#SVGID_194_);
  fill: url(#SVGID_195_);
}
.st155 {
  clip-path: url(#SVGID_197_);
  fill: url(#SVGID_198_);
}
.st156 {
  clip-path: url(#SVGID_200_);
  fill: url(#SVGID_201_);
}
.st157 {
  clip-path: url(#SVGID_203_);
  fill: url(#SVGID_204_);
}
.st158 {
  clip-path: url(#SVGID_206_);
  fill: url(#SVGID_207_);
}
.st159 {
  clip-path: url(#SVGID_209_);
  fill: url(#SVGID_210_);
}
.st160 {
  clip-path: url(#SVGID_212_);
  fill: url(#SVGID_213_);
}
.st161 {
  clip-path: url(#SVGID_215_);
  fill: url(#SVGID_216_);
}
.st162 {
  clip-path: url(#SVGID_218_);
  fill: url(#SVGID_219_);
}
.st163 {
  clip-path: url(#SVGID_221_);
  fill: url(#SVGID_222_);
}
.st164 {
  clip-path: url(#SVGID_224_);
  fill: url(#SVGID_225_);
}
.st165 {
  clip-path: url(#SVGID_227_);
  fill: url(#SVGID_228_);
}
.st166 {
  clip-path: url(#SVGID_230_);
  fill: url(#SVGID_231_);
}
.st167 {
  clip-path: url(#SVGID_233_);
  fill: url(#SVGID_234_);
}
.st168 {
  clip-path: url(#SVGID_236_);
  fill: url(#SVGID_237_);
}
.st169 {
  clip-path: url(#SVGID_239_);
  fill: url(#SVGID_240_);
}
.st170 {
  clip-path: url(#SVGID_242_);
  fill: url(#SVGID_243_);
}
.st171 {
  clip-path: url(#SVGID_245_);
  fill: url(#SVGID_246_);
}
.st172 {
  clip-path: url(#SVGID_248_);
  fill: url(#SVGID_249_);
}
.st173 {
  clip-path: url(#SVGID_251_);
  fill: url(#SVGID_252_);
}
.st174 {
  clip-path: url(#SVGID_254_);
  fill: url(#SVGID_255_);
}
.st175 {
  clip-path: url(#SVGID_257_);
  fill: url(#SVGID_258_);
}
.st176 {
  clip-path: url(#SVGID_260_);
  fill: url(#SVGID_261_);
}
.st177 {
  clip-path: url(#SVGID_263_);
  fill: url(#SVGID_264_);
}
.st178 {
  clip-path: url(#SVGID_266_);
  fill: url(#SVGID_267_);
}
.st179 {
  clip-path: url(#SVGID_269_);
  fill: url(#SVGID_270_);
}
.st180 {
  clip-path: url(#SVGID_272_);
  fill: url(#SVGID_273_);
}
.st181 {
  fill: none;
}
.st182 {
  font-family: "Poppins";
}
.st183 {
  font-size: 10px;
  font-weight: bold;
}
.st184 {
  fill: #6fd1d1;
}
.st185 {
  fill: #00bee9;
}
.st186 {
  fill: #61c7cb;
  stroke: #e3e3e3;
  stroke-miterlimit: 10;
}
.st187 {
  font-size: 19.7231px;
}
.st188 {
  fill: #ffffff;
  stroke: #e3e3e3;
  stroke-miterlimit: 10;
}
.st189 {
  fill: #383874;
  stroke: #e3e3e3;
  stroke-miterlimit: 10;
}
.st190 {
  fill: #f9f9f9;
}
.st191 {
  font-size: 20px;
}
.st192 {
  font-size: 18px;
  font-weight: bold;
}
.st194 {
  fill: url(#SVGID_274_);
}
.st195 {
  fill: url(#SVGID_275_);
}
.st196 {
  fill: url(#SVGID_276_);
}
.st197 {
  fill: #6a6666;
}
.st200 {
  fill: #ffffff;
}
.st201 {
  fill: #0c0c0c;
}
.st202 {
  fill: none;
  stroke: #ffffff;
  stroke-miterlimit: 10;
}
.st203 {
  fill: none;
  stroke: #000000;
  stroke-miterlimit: 10;
}
.blink {
  animation: blinker 1s infinite;
}
@keyframes blinker {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
